export default {
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "properties": {
                "adcode": 410100,
                "name": "郑州市",
                "center": [
                    113.665412,
                    34.757975
                ],
                "centroid": [
                    113.477391,
                    34.626256
                ],
                "childrenNum": 12,
                "level": "city",
                "parent": {
                    "adcode": 410000
                },
                "subFeatureIndex": 0,
                "acroutes": [
                    100000,
                    410000
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                114.22071,
                                34.919066
                            ],
                            [
                                114.208505,
                                34.926602
                            ],
                            [
                                114.200704,
                                34.939504
                            ],
                            [
                                114.172834,
                                34.931871
                            ],
                            [
                                114.160566,
                                34.933496
                            ],
                            [
                                114.120491,
                                34.956638
                            ],
                            [
                                114.101869,
                                34.954768
                            ],
                            [
                                114.080542,
                                34.944527
                            ],
                            [
                                114.051225,
                                34.944527
                            ],
                            [
                                114.028451,
                                34.959346
                            ],
                            [
                                114.018385,
                                34.958608
                            ],
                            [
                                113.985293,
                                34.928276
                            ],
                            [
                                113.973654,
                                34.910447
                            ],
                            [
                                113.953585,
                                34.898082
                            ],
                            [
                                113.905331,
                                34.901333
                            ],
                            [
                                113.870163,
                                34.885666
                            ],
                            [
                                113.826062,
                                34.877683
                            ],
                            [
                                113.800456,
                                34.87995
                            ],
                            [
                                113.78649,
                                34.890445
                            ],
                            [
                                113.777116,
                                34.905028
                            ],
                            [
                                113.766106,
                                34.91488
                            ],
                            [
                                113.749057,
                                34.919017
                            ],
                            [
                                113.725528,
                                34.917392
                            ],
                            [
                                113.716846,
                                34.913402
                            ],
                            [
                                113.684824,
                                34.906358
                            ],
                            [
                                113.670731,
                                34.910299
                            ],
                            [
                                113.665069,
                                34.918525
                            ],
                            [
                                113.650348,
                                34.928769
                            ],
                            [
                                113.631348,
                                34.929311
                            ],
                            [
                                113.592091,
                                34.933743
                            ],
                            [
                                113.57479,
                                34.950583
                            ],
                            [
                                113.552582,
                                34.965155
                            ],
                            [
                                113.543271,
                                34.96801
                            ],
                            [
                                113.515086,
                                34.965992
                            ],
                            [
                                113.495835,
                                34.959937
                            ],
                            [
                                113.477339,
                                34.957278
                            ],
                            [
                                113.449658,
                                34.960232
                            ],
                            [
                                113.429463,
                                34.964761
                            ],
                            [
                                113.427198,
                                34.983563
                            ],
                            [
                                113.407821,
                                34.989518
                            ],
                            [
                                113.37561,
                                34.98002
                            ],
                            [
                                113.362587,
                                34.970323
                            ],
                            [
                                113.343462,
                                34.950533
                            ],
                            [
                                113.333018,
                                34.944871
                            ],
                            [
                                113.315277,
                                34.942212
                            ],
                            [
                                113.28986,
                                34.952601
                            ],
                            [
                                113.260543,
                                34.953586
                            ],
                            [
                                113.243934,
                                34.946201
                            ],
                            [
                                113.239342,
                                34.939504
                            ],
                            [
                                113.236951,
                                34.925174
                            ],
                            [
                                113.227703,
                                34.908427
                            ],
                            [
                                113.197631,
                                34.900299
                            ],
                            [
                                113.179512,
                                34.893697
                            ],
                            [
                                113.139815,
                                34.884631
                            ],
                            [
                                113.14793,
                                34.856096
                            ],
                            [
                                113.119431,
                                34.853977
                            ],
                            [
                                113.107666,
                                34.844709
                            ],
                            [
                                113.06023,
                                34.83756
                            ],
                            [
                                113.039595,
                                34.841948
                            ],
                            [
                                113.025063,
                                34.854913
                            ],
                            [
                                113.004364,
                                34.864081
                            ],
                            [
                                112.992851,
                                34.863539
                            ],
                            [
                                112.989077,
                                34.856343
                            ],
                            [
                                112.976117,
                                34.847765
                            ],
                            [
                                112.943025,
                                34.831102
                            ],
                            [
                                112.938181,
                                34.831595
                            ],
                            [
                                112.914148,
                                34.84747
                            ],
                            [
                                112.902321,
                                34.852301
                            ],
                            [
                                112.884516,
                                34.853089
                            ],
                            [
                                112.879106,
                                34.849688
                            ],
                            [
                                112.873192,
                                34.832827
                            ],
                            [
                                112.866461,
                                34.829524
                            ],
                            [
                                112.853501,
                                34.810736
                            ],
                            [
                                112.838653,
                                34.812116
                            ],
                            [
                                112.827266,
                                34.819218
                            ],
                            [
                                112.814118,
                                34.811475
                            ],
                            [
                                112.80984,
                                34.7951
                            ],
                            [
                                112.810595,
                                34.784938
                            ],
                            [
                                112.817263,
                                34.778278
                            ],
                            [
                                112.837144,
                                34.782915
                            ],
                            [
                                112.846329,
                                34.780054
                            ],
                            [
                                112.875017,
                                34.779659
                            ],
                            [
                                112.887914,
                                34.782718
                            ],
                            [
                                112.89993,
                                34.780596
                            ],
                            [
                                112.909367,
                                34.771123
                            ],
                            [
                                112.908486,
                                34.757405
                            ],
                            [
                                112.902258,
                                34.753161
                            ],
                            [
                                112.909933,
                                34.737465
                            ],
                            [
                                112.939502,
                                34.72384
                            ],
                            [
                                112.931764,
                                34.711694
                            ],
                            [
                                112.91635,
                                34.710953
                            ],
                            [
                                112.901692,
                                34.693521
                            ],
                            [
                                112.893827,
                                34.694953
                            ],
                            [
                                112.879735,
                                34.705077
                            ],
                            [
                                112.867782,
                                34.708089
                            ],
                            [
                                112.8496,
                                34.699694
                            ],
                            [
                                112.830223,
                                34.694163
                            ],
                            [
                                112.829217,
                                34.683346
                            ],
                            [
                                112.835885,
                                34.667785
                            ],
                            [
                                112.831041,
                                34.656669
                            ],
                            [
                                112.847147,
                                34.640362
                            ],
                            [
                                112.841799,
                                34.628648
                            ],
                            [
                                112.825001,
                                34.628698
                            ],
                            [
                                112.82475,
                                34.625188
                            ],
                            [
                                112.840226,
                                34.623161
                            ],
                            [
                                112.845574,
                                34.609913
                            ],
                            [
                                112.839408,
                                34.596514
                            ],
                            [
                                112.846329,
                                34.58885
                            ],
                            [
                                112.862183,
                                34.590284
                            ],
                            [
                                112.864133,
                                34.580146
                            ],
                            [
                                112.877722,
                                34.567731
                            ],
                            [
                                112.87898,
                                34.560015
                            ],
                            [
                                112.890682,
                                34.547102
                            ],
                            [
                                112.910751,
                                34.545173
                            ],
                            [
                                112.929562,
                                34.547548
                            ],
                            [
                                112.952273,
                                34.547647
                            ],
                            [
                                112.967749,
                                34.541264
                            ],
                            [
                                112.984736,
                                34.539038
                            ],
                            [
                                112.976683,
                                34.53117
                            ],
                            [
                                112.947995,
                                34.531467
                            ],
                            [
                                112.929813,
                                34.526023
                            ],
                            [
                                112.925598,
                                34.509789
                            ],
                            [
                                112.927297,
                                34.499691
                            ],
                            [
                                112.920125,
                                34.482016
                            ],
                            [
                                112.922956,
                                34.47657
                            ],
                            [
                                112.905215,
                                34.468201
                            ],
                            [
                                112.896155,
                                34.475827
                            ],
                            [
                                112.862371,
                                34.473648
                            ],
                            [
                                112.856017,
                                34.478402
                            ],
                            [
                                112.838024,
                                34.477164
                            ],
                            [
                                112.806002,
                                34.479243
                            ],
                            [
                                112.798012,
                                34.487166
                            ],
                            [
                                112.774609,
                                34.500137
                            ],
                            [
                                112.767374,
                                34.49479
                            ],
                            [
                                112.740384,
                                34.491077
                            ],
                            [
                                112.744285,
                                34.4683
                            ],
                            [
                                112.741894,
                                34.433973
                            ],
                            [
                                112.736673,
                                34.422578
                            ],
                            [
                                112.729626,
                                34.416978
                            ],
                            [
                                112.735918,
                                34.404242
                            ],
                            [
                                112.733653,
                                34.39309
                            ],
                            [
                                112.72409,
                                34.388877
                            ],
                            [
                                112.721825,
                                34.380152
                            ],
                            [
                                112.730318,
                                34.377426
                            ],
                            [
                                112.728117,
                                34.361163
                            ],
                            [
                                112.732898,
                                34.350898
                            ],
                            [
                                112.756805,
                                34.357394
                            ],
                            [
                                112.760076,
                                34.346584
                            ],
                            [
                                112.776622,
                                34.345046
                            ],
                            [
                                112.787002,
                                34.343261
                            ],
                            [
                                112.788953,
                                34.331158
                            ],
                            [
                                112.81223,
                                34.340037
                            ],
                            [
                                112.824184,
                                34.33344
                            ],
                            [
                                112.83318,
                                34.333638
                            ],
                            [
                                112.854633,
                                34.316325
                            ],
                            [
                                112.842114,
                                34.311612
                            ],
                            [
                                112.84117,
                                34.297818
                            ],
                            [
                                112.856458,
                                34.302185
                            ],
                            [
                                112.87357,
                                34.298016
                            ],
                            [
                                112.884516,
                                34.30144
                            ],
                            [
                                112.91245,
                                34.293749
                            ],
                            [
                                112.936293,
                                34.295535
                            ],
                            [
                                112.954097,
                                34.302135
                            ],
                            [
                                112.960829,
                                34.297867
                            ],
                            [
                                112.992977,
                                34.296478
                            ],
                            [
                                113.013235,
                                34.300398
                            ],
                            [
                                113.020847,
                                34.290424
                            ],
                            [
                                113.027642,
                                34.289282
                            ],
                            [
                                113.037142,
                                34.280299
                            ],
                            [
                                113.059476,
                                34.280944
                            ],
                            [
                                113.075518,
                                34.276527
                            ],
                            [
                                113.082439,
                                34.26645
                            ],
                            [
                                113.097726,
                                34.26223
                            ],
                            [
                                113.109365,
                                34.263471
                            ],
                            [
                                113.142583,
                                34.272804
                            ],
                            [
                                113.15202,
                                34.266351
                            ],
                            [
                                113.175297,
                                34.281639
                            ],
                            [
                                113.184356,
                                34.290225
                            ],
                            [
                                113.18379,
                                34.295634
                            ],
                            [
                                113.196436,
                                34.312257
                            ],
                            [
                                113.210276,
                                34.312009
                            ],
                            [
                                113.223362,
                                34.325057
                            ],
                            [
                                113.224557,
                                34.33473
                            ],
                            [
                                113.235567,
                                34.339045
                            ],
                            [
                                113.267904,
                                34.337805
                            ],
                            [
                                113.276334,
                                34.342814
                            ],
                            [
                                113.276586,
                                34.351444
                            ],
                            [
                                113.314648,
                                34.352287
                            ],
                            [
                                113.314019,
                                34.373856
                            ],
                            [
                                113.320436,
                                34.383375
                            ],
                            [
                                113.315969,
                                34.391157
                            ],
                            [
                                113.32528,
                                34.404986
                            ],
                            [
                                113.348809,
                                34.404738
                            ],
                            [
                                113.353968,
                                34.396411
                            ],
                            [
                                113.370388,
                                34.389918
                            ],
                            [
                                113.366991,
                                34.379805
                            ],
                            [
                                113.389828,
                                34.375988
                            ],
                            [
                                113.401655,
                                34.377525
                            ],
                            [
                                113.414867,
                                34.374947
                            ],
                            [
                                113.406751,
                                34.355213
                            ],
                            [
                                113.414175,
                                34.349361
                            ],
                            [
                                113.429085,
                                34.350303
                            ],
                            [
                                113.459409,
                                34.334432
                            ],
                            [
                                113.471425,
                                34.330811
                            ],
                            [
                                113.482875,
                                34.342864
                            ],
                            [
                                113.498729,
                                34.338598
                            ],
                            [
                                113.510871,
                                34.342715
                            ],
                            [
                                113.518169,
                                34.335771
                            ],
                            [
                                113.516848,
                                34.328579
                            ],
                            [
                                113.529619,
                                34.317913
                            ],
                            [
                                113.556608,
                                34.311513
                            ],
                            [
                                113.566737,
                                34.318359
                            ],
                            [
                                113.579697,
                                34.319897
                            ],
                            [
                                113.600836,
                                34.313299
                            ],
                            [
                                113.608951,
                                34.3132
                            ],
                            [
                                113.624805,
                                34.303375
                            ],
                            [
                                113.634494,
                                34.290026
                            ],
                            [
                                113.643994,
                                34.288488
                            ],
                            [
                                113.658589,
                                34.275037
                            ],
                            [
                                113.669851,
                                34.275385
                            ],
                            [
                                113.679728,
                                34.282532
                            ],
                            [
                                113.70332,
                                34.276725
                            ],
                            [
                                113.7003,
                                34.289381
                            ],
                            [
                                113.71326,
                                34.29092
                            ],
                            [
                                113.713386,
                                34.301391
                            ],
                            [
                                113.727227,
                                34.305757
                            ],
                            [
                                113.736852,
                                34.317863
                            ],
                            [
                                113.756732,
                                34.313795
                            ],
                            [
                                113.777242,
                                34.314589
                            ],
                            [
                                113.793159,
                                34.328083
                            ],
                            [
                                113.791208,
                                34.331803
                            ],
                            [
                                113.803791,
                                34.33721
                            ],
                            [
                                113.832353,
                                34.32342
                            ],
                            [
                                113.848584,
                                34.322725
                            ],
                            [
                                113.85022,
                                34.32719
                            ],
                            [
                                113.880481,
                                34.32972
                            ],
                            [
                                113.885451,
                                34.327785
                            ],
                            [
                                113.888093,
                                34.348369
                            ],
                            [
                                113.879978,
                                34.356056
                            ],
                            [
                                113.885199,
                                34.370485
                            ],
                            [
                                113.878531,
                                34.394577
                            ],
                            [
                                113.878153,
                                34.411478
                            ],
                            [
                                113.891616,
                                34.437342
                            ],
                            [
                                113.903507,
                                34.454185
                            ],
                            [
                                113.912126,
                                34.452352
                            ],
                            [
                                113.915586,
                                34.444922
                            ],
                            [
                                113.929993,
                                34.443485
                            ],
                            [
                                113.938108,
                                34.454729
                            ],
                            [
                                113.948929,
                                34.452699
                            ],
                            [
                                113.948615,
                                34.435063
                            ],
                            [
                                113.968495,
                                34.439324
                            ],
                            [
                                113.990326,
                                34.435707
                            ],
                            [
                                114.006557,
                                34.439225
                            ],
                            [
                                114.019894,
                                34.445368
                            ],
                            [
                                114.021719,
                                34.458989
                            ],
                            [
                                114.01851,
                                34.46721
                            ],
                            [
                                114.008256,
                                34.470082
                            ],
                            [
                                114.009577,
                                34.480135
                            ],
                            [
                                114.0226,
                                34.488552
                            ],
                            [
                                114.035119,
                                34.503998
                            ],
                            [
                                114.062486,
                                34.490532
                            ],
                            [
                                114.07035,
                                34.481472
                            ],
                            [
                                114.083373,
                                34.480927
                            ],
                            [
                                114.094383,
                                34.492265
                            ],
                            [
                                114.093942,
                                34.50182
                            ],
                            [
                                114.100296,
                                34.535178
                            ],
                            [
                                114.107217,
                                34.557887
                            ],
                            [
                                114.118478,
                                34.570155
                            ],
                            [
                                114.129802,
                                34.575348
                            ],
                            [
                                114.127852,
                                34.584943
                            ],
                            [
                                114.133451,
                                34.591025
                            ],
                            [
                                114.136848,
                                34.605711
                            ],
                            [
                                114.125461,
                                34.607886
                            ],
                            [
                                114.127726,
                                34.61718
                            ],
                            [
                                114.14553,
                                34.61456
                            ],
                            [
                                114.145153,
                                34.604277
                            ],
                            [
                                114.15459,
                                34.60576
                            ],
                            [
                                114.15157,
                                34.618268
                            ],
                            [
                                114.157547,
                                34.625979
                            ],
                            [
                                114.150375,
                                34.656669
                            ],
                            [
                                114.160441,
                                34.665611
                            ],
                            [
                                114.157547,
                                34.686507
                            ],
                            [
                                114.158113,
                                34.704336
                            ],
                            [
                                114.141189,
                                34.7191
                            ],
                            [
                                114.138484,
                                34.73475
                            ],
                            [
                                114.158364,
                                34.759379
                            ],
                            [
                                114.172331,
                                34.768311
                            ],
                            [
                                114.161762,
                                34.781238
                            ],
                            [
                                114.134143,
                                34.802154
                            ],
                            [
                                114.122504,
                                34.81833
                            ],
                            [
                                114.133703,
                                34.825628
                            ],
                            [
                                114.162517,
                                34.828883
                            ],
                            [
                                114.185354,
                                34.825628
                            ],
                            [
                                114.199824,
                                34.832729
                            ],
                            [
                                114.211085,
                                34.860877
                            ],
                            [
                                114.220522,
                                34.906801
                            ],
                            [
                                114.22071,
                                34.919066
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 410200,
                "name": "开封市",
                "center": [
                    114.341447,
                    34.797049
                ],
                "centroid": [
                    114.541763,
                    34.604497
                ],
                "childrenNum": 9,
                "level": "city",
                "parent": {
                    "adcode": 410000
                },
                "subFeatureIndex": 1,
                "acroutes": [
                    100000,
                    410000
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                113.885451,
                                34.327785
                            ],
                            [
                                113.894573,
                                34.323767
                            ],
                            [
                                113.899229,
                                34.315879
                            ],
                            [
                                113.896083,
                                34.303375
                            ],
                            [
                                113.904702,
                                34.294543
                            ],
                            [
                                113.916278,
                                34.301688
                            ],
                            [
                                113.934271,
                                34.304864
                            ],
                            [
                                113.937354,
                                34.298612
                            ],
                            [
                                113.964406,
                                34.292954
                            ],
                            [
                                113.96472,
                                34.283128
                            ],
                            [
                                113.972459,
                                34.283426
                            ],
                            [
                                113.977303,
                                34.275583
                            ],
                            [
                                113.992905,
                                34.27335
                            ],
                            [
                                113.990577,
                                34.261138
                            ],
                            [
                                114.000266,
                                34.263471
                            ],
                            [
                                114.00316,
                                34.252549
                            ],
                            [
                                114.011275,
                                34.242022
                            ],
                            [
                                114.041033,
                                34.237851
                            ],
                            [
                                114.050847,
                                34.247137
                            ],
                            [
                                114.058837,
                                34.244753
                            ],
                            [
                                114.068589,
                                34.250265
                            ],
                            [
                                114.076453,
                                34.239639
                            ],
                            [
                                114.081926,
                                34.24952
                            ],
                            [
                                114.098661,
                                34.241923
                            ],
                            [
                                114.10816,
                                34.228813
                            ],
                            [
                                114.102058,
                                34.224343
                            ],
                            [
                                114.108475,
                                34.218929
                            ],
                            [
                                114.109544,
                                34.206958
                            ],
                            [
                                114.122882,
                                34.204176
                            ],
                            [
                                114.129299,
                                34.198214
                            ],
                            [
                                114.155345,
                                34.202039
                            ],
                            [
                                114.160503,
                                34.213564
                            ],
                            [
                                114.198314,
                                34.217737
                            ],
                            [
                                114.202906,
                                34.234623
                            ],
                            [
                                114.210267,
                                34.241228
                            ],
                            [
                                114.246442,
                                34.240433
                            ],
                            [
                                114.259905,
                                34.251854
                            ],
                            [
                                114.267517,
                                34.256968
                            ],
                            [
                                114.274626,
                                34.274889
                            ],
                            [
                                114.287901,
                                34.276527
                            ],
                            [
                                114.301175,
                                34.26774
                            ],
                            [
                                114.328857,
                                34.267294
                            ],
                            [
                                114.344207,
                                34.251804
                            ],
                            [
                                114.356412,
                                34.247186
                            ],
                            [
                                114.385729,
                                34.24386
                            ],
                            [
                                114.405798,
                                34.248031
                            ],
                            [
                                114.417689,
                                34.265308
                            ],
                            [
                                114.434927,
                                34.267145
                            ],
                            [
                                114.440652,
                                34.270719
                            ],
                            [
                                114.455688,
                                34.294096
                            ],
                            [
                                114.442539,
                                34.300696
                            ],
                            [
                                114.430649,
                                34.302284
                            ],
                            [
                                114.424546,
                                34.309032
                            ],
                            [
                                114.434486,
                                34.313894
                            ],
                            [
                                114.436059,
                                34.330265
                            ],
                            [
                                114.427692,
                                34.333837
                            ],
                            [
                                114.439897,
                                34.336366
                            ],
                            [
                                114.438576,
                                34.328033
                            ],
                            [
                                114.452857,
                                34.319997
                            ],
                            [
                                114.46179,
                                34.319947
                            ],
                            [
                                114.462042,
                                34.330166
                            ],
                            [
                                114.479343,
                                34.32962
                            ],
                            [
                                114.485949,
                                34.325057
                            ],
                            [
                                114.493876,
                                34.31191
                            ],
                            [
                                114.509855,
                                34.309727
                            ],
                            [
                                114.519355,
                                34.313448
                            ],
                            [
                                114.524703,
                                34.306253
                            ],
                            [
                                114.528603,
                                34.282234
                            ],
                            [
                                114.551629,
                                34.284964
                            ],
                            [
                                114.551189,
                                34.272059
                            ],
                            [
                                114.556662,
                                34.267989
                            ],
                            [
                                114.58988,
                                34.273747
                            ],
                            [
                                114.602085,
                                34.271017
                            ],
                            [
                                114.611459,
                                34.261088
                            ],
                            [
                                114.634044,
                                34.261883
                            ],
                            [
                                114.647319,
                                34.250315
                            ],
                            [
                                114.667514,
                                34.250265
                            ],
                            [
                                114.679341,
                                34.244307
                            ],
                            [
                                114.702241,
                                34.244505
                            ],
                            [
                                114.71388,
                                34.241327
                            ],
                            [
                                114.723946,
                                34.228018
                            ],
                            [
                                114.730426,
                                34.225237
                            ],
                            [
                                114.752697,
                                34.23363
                            ],
                            [
                                114.758736,
                                34.238397
                            ],
                            [
                                114.76465,
                                34.254436
                            ],
                            [
                                114.781196,
                                34.255627
                            ],
                            [
                                114.788242,
                                34.261138
                            ],
                            [
                                114.812778,
                                34.259003
                            ],
                            [
                                114.8314,
                                34.268138
                            ],
                            [
                                114.832847,
                                34.281937
                            ],
                            [
                                114.845492,
                                34.280696
                            ],
                            [
                                114.867763,
                                34.271066
                            ],
                            [
                                114.896514,
                                34.265804
                            ],
                            [
                                114.901988,
                                34.284567
                            ],
                            [
                                114.882674,
                                34.301192
                            ],
                            [
                                114.870783,
                                34.305608
                            ],
                            [
                                114.862353,
                                34.329174
                            ],
                            [
                                114.855558,
                                34.33473
                            ],
                            [
                                114.861724,
                                34.367014
                            ],
                            [
                                114.879025,
                                34.370683
                            ],
                            [
                                114.888461,
                                34.383771
                            ],
                            [
                                114.875061,
                                34.390612
                            ],
                            [
                                114.874432,
                                34.396411
                            ],
                            [
                                114.851658,
                                34.399534
                            ],
                            [
                                114.848575,
                                34.409942
                            ],
                            [
                                114.854615,
                                34.410933
                            ],
                            [
                                114.852413,
                                34.42887
                            ],
                            [
                                114.864806,
                                34.433726
                            ],
                            [
                                114.856502,
                                34.436599
                            ],
                            [
                                114.858893,
                                34.451906
                            ],
                            [
                                114.865624,
                                34.462902
                            ],
                            [
                                114.872356,
                                34.454085
                            ],
                            [
                                114.880786,
                                34.450519
                            ],
                            [
                                114.886322,
                                34.461317
                            ],
                            [
                                114.896451,
                                34.46102
                            ],
                            [
                                114.904001,
                                34.467606
                            ],
                            [
                                114.912305,
                                34.483601
                            ],
                            [
                                114.918596,
                                34.484938
                            ],
                            [
                                114.922371,
                                34.498206
                            ],
                            [
                                114.9096,
                                34.495137
                            ],
                            [
                                114.917653,
                                34.511571
                            ],
                            [
                                114.913752,
                                34.518154
                            ],
                            [
                                114.920673,
                                34.531417
                            ],
                            [
                                114.91111,
                                34.534782
                            ],
                            [
                                114.917841,
                                34.541957
                            ],
                            [
                                114.91501,
                                34.548686
                            ],
                            [
                                114.906517,
                                34.547647
                            ],
                            [
                                114.907398,
                                34.573865
                            ],
                            [
                                114.904882,
                                34.586179
                            ],
                            [
                                114.897018,
                                34.602596
                            ],
                            [
                                114.90117,
                                34.613769
                            ],
                            [
                                114.898339,
                                34.631762
                            ],
                            [
                                114.901673,
                                34.645303
                            ],
                            [
                                114.893494,
                                34.652469
                            ],
                            [
                                114.896451,
                                34.661363
                            ],
                            [
                                114.905825,
                                34.666896
                            ],
                            [
                                114.926649,
                                34.668625
                            ],
                            [
                                114.935771,
                                34.672182
                            ],
                            [
                                114.936652,
                                34.681914
                            ],
                            [
                                114.931682,
                                34.686804
                            ],
                            [
                                114.90765,
                                34.697916
                            ],
                            [
                                114.891418,
                                34.698213
                            ],
                            [
                                114.8677,
                                34.688038
                            ],
                            [
                                114.858012,
                                34.692286
                            ],
                            [
                                114.855558,
                                34.710904
                            ],
                            [
                                114.840648,
                                34.715101
                            ],
                            [
                                114.858767,
                                34.734256
                            ],
                            [
                                114.859333,
                                34.740328
                            ],
                            [
                                114.835678,
                                34.746893
                            ],
                            [
                                114.82838,
                                34.755332
                            ],
                            [
                                114.829009,
                                34.764314
                            ],
                            [
                                114.835615,
                                34.767472
                            ],
                            [
                                114.86682,
                                34.769199
                            ],
                            [
                                114.867386,
                                34.775515
                            ],
                            [
                                114.877578,
                                34.775219
                            ],
                            [
                                114.894375,
                                34.762833
                            ],
                            [
                                114.922874,
                                34.748423
                            ],
                            [
                                114.936841,
                                34.747041
                            ],
                            [
                                114.966913,
                                34.761106
                            ],
                            [
                                114.980502,
                                34.760909
                            ],
                            [
                                114.988366,
                                34.76456
                            ],
                            [
                                115.001012,
                                34.760662
                            ],
                            [
                                115.030329,
                                34.772455
                            ],
                            [
                                115.038885,
                                34.773985
                            ],
                            [
                                115.104125,
                                34.772357
                            ],
                            [
                                115.119601,
                                34.788638
                            ],
                            [
                                115.140048,
                                34.793324
                            ],
                            [
                                115.154455,
                                34.78178
                            ],
                            [
                                115.163891,
                                34.783063
                            ],
                            [
                                115.17553,
                                34.790463
                            ],
                            [
                                115.17899,
                                34.800279
                            ],
                            [
                                115.198367,
                                34.795297
                            ],
                            [
                                115.202897,
                                34.805656
                            ],
                            [
                                115.24832,
                                34.798109
                            ],
                            [
                                115.253919,
                                34.805014
                            ],
                            [
                                115.242658,
                                34.813497
                            ],
                            [
                                115.256561,
                                34.81187
                            ],
                            [
                                115.267256,
                                34.831249
                            ],
                            [
                                115.256058,
                                34.845301
                            ],
                            [
                                115.243475,
                                34.850181
                            ],
                            [
                                115.239323,
                                34.874677
                            ],
                            [
                                115.24077,
                                34.883842
                            ],
                            [
                                115.2492,
                                34.894534
                            ],
                            [
                                115.252157,
                                34.906604
                            ],
                            [
                                115.239323,
                                34.911826
                            ],
                            [
                                115.204973,
                                34.914239
                            ],
                            [
                                115.202708,
                                34.925617
                            ],
                            [
                                115.211768,
                                34.943345
                            ],
                            [
                                115.222148,
                                34.945561
                            ],
                            [
                                115.219128,
                                34.960626
                            ],
                            [
                                115.208245,
                                34.958312
                            ],
                            [
                                115.201639,
                                34.950977
                            ],
                            [
                                115.175027,
                                34.962497
                            ],
                            [
                                115.156908,
                                34.958017
                            ],
                            [
                                115.157223,
                                34.966976
                            ],
                            [
                                115.146528,
                                34.980118
                            ],
                            [
                                115.131177,
                                34.983613
                            ],
                            [
                                115.133002,
                                34.999655
                            ],
                            [
                                115.128094,
                                35.004379
                            ],
                            [
                                115.106138,
                                35.000787
                            ],
                            [
                                115.074996,
                                35.000393
                            ],
                            [
                                115.051656,
                                34.985975
                            ],
                            [
                                115.037564,
                                34.981644
                            ],
                            [
                                115.024918,
                                34.971849
                            ],
                            [
                                115.016048,
                                34.977362
                            ],
                            [
                                115.008121,
                                34.988485
                            ],
                            [
                                114.95087,
                                34.989813
                            ],
                            [
                                114.934765,
                                34.980709
                            ],
                            [
                                114.923818,
                                34.968748
                            ],
                            [
                                114.914004,
                                34.977903
                            ],
                            [
                                114.907964,
                                34.98937
                            ],
                            [
                                114.889657,
                                34.993996
                            ],
                            [
                                114.880346,
                                35.003493
                            ],
                            [
                                114.884435,
                                35.021893
                            ],
                            [
                                114.869965,
                                35.024451
                            ],
                            [
                                114.859333,
                                35.002656
                            ],
                            [
                                114.827122,
                                35.010135
                            ],
                            [
                                114.824668,
                                35.0123
                            ],
                            [
                                114.815861,
                                35.014022
                            ],
                            [
                                114.800384,
                                35.006691
                            ],
                            [
                                114.765908,
                                34.977707
                            ],
                            [
                                114.756597,
                                34.97559
                            ],
                            [
                                114.741435,
                                34.960675
                            ],
                            [
                                114.74175,
                                34.948712
                            ],
                            [
                                114.768173,
                                34.927882
                            ],
                            [
                                114.778994,
                                34.916751
                            ],
                            [
                                114.774779,
                                34.901382
                            ],
                            [
                                114.76119,
                                34.89148
                            ],
                            [
                                114.733886,
                                34.888474
                            ],
                            [
                                114.724323,
                                34.885222
                            ],
                            [
                                114.709161,
                                34.89212
                            ],
                            [
                                114.695572,
                                34.894387
                            ],
                            [
                                114.679593,
                                34.909018
                            ],
                            [
                                114.660279,
                                34.898722
                            ],
                            [
                                114.633981,
                                34.905225
                            ],
                            [
                                114.586608,
                                34.912466
                            ],
                            [
                                114.557165,
                                34.905521
                            ],
                            [
                                114.540682,
                                34.899264
                            ],
                            [
                                114.513378,
                                34.895273
                            ],
                            [
                                114.442728,
                                34.914486
                            ],
                            [
                                114.417815,
                                34.930788
                            ],
                            [
                                114.40064,
                                34.939504
                            ],
                            [
                                114.383024,
                                34.936894
                            ],
                            [
                                114.367233,
                                34.918968
                            ],
                            [
                                114.350499,
                                34.908082
                            ],
                            [
                                114.340118,
                                34.907146
                            ],
                            [
                                114.284441,
                                34.90823
                            ],
                            [
                                114.243988,
                                34.905126
                            ],
                            [
                                114.226624,
                                34.913156
                            ],
                            [
                                114.22071,
                                34.919066
                            ],
                            [
                                114.220522,
                                34.906801
                            ],
                            [
                                114.211085,
                                34.860877
                            ],
                            [
                                114.199824,
                                34.832729
                            ],
                            [
                                114.185354,
                                34.825628
                            ],
                            [
                                114.162517,
                                34.828883
                            ],
                            [
                                114.133703,
                                34.825628
                            ],
                            [
                                114.122504,
                                34.81833
                            ],
                            [
                                114.134143,
                                34.802154
                            ],
                            [
                                114.161762,
                                34.781238
                            ],
                            [
                                114.172331,
                                34.768311
                            ],
                            [
                                114.158364,
                                34.759379
                            ],
                            [
                                114.138484,
                                34.73475
                            ],
                            [
                                114.141189,
                                34.7191
                            ],
                            [
                                114.158113,
                                34.704336
                            ],
                            [
                                114.157547,
                                34.686507
                            ],
                            [
                                114.160441,
                                34.665611
                            ],
                            [
                                114.150375,
                                34.656669
                            ],
                            [
                                114.157547,
                                34.625979
                            ],
                            [
                                114.15157,
                                34.618268
                            ],
                            [
                                114.15459,
                                34.60576
                            ],
                            [
                                114.145153,
                                34.604277
                            ],
                            [
                                114.14553,
                                34.61456
                            ],
                            [
                                114.127726,
                                34.61718
                            ],
                            [
                                114.125461,
                                34.607886
                            ],
                            [
                                114.136848,
                                34.605711
                            ],
                            [
                                114.133451,
                                34.591025
                            ],
                            [
                                114.127852,
                                34.584943
                            ],
                            [
                                114.129802,
                                34.575348
                            ],
                            [
                                114.118478,
                                34.570155
                            ],
                            [
                                114.107217,
                                34.557887
                            ],
                            [
                                114.100296,
                                34.535178
                            ],
                            [
                                114.093942,
                                34.50182
                            ],
                            [
                                114.094383,
                                34.492265
                            ],
                            [
                                114.083373,
                                34.480927
                            ],
                            [
                                114.07035,
                                34.481472
                            ],
                            [
                                114.062486,
                                34.490532
                            ],
                            [
                                114.035119,
                                34.503998
                            ],
                            [
                                114.0226,
                                34.488552
                            ],
                            [
                                114.009577,
                                34.480135
                            ],
                            [
                                114.008256,
                                34.470082
                            ],
                            [
                                114.01851,
                                34.46721
                            ],
                            [
                                114.021719,
                                34.458989
                            ],
                            [
                                114.019894,
                                34.445368
                            ],
                            [
                                114.006557,
                                34.439225
                            ],
                            [
                                113.990326,
                                34.435707
                            ],
                            [
                                113.968495,
                                34.439324
                            ],
                            [
                                113.948615,
                                34.435063
                            ],
                            [
                                113.948929,
                                34.452699
                            ],
                            [
                                113.938108,
                                34.454729
                            ],
                            [
                                113.929993,
                                34.443485
                            ],
                            [
                                113.915586,
                                34.444922
                            ],
                            [
                                113.912126,
                                34.452352
                            ],
                            [
                                113.903507,
                                34.454185
                            ],
                            [
                                113.891616,
                                34.437342
                            ],
                            [
                                113.878153,
                                34.411478
                            ],
                            [
                                113.878531,
                                34.394577
                            ],
                            [
                                113.885199,
                                34.370485
                            ],
                            [
                                113.879978,
                                34.356056
                            ],
                            [
                                113.888093,
                                34.348369
                            ],
                            [
                                113.885451,
                                34.327785
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 410300,
                "name": "洛阳市",
                "center": [
                    112.434468,
                    34.663041
                ],
                "centroid": [
                    112.038509,
                    34.293198
                ],
                "childrenNum": 14,
                "level": "city",
                "parent": {
                    "adcode": 410000
                },
                "subFeatureIndex": 2,
                "acroutes": [
                    100000,
                    410000
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                111.260813,
                                33.796775
                            ],
                            [
                                111.270816,
                                33.781699
                            ],
                            [
                                111.288558,
                                33.779702
                            ],
                            [
                                111.304223,
                                33.775008
                            ],
                            [
                                111.315044,
                                33.764073
                            ],
                            [
                                111.322467,
                                33.762974
                            ],
                            [
                                111.336245,
                                33.768317
                            ],
                            [
                                111.348387,
                                33.764822
                            ],
                            [
                                111.390035,
                                33.771264
                            ],
                            [
                                111.398906,
                                33.768168
                            ],
                            [
                                111.4342,
                                33.747742
                            ],
                            [
                                111.469808,
                                33.738052
                            ],
                            [
                                111.484529,
                                33.726462
                            ],
                            [
                                111.495476,
                                33.725663
                            ],
                            [
                                111.516048,
                                33.7405
                            ],
                            [
                                111.523975,
                                33.742847
                            ],
                            [
                                111.541402,
                                33.733406
                            ],
                            [
                                111.567699,
                                33.735005
                            ],
                            [
                                111.59148,
                                33.727711
                            ],
                            [
                                111.619476,
                                33.730059
                            ],
                            [
                                111.645207,
                                33.720517
                            ],
                            [
                                111.665151,
                                33.695582
                            ],
                            [
                                111.684968,
                                33.677489
                            ],
                            [
                                111.719003,
                                33.688885
                            ],
                            [
                                111.728629,
                                33.688086
                            ],
                            [
                                111.778078,
                                33.666091
                            ],
                            [
                                111.819411,
                                33.652892
                            ],
                            [
                                111.82759,
                                33.634189
                            ],
                            [
                                111.827716,
                                33.606228
                            ],
                            [
                                111.832749,
                                33.598723
                            ],
                            [
                                111.843444,
                                33.595821
                            ],
                            [
                                111.863953,
                                33.599174
                            ],
                            [
                                111.884526,
                                33.596121
                            ],
                            [
                                111.899184,
                                33.588666
                            ],
                            [
                                111.916359,
                                33.572102
                            ],
                            [
                                111.930137,
                                33.571051
                            ],
                            [
                                111.994182,
                                33.584913
                            ],
                            [
                                112.020353,
                                33.587715
                            ],
                            [
                                112.028343,
                                33.593019
                            ],
                            [
                                112.024191,
                                33.600024
                            ],
                            [
                                112.018655,
                                33.59437
                            ],
                            [
                                112.012301,
                                33.602626
                            ],
                            [
                                112.014943,
                                33.613632
                            ],
                            [
                                112.024757,
                                33.622436
                            ],
                            [
                                112.038535,
                                33.622386
                            ],
                            [
                                112.059044,
                                33.605227
                            ],
                            [
                                112.065713,
                                33.607479
                            ],
                            [
                                112.087481,
                                33.603076
                            ],
                            [
                                112.092199,
                                33.607228
                            ],
                            [
                                112.084146,
                                33.628988
                            ],
                            [
                                112.076345,
                                33.633689
                            ],
                            [
                                112.071312,
                                33.648192
                            ],
                            [
                                112.074018,
                                33.653142
                            ],
                            [
                                112.104719,
                                33.661392
                            ],
                            [
                                112.120573,
                                33.668841
                            ],
                            [
                                112.13089,
                                33.676939
                            ],
                            [
                                112.141774,
                                33.691634
                            ],
                            [
                                112.15033,
                                33.713672
                            ],
                            [
                                112.158509,
                                33.720117
                            ],
                            [
                                112.168638,
                                33.721766
                            ],
                            [
                                112.17776,
                                33.715621
                            ],
                            [
                                112.179207,
                                33.703278
                            ],
                            [
                                112.184995,
                                33.698731
                            ],
                            [
                                112.214752,
                                33.713972
                            ],
                            [
                                112.230103,
                                33.71702
                            ],
                            [
                                112.239917,
                                33.715321
                            ],
                            [
                                112.249354,
                                33.719018
                            ],
                            [
                                112.24797,
                                33.72871
                            ],
                            [
                                112.263446,
                                33.743596
                            ],
                            [
                                112.266907,
                                33.769766
                            ],
                            [
                                112.259168,
                                33.776007
                            ],
                            [
                                112.260049,
                                33.781849
                            ],
                            [
                                112.277413,
                                33.791684
                            ],
                            [
                                112.273953,
                                33.801667
                            ],
                            [
                                112.285906,
                                33.808755
                            ],
                            [
                                112.301383,
                                33.811001
                            ],
                            [
                                112.323402,
                                33.828467
                            ],
                            [
                                112.351461,
                                33.834605
                            ],
                            [
                                112.363854,
                                33.840143
                            ],
                            [
                                112.372222,
                                33.838297
                            ],
                            [
                                112.40978,
                                33.80591
                            ],
                            [
                                112.42381,
                                33.806559
                            ],
                            [
                                112.433687,
                                33.810951
                            ],
                            [
                                112.45665,
                                33.836451
                            ],
                            [
                                112.462312,
                                33.84583
                            ],
                            [
                                112.474643,
                                33.855458
                            ],
                            [
                                112.48559,
                                33.859848
                            ],
                            [
                                112.512768,
                                33.85895
                            ],
                            [
                                112.534095,
                                33.880247
                            ],
                            [
                                112.541393,
                                33.892165
                            ],
                            [
                                112.536423,
                                33.902236
                            ],
                            [
                                112.51497,
                                33.906374
                            ],
                            [
                                112.502576,
                                33.913004
                            ],
                            [
                                112.497858,
                                33.926064
                            ],
                            [
                                112.530761,
                                33.937975
                            ],
                            [
                                112.538121,
                                33.947344
                            ],
                            [
                                112.539065,
                                33.968071
                            ],
                            [
                                112.546803,
                                33.979777
                            ],
                            [
                                112.547118,
                                33.998304
                            ],
                            [
                                112.56964,
                                34.003035
                            ],
                            [
                                112.549383,
                                34.016529
                            ],
                            [
                                112.533718,
                                34.018122
                            ],
                            [
                                112.538625,
                                34.027084
                            ],
                            [
                                112.572346,
                                34.043162
                            ],
                            [
                                112.577253,
                                34.062373
                            ],
                            [
                                112.601222,
                                34.071827
                            ],
                            [
                                112.602544,
                                34.088792
                            ],
                            [
                                112.608206,
                                34.114209
                            ],
                            [
                                112.616196,
                                34.128928
                            ],
                            [
                                112.620285,
                                34.143148
                            ],
                            [
                                112.611666,
                                34.15816
                            ],
                            [
                                112.595623,
                                34.163529
                            ],
                            [
                                112.589395,
                                34.18614
                            ],
                            [
                                112.583544,
                                34.19096
                            ],
                            [
                                112.559763,
                                34.224988
                            ],
                            [
                                112.577819,
                                34.246988
                            ],
                            [
                                112.575617,
                                34.254336
                            ],
                            [
                                112.557876,
                                34.263719
                            ],
                            [
                                112.553724,
                                34.27608
                            ],
                            [
                                112.569703,
                                34.284815
                            ],
                            [
                                112.573226,
                                34.298314
                            ],
                            [
                                112.597133,
                                34.317962
                            ],
                            [
                                112.613994,
                                34.322328
                            ],
                            [
                                112.607262,
                                34.327934
                            ],
                            [
                                112.623682,
                                34.337854
                            ],
                            [
                                112.650168,
                                34.341078
                            ],
                            [
                                112.659605,
                                34.333936
                            ],
                            [
                                112.65734,
                                34.320592
                            ],
                            [
                                112.669294,
                                34.324908
                            ],
                            [
                                112.688356,
                                34.326743
                            ],
                            [
                                112.701001,
                                34.335077
                            ],
                            [
                                112.73057,
                                34.330414
                            ],
                            [
                                112.741265,
                                34.333738
                            ],
                            [
                                112.75693,
                                34.330662
                            ],
                            [
                                112.776622,
                                34.345046
                            ],
                            [
                                112.760076,
                                34.346584
                            ],
                            [
                                112.756805,
                                34.357394
                            ],
                            [
                                112.732898,
                                34.350898
                            ],
                            [
                                112.728117,
                                34.361163
                            ],
                            [
                                112.730318,
                                34.377426
                            ],
                            [
                                112.721825,
                                34.380152
                            ],
                            [
                                112.72409,
                                34.388877
                            ],
                            [
                                112.733653,
                                34.39309
                            ],
                            [
                                112.735918,
                                34.404242
                            ],
                            [
                                112.729626,
                                34.416978
                            ],
                            [
                                112.736673,
                                34.422578
                            ],
                            [
                                112.741894,
                                34.433973
                            ],
                            [
                                112.744285,
                                34.4683
                            ],
                            [
                                112.740384,
                                34.491077
                            ],
                            [
                                112.767374,
                                34.49479
                            ],
                            [
                                112.774609,
                                34.500137
                            ],
                            [
                                112.798012,
                                34.487166
                            ],
                            [
                                112.806002,
                                34.479243
                            ],
                            [
                                112.838024,
                                34.477164
                            ],
                            [
                                112.856017,
                                34.478402
                            ],
                            [
                                112.862371,
                                34.473648
                            ],
                            [
                                112.896155,
                                34.475827
                            ],
                            [
                                112.905215,
                                34.468201
                            ],
                            [
                                112.922956,
                                34.47657
                            ],
                            [
                                112.920125,
                                34.482016
                            ],
                            [
                                112.927297,
                                34.499691
                            ],
                            [
                                112.925598,
                                34.509789
                            ],
                            [
                                112.929813,
                                34.526023
                            ],
                            [
                                112.947995,
                                34.531467
                            ],
                            [
                                112.976683,
                                34.53117
                            ],
                            [
                                112.984736,
                                34.539038
                            ],
                            [
                                112.967749,
                                34.541264
                            ],
                            [
                                112.952273,
                                34.547647
                            ],
                            [
                                112.929562,
                                34.547548
                            ],
                            [
                                112.910751,
                                34.545173
                            ],
                            [
                                112.890682,
                                34.547102
                            ],
                            [
                                112.87898,
                                34.560015
                            ],
                            [
                                112.877722,
                                34.567731
                            ],
                            [
                                112.864133,
                                34.580146
                            ],
                            [
                                112.862183,
                                34.590284
                            ],
                            [
                                112.846329,
                                34.58885
                            ],
                            [
                                112.839408,
                                34.596514
                            ],
                            [
                                112.845574,
                                34.609913
                            ],
                            [
                                112.840226,
                                34.623161
                            ],
                            [
                                112.82475,
                                34.625188
                            ],
                            [
                                112.825001,
                                34.628698
                            ],
                            [
                                112.841799,
                                34.628648
                            ],
                            [
                                112.847147,
                                34.640362
                            ],
                            [
                                112.831041,
                                34.656669
                            ],
                            [
                                112.835885,
                                34.667785
                            ],
                            [
                                112.829217,
                                34.683346
                            ],
                            [
                                112.830223,
                                34.694163
                            ],
                            [
                                112.8496,
                                34.699694
                            ],
                            [
                                112.867782,
                                34.708089
                            ],
                            [
                                112.879735,
                                34.705077
                            ],
                            [
                                112.893827,
                                34.694953
                            ],
                            [
                                112.901692,
                                34.693521
                            ],
                            [
                                112.91635,
                                34.710953
                            ],
                            [
                                112.931764,
                                34.711694
                            ],
                            [
                                112.939502,
                                34.72384
                            ],
                            [
                                112.909933,
                                34.737465
                            ],
                            [
                                112.902258,
                                34.753161
                            ],
                            [
                                112.908486,
                                34.757405
                            ],
                            [
                                112.909367,
                                34.771123
                            ],
                            [
                                112.89993,
                                34.780596
                            ],
                            [
                                112.887914,
                                34.782718
                            ],
                            [
                                112.875017,
                                34.779659
                            ],
                            [
                                112.846329,
                                34.780054
                            ],
                            [
                                112.837144,
                                34.782915
                            ],
                            [
                                112.817263,
                                34.778278
                            ],
                            [
                                112.810595,
                                34.784938
                            ],
                            [
                                112.80984,
                                34.7951
                            ],
                            [
                                112.814118,
                                34.811475
                            ],
                            [
                                112.827266,
                                34.819218
                            ],
                            [
                                112.813363,
                                34.832877
                            ],
                            [
                                112.78782,
                                34.83761
                            ],
                            [
                                112.773288,
                                34.835884
                            ],
                            [
                                112.753281,
                                34.828587
                            ],
                            [
                                112.72214,
                                34.828833
                            ],
                            [
                                112.696723,
                                34.840617
                            ],
                            [
                                112.676088,
                                34.853188
                            ],
                            [
                                112.656648,
                                34.859645
                            ],
                            [
                                112.638215,
                                34.854174
                            ],
                            [
                                112.636328,
                                34.88266
                            ],
                            [
                                112.642115,
                                34.895717
                            ],
                            [
                                112.638152,
                                34.896998
                            ],
                            [
                                112.638404,
                                34.919756
                            ],
                            [
                                112.618209,
                                34.920298
                            ],
                            [
                                112.585369,
                                34.926503
                            ],
                            [
                                112.579329,
                                34.933398
                            ],
                            [
                                112.578134,
                                34.944083
                            ],
                            [
                                112.571654,
                                34.948761
                            ],
                            [
                                112.5692,
                                34.958608
                            ],
                            [
                                112.563853,
                                34.949696
                            ],
                            [
                                112.551207,
                                34.938569
                            ],
                            [
                                112.527867,
                                34.932019
                            ],
                            [
                                112.519436,
                                34.940341
                            ],
                            [
                                112.505155,
                                34.942459
                            ],
                            [
                                112.496914,
                                34.921726
                            ],
                            [
                                112.511447,
                                34.92084
                            ],
                            [
                                112.515976,
                                34.929212
                            ],
                            [
                                112.527426,
                                34.929163
                            ],
                            [
                                112.537304,
                                34.916013
                            ],
                            [
                                112.534221,
                                34.893746
                            ],
                            [
                                112.521072,
                                34.892761
                            ],
                            [
                                112.505659,
                                34.898821
                            ],
                            [
                                112.496536,
                                34.895717
                            ],
                            [
                                112.489616,
                                34.90286
                            ],
                            [
                                112.462501,
                                34.915668
                            ],
                            [
                                112.433247,
                                34.920987
                            ],
                            [
                                112.39097,
                                34.918574
                            ],
                            [
                                112.384993,
                                34.924533
                            ],
                            [
                                112.360268,
                                34.931428
                            ],
                            [
                                112.334537,
                                34.941425
                            ],
                            [
                                112.3212,
                                34.941375
                            ],
                            [
                                112.301068,
                                34.945462
                            ],
                            [
                                112.28188,
                                34.960232
                            ],
                            [
                                112.267284,
                                34.953537
                            ],
                            [
                                112.258099,
                                34.942212
                            ],
                            [
                                112.247844,
                                34.940735
                            ],
                            [
                                112.226831,
                                34.956589
                            ],
                            [
                                112.212047,
                                34.965007
                            ],
                            [
                                112.1877,
                                34.972981
                            ],
                            [
                                112.169896,
                                35.00241
                            ],
                            [
                                112.1514,
                                35.015399
                            ],
                            [
                                112.125857,
                                35.021204
                            ],
                            [
                                112.108242,
                                35.029222
                            ],
                            [
                                112.09352,
                                35.029911
                            ],
                            [
                                112.042436,
                                35.027845
                            ],
                            [
                                112.035075,
                                35.033845
                            ],
                            [
                                112.038912,
                                35.045501
                            ],
                            [
                                112.035264,
                                35.053714
                            ],
                            [
                                112.023814,
                                35.060843
                            ],
                            [
                                112.021171,
                                35.067973
                            ],
                            [
                                112.006009,
                                35.065367
                            ],
                            [
                                111.973358,
                                35.070234
                            ],
                            [
                                111.958699,
                                35.062908
                            ],
                            [
                                111.958573,
                                35.0486
                            ],
                            [
                                111.939511,
                                35.0366
                            ],
                            [
                                111.940203,
                                35.030599
                            ],
                            [
                                111.967067,
                                35.014169
                            ],
                            [
                                111.991917,
                                35.005018
                            ],
                            [
                                111.978139,
                                34.997195
                            ],
                            [
                                111.981033,
                                34.990059
                            ],
                            [
                                111.967192,
                                34.989912
                            ],
                            [
                                111.95763,
                                34.986221
                            ],
                            [
                                111.961153,
                                34.975689
                            ],
                            [
                                111.983235,
                                34.970471
                            ],
                            [
                                111.981914,
                                34.960626
                            ],
                            [
                                111.950835,
                                34.947776
                            ],
                            [
                                111.933975,
                                34.947678
                            ],
                            [
                                111.921707,
                                34.934038
                            ],
                            [
                                111.906168,
                                34.929606
                            ],
                            [
                                111.890062,
                                34.920347
                            ],
                            [
                                111.88396,
                                34.911974
                            ],
                            [
                                111.883267,
                                34.894239
                            ],
                            [
                                111.898744,
                                34.885912
                            ],
                            [
                                111.922336,
                                34.883941
                            ],
                            [
                                111.949829,
                                34.863391
                            ],
                            [
                                111.948948,
                                34.852301
                            ],
                            [
                                111.957944,
                                34.851167
                            ],
                            [
                                111.981411,
                                34.857624
                            ],
                            [
                                111.990722,
                                34.853779
                            ],
                            [
                                111.982858,
                                34.846139
                            ],
                            [
                                111.986003,
                                34.837856
                            ],
                            [
                                112.01444,
                                34.817985
                            ],
                            [
                                112.020731,
                                34.811327
                            ],
                            [
                                112.012804,
                                34.803781
                            ],
                            [
                                112.016327,
                                34.797073
                            ],
                            [
                                112.030105,
                                34.792584
                            ],
                            [
                                112.031992,
                                34.782965
                            ],
                            [
                                112.031174,
                                34.777735
                            ],
                            [
                                112.017459,
                                34.769939
                            ],
                            [
                                112.019347,
                                34.762587
                            ],
                            [
                                112.011042,
                                34.750644
                            ],
                            [
                                111.997831,
                                34.750693
                            ],
                            [
                                112.000536,
                                34.745017
                            ],
                            [
                                111.995692,
                                34.736823
                            ],
                            [
                                112.014125,
                                34.731048
                            ],
                            [
                                112.01488,
                                34.724235
                            ],
                            [
                                111.997642,
                                34.717125
                            ],
                            [
                                111.993238,
                                34.693866
                            ],
                            [
                                111.982921,
                                34.695052
                            ],
                            [
                                111.984997,
                                34.686013
                            ],
                            [
                                111.972855,
                                34.66739
                            ],
                            [
                                111.980089,
                                34.654
                            ],
                            [
                                111.971408,
                                34.65069
                            ],
                            [
                                111.967444,
                                34.64308
                            ],
                            [
                                111.953666,
                                34.639521
                            ],
                            [
                                111.943223,
                                34.629637
                            ],
                            [
                                111.94165,
                                34.620492
                            ],
                            [
                                111.928879,
                                34.600272
                            ],
                            [
                                111.905664,
                                34.6198
                            ],
                            [
                                111.888867,
                                34.61891
                            ],
                            [
                                111.863953,
                                34.647082
                            ],
                            [
                                111.830736,
                                34.649207
                            ],
                            [
                                111.823752,
                                34.646242
                            ],
                            [
                                111.821362,
                                34.634431
                            ],
                            [
                                111.811296,
                                34.633887
                            ],
                            [
                                111.797078,
                                34.626028
                            ],
                            [
                                111.778393,
                                34.608331
                            ],
                            [
                                111.764112,
                                34.609171
                            ],
                            [
                                111.758764,
                                34.597454
                            ],
                            [
                                111.740079,
                                34.600272
                            ],
                            [
                                111.702835,
                                34.584943
                            ],
                            [
                                111.696292,
                                34.575744
                            ],
                            [
                                111.687044,
                                34.571886
                            ],
                            [
                                111.672008,
                                34.572232
                            ],
                            [
                                111.681445,
                                34.547647
                            ],
                            [
                                111.692643,
                                34.535673
                            ],
                            [
                                111.683584,
                                34.533298
                            ],
                            [
                                111.670058,
                                34.540571
                            ],
                            [
                                111.619099,
                                34.55576
                            ],
                            [
                                111.608089,
                                34.56229
                            ],
                            [
                                111.594437,
                                34.565308
                            ],
                            [
                                111.584434,
                                34.556057
                            ],
                            [
                                111.574305,
                                34.564467
                            ],
                            [
                                111.562037,
                                34.558728
                            ],
                            [
                                111.544736,
                                34.544925
                            ],
                            [
                                111.538634,
                                34.543342
                            ],
                            [
                                111.525045,
                                34.54829
                            ],
                            [
                                111.5029,
                                34.545074
                            ],
                            [
                                111.489437,
                                34.533842
                            ],
                            [
                                111.484655,
                                34.525528
                            ],
                            [
                                111.45754,
                                34.512561
                            ],
                            [
                                111.451689,
                                34.505928
                            ],
                            [
                                111.418346,
                                34.490829
                            ],
                            [
                                111.394816,
                                34.482016
                            ],
                            [
                                111.385065,
                                34.473103
                            ],
                            [
                                111.370595,
                                34.473301
                            ],
                            [
                                111.358642,
                                34.480333
                            ],
                            [
                                111.344424,
                                34.472955
                            ],
                            [
                                111.324732,
                                34.471717
                            ],
                            [
                                111.306676,
                                34.474193
                            ],
                            [
                                111.300008,
                                34.488948
                            ],
                            [
                                111.289313,
                                34.485581
                            ],
                            [
                                111.271383,
                                34.470677
                            ],
                            [
                                111.272012,
                                34.447547
                            ],
                            [
                                111.244708,
                                34.453788
                            ],
                            [
                                111.227533,
                                34.459732
                            ],
                            [
                                111.220235,
                                34.457949
                            ],
                            [
                                111.213252,
                                34.437441
                            ],
                            [
                                111.21344,
                                34.429812
                            ],
                            [
                                111.197712,
                                34.418762
                            ],
                            [
                                111.191232,
                                34.41792
                            ],
                            [
                                111.188967,
                                34.399286
                            ],
                            [
                                111.171415,
                                34.394974
                            ],
                            [
                                111.156819,
                                34.394677
                            ],
                            [
                                111.147949,
                                34.38853
                            ],
                            [
                                111.141217,
                                34.373113
                            ],
                            [
                                111.138449,
                                34.35675
                            ],
                            [
                                111.141217,
                                34.353031
                            ],
                            [
                                111.159839,
                                34.350799
                            ],
                            [
                                111.166634,
                                34.344798
                            ],
                            [
                                111.16915,
                                34.334878
                            ],
                            [
                                111.185444,
                                34.31697
                            ],
                            [
                                111.191547,
                                34.301837
                            ],
                            [
                                111.181921,
                                34.27876
                            ],
                            [
                                111.182488,
                                34.256421
                            ],
                            [
                                111.187772,
                                34.250265
                            ],
                            [
                                111.180915,
                                34.230203
                            ],
                            [
                                111.166571,
                                34.228962
                            ],
                            [
                                111.158958,
                                34.223101
                            ],
                            [
                                111.175819,
                                34.209541
                            ],
                            [
                                111.207401,
                                34.197419
                            ],
                            [
                                111.214699,
                                34.181221
                            ],
                            [
                                111.234516,
                                34.178537
                            ],
                            [
                                111.248671,
                                34.162882
                            ],
                            [
                                111.253201,
                                34.15309
                            ],
                            [
                                111.267922,
                                34.146528
                            ],
                            [
                                111.276856,
                                34.148318
                            ],
                            [
                                111.281889,
                                34.138524
                            ],
                            [
                                111.296925,
                                34.145137
                            ],
                            [
                                111.305292,
                                34.140165
                            ],
                            [
                                111.306362,
                                34.125149
                            ],
                            [
                                111.313408,
                                34.116546
                            ],
                            [
                                111.334735,
                                34.115601
                            ],
                            [
                                111.344738,
                                34.109037
                            ],
                            [
                                111.358768,
                                34.108788
                            ],
                            [
                                111.367198,
                                34.092473
                            ],
                            [
                                111.354301,
                                34.084464
                            ],
                            [
                                111.342096,
                                34.056053
                            ],
                            [
                                111.342285,
                                34.037936
                            ],
                            [
                                111.355119,
                                34.015185
                            ],
                            [
                                111.353609,
                                33.996263
                            ],
                            [
                                111.356,
                                33.984509
                            ],
                            [
                                111.344109,
                                33.973351
                            ],
                            [
                                111.324795,
                                33.963039
                            ],
                            [
                                111.305921,
                                33.941364
                            ],
                            [
                                111.303342,
                                33.928207
                            ],
                            [
                                111.29013,
                                33.926662
                            ],
                            [
                                111.276793,
                                33.935533
                            ],
                            [
                                111.259366,
                                33.929852
                            ],
                            [
                                111.239989,
                                33.933141
                            ],
                            [
                                111.230049,
                                33.924768
                            ],
                            [
                                111.226652,
                                33.913104
                            ],
                            [
                                111.234768,
                                33.901738
                            ],
                            [
                                111.234516,
                                33.894857
                            ],
                            [
                                111.212811,
                                33.884087
                            ],
                            [
                                111.206017,
                                33.891616
                            ],
                            [
                                111.203689,
                                33.883438
                            ],
                            [
                                111.21948,
                                33.872766
                            ],
                            [
                                111.216397,
                                33.865135
                            ],
                            [
                                111.232062,
                                33.856805
                            ],
                            [
                                111.240304,
                                33.842488
                            ],
                            [
                                111.261568,
                                33.822878
                            ],
                            [
                                111.260813,
                                33.796775
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                112.028784,
                                34.778968
                            ],
                            [
                                112.030231,
                                34.782668
                            ],
                            [
                                112.018466,
                                34.785678
                            ],
                            [
                                112.021171,
                                34.777537
                            ],
                            [
                                112.028784,
                                34.778968
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 410400,
                "name": "平顶山市",
                "center": [
                    113.307718,
                    33.735241
                ],
                "centroid": [
                    113.016514,
                    33.795715
                ],
                "childrenNum": 10,
                "level": "city",
                "parent": {
                    "adcode": 410000
                },
                "subFeatureIndex": 3,
                "acroutes": [
                    100000,
                    410000
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                113.585485,
                                33.711024
                            ],
                            [
                                113.580767,
                                33.715171
                            ],
                            [
                                113.58775,
                                33.727062
                            ],
                            [
                                113.576552,
                                33.736304
                            ],
                            [
                                113.573091,
                                33.752137
                            ],
                            [
                                113.549373,
                                33.750489
                            ],
                            [
                                113.544341,
                                33.757131
                            ],
                            [
                                113.51798,
                                33.750439
                            ],
                            [
                                113.504014,
                                33.751238
                            ],
                            [
                                113.489481,
                                33.746094
                            ],
                            [
                                113.451042,
                                33.739301
                            ],
                            [
                                113.448211,
                                33.75868
                            ],
                            [
                                113.434873,
                                33.765371
                            ],
                            [
                                113.425814,
                                33.762175
                            ],
                            [
                                113.372401,
                                33.785593
                            ],
                            [
                                113.393351,
                                33.797873
                            ],
                            [
                                113.386053,
                                33.801817
                            ],
                            [
                                113.38102,
                                33.815542
                            ],
                            [
                                113.385802,
                                33.834854
                            ],
                            [
                                113.384669,
                                33.843286
                            ],
                            [
                                113.36762,
                                33.862691
                            ],
                            [
                                113.360762,
                                33.879997
                            ],
                            [
                                113.365481,
                                33.890519
                            ],
                            [
                                113.381586,
                                33.912007
                            ],
                            [
                                113.386116,
                                33.927808
                            ],
                            [
                                113.410715,
                                33.943308
                            ],
                            [
                                113.412665,
                                33.952028
                            ],
                            [
                                113.41342,
                                33.987049
                            ],
                            [
                                113.402222,
                                34.002687
                            ],
                            [
                                113.395742,
                                34.031315
                            ],
                            [
                                113.386368,
                                34.039827
                            ],
                            [
                                113.368626,
                                34.039877
                            ],
                            [
                                113.35466,
                                34.043112
                            ],
                            [
                                113.346104,
                                34.03928
                            ],
                            [
                                113.345034,
                                34.029075
                            ],
                            [
                                113.334528,
                                34.027183
                            ],
                            [
                                113.320687,
                                34.054858
                            ],
                            [
                                113.331949,
                                34.063268
                            ],
                            [
                                113.30043,
                                34.082623
                            ],
                            [
                                113.283129,
                                34.086802
                            ],
                            [
                                113.278914,
                                34.100134
                            ],
                            [
                                113.264381,
                                34.098542
                            ],
                            [
                                113.257398,
                                34.112319
                            ],
                            [
                                113.252113,
                                34.114308
                            ],
                            [
                                113.240097,
                                34.108539
                            ],
                            [
                                113.241166,
                                34.097945
                            ],
                            [
                                113.235064,
                                34.091926
                            ],
                            [
                                113.227137,
                                34.092523
                            ],
                            [
                                113.222355,
                                34.102422
                            ],
                            [
                                113.210654,
                                34.107445
                            ],
                            [
                                113.177876,
                                34.101228
                            ],
                            [
                                113.157493,
                                34.103118
                            ],
                            [
                                113.150384,
                                34.108141
                            ],
                            [
                                113.146483,
                                34.117939
                            ],
                            [
                                113.130629,
                                34.124105
                            ],
                            [
                                113.126477,
                                34.134696
                            ],
                            [
                                113.129811,
                                34.145733
                            ],
                            [
                                113.118047,
                                34.156818
                            ],
                            [
                                113.103011,
                                34.176798
                            ],
                            [
                                113.101941,
                                34.18778
                            ],
                            [
                                113.106094,
                                34.198115
                            ],
                            [
                                113.103892,
                                34.205418
                            ],
                            [
                                113.094203,
                                34.21118
                            ],
                            [
                                113.075392,
                                34.215502
                            ],
                            [
                                113.066962,
                                34.223647
                            ],
                            [
                                113.070171,
                                34.247186
                            ],
                            [
                                113.077343,
                                34.262677
                            ],
                            [
                                113.082439,
                                34.26645
                            ],
                            [
                                113.075518,
                                34.276527
                            ],
                            [
                                113.059476,
                                34.280944
                            ],
                            [
                                113.037142,
                                34.280299
                            ],
                            [
                                113.027642,
                                34.289282
                            ],
                            [
                                113.020847,
                                34.290424
                            ],
                            [
                                113.013235,
                                34.300398
                            ],
                            [
                                112.992977,
                                34.296478
                            ],
                            [
                                112.960829,
                                34.297867
                            ],
                            [
                                112.954097,
                                34.302135
                            ],
                            [
                                112.936293,
                                34.295535
                            ],
                            [
                                112.91245,
                                34.293749
                            ],
                            [
                                112.884516,
                                34.30144
                            ],
                            [
                                112.87357,
                                34.298016
                            ],
                            [
                                112.856458,
                                34.302185
                            ],
                            [
                                112.84117,
                                34.297818
                            ],
                            [
                                112.842114,
                                34.311612
                            ],
                            [
                                112.854633,
                                34.316325
                            ],
                            [
                                112.83318,
                                34.333638
                            ],
                            [
                                112.824184,
                                34.33344
                            ],
                            [
                                112.81223,
                                34.340037
                            ],
                            [
                                112.788953,
                                34.331158
                            ],
                            [
                                112.787002,
                                34.343261
                            ],
                            [
                                112.776622,
                                34.345046
                            ],
                            [
                                112.75693,
                                34.330662
                            ],
                            [
                                112.741265,
                                34.333738
                            ],
                            [
                                112.73057,
                                34.330414
                            ],
                            [
                                112.701001,
                                34.335077
                            ],
                            [
                                112.688356,
                                34.326743
                            ],
                            [
                                112.669294,
                                34.324908
                            ],
                            [
                                112.65734,
                                34.320592
                            ],
                            [
                                112.659605,
                                34.333936
                            ],
                            [
                                112.650168,
                                34.341078
                            ],
                            [
                                112.623682,
                                34.337854
                            ],
                            [
                                112.607262,
                                34.327934
                            ],
                            [
                                112.613994,
                                34.322328
                            ],
                            [
                                112.597133,
                                34.317962
                            ],
                            [
                                112.573226,
                                34.298314
                            ],
                            [
                                112.569703,
                                34.284815
                            ],
                            [
                                112.553724,
                                34.27608
                            ],
                            [
                                112.557876,
                                34.263719
                            ],
                            [
                                112.575617,
                                34.254336
                            ],
                            [
                                112.577819,
                                34.246988
                            ],
                            [
                                112.559763,
                                34.224988
                            ],
                            [
                                112.583544,
                                34.19096
                            ],
                            [
                                112.589395,
                                34.18614
                            ],
                            [
                                112.595623,
                                34.163529
                            ],
                            [
                                112.611666,
                                34.15816
                            ],
                            [
                                112.620285,
                                34.143148
                            ],
                            [
                                112.616196,
                                34.128928
                            ],
                            [
                                112.608206,
                                34.114209
                            ],
                            [
                                112.602544,
                                34.088792
                            ],
                            [
                                112.601222,
                                34.071827
                            ],
                            [
                                112.577253,
                                34.062373
                            ],
                            [
                                112.572346,
                                34.043162
                            ],
                            [
                                112.538625,
                                34.027084
                            ],
                            [
                                112.533718,
                                34.018122
                            ],
                            [
                                112.549383,
                                34.016529
                            ],
                            [
                                112.56964,
                                34.003035
                            ],
                            [
                                112.547118,
                                33.998304
                            ],
                            [
                                112.546803,
                                33.979777
                            ],
                            [
                                112.539065,
                                33.968071
                            ],
                            [
                                112.538121,
                                33.947344
                            ],
                            [
                                112.530761,
                                33.937975
                            ],
                            [
                                112.497858,
                                33.926064
                            ],
                            [
                                112.502576,
                                33.913004
                            ],
                            [
                                112.51497,
                                33.906374
                            ],
                            [
                                112.536423,
                                33.902236
                            ],
                            [
                                112.541393,
                                33.892165
                            ],
                            [
                                112.534095,
                                33.880247
                            ],
                            [
                                112.512768,
                                33.85895
                            ],
                            [
                                112.48559,
                                33.859848
                            ],
                            [
                                112.474643,
                                33.855458
                            ],
                            [
                                112.462312,
                                33.84583
                            ],
                            [
                                112.45665,
                                33.836451
                            ],
                            [
                                112.433687,
                                33.810951
                            ],
                            [
                                112.42381,
                                33.806559
                            ],
                            [
                                112.40978,
                                33.80591
                            ],
                            [
                                112.372222,
                                33.838297
                            ],
                            [
                                112.363854,
                                33.840143
                            ],
                            [
                                112.351461,
                                33.834605
                            ],
                            [
                                112.323402,
                                33.828467
                            ],
                            [
                                112.301383,
                                33.811001
                            ],
                            [
                                112.285906,
                                33.808755
                            ],
                            [
                                112.273953,
                                33.801667
                            ],
                            [
                                112.277413,
                                33.791684
                            ],
                            [
                                112.260049,
                                33.781849
                            ],
                            [
                                112.259168,
                                33.776007
                            ],
                            [
                                112.266907,
                                33.769766
                            ],
                            [
                                112.263446,
                                33.743596
                            ],
                            [
                                112.24797,
                                33.72871
                            ],
                            [
                                112.249354,
                                33.719018
                            ],
                            [
                                112.258854,
                                33.710624
                            ],
                            [
                                112.278168,
                                33.712373
                            ],
                            [
                                112.306541,
                                33.69978
                            ],
                            [
                                112.312455,
                                33.684887
                            ],
                            [
                                112.332839,
                                33.668391
                            ],
                            [
                                112.353285,
                                33.669941
                            ],
                            [
                                112.361086,
                                33.661242
                            ],
                            [
                                112.375116,
                                33.666891
                            ],
                            [
                                112.392479,
                                33.666991
                            ],
                            [
                                112.408019,
                                33.675439
                            ],
                            [
                                112.420727,
                                33.676389
                            ],
                            [
                                112.453756,
                                33.645291
                            ],
                            [
                                112.461683,
                                33.63994
                            ],
                            [
                                112.477159,
                                33.63764
                            ],
                            [
                                112.493202,
                                33.63899
                            ],
                            [
                                112.503394,
                                33.622185
                            ],
                            [
                                112.524721,
                                33.603826
                            ],
                            [
                                112.522771,
                                33.595521
                            ],
                            [
                                112.529943,
                                33.587915
                            ],
                            [
                                112.548502,
                                33.59367
                            ],
                            [
                                112.556869,
                                33.588166
                            ],
                            [
                                112.575995,
                                33.602275
                            ],
                            [
                                112.588388,
                                33.616883
                            ],
                            [
                                112.599775,
                                33.618084
                            ],
                            [
                                112.610785,
                                33.611431
                            ],
                            [
                                112.611351,
                                33.601875
                            ],
                            [
                                112.617705,
                                33.597272
                            ],
                            [
                                112.63444,
                                33.594821
                            ],
                            [
                                112.646205,
                                33.602876
                            ],
                            [
                                112.660234,
                                33.605377
                            ],
                            [
                                112.664386,
                                33.597673
                            ],
                            [
                                112.683889,
                                33.591718
                            ],
                            [
                                112.689174,
                                33.587165
                            ],
                            [
                                112.70572,
                                33.585263
                            ],
                            [
                                112.725411,
                                33.586765
                            ],
                            [
                                112.743215,
                                33.578858
                            ],
                            [
                                112.750387,
                                33.571151
                            ],
                            [
                                112.760076,
                                33.571751
                            ],
                            [
                                112.773413,
                                33.56079
                            ],
                            [
                                112.783668,
                                33.567747
                            ],
                            [
                                112.81179,
                                33.580309
                            ],
                            [
                                112.82022,
                                33.574804
                            ],
                            [
                                112.845637,
                                33.578107
                            ],
                            [
                                112.85262,
                                33.584413
                            ],
                            [
                                112.854822,
                                33.603626
                            ],
                            [
                                112.869669,
                                33.611531
                            ],
                            [
                                112.887914,
                                33.608329
                            ],
                            [
                                112.893513,
                                33.616133
                            ],
                            [
                                112.917545,
                                33.605627
                            ],
                            [
                                112.94271,
                                33.607629
                            ],
                            [
                                112.950134,
                                33.590968
                            ],
                            [
                                112.963597,
                                33.583662
                            ],
                            [
                                112.972908,
                                33.584613
                            ],
                            [
                                112.986497,
                                33.575805
                            ],
                            [
                                112.990775,
                                33.567797
                            ],
                            [
                                112.997255,
                                33.569399
                            ],
                            [
                                113.022861,
                                33.56119
                            ],
                            [
                                113.027642,
                                33.546874
                            ],
                            [
                                113.036701,
                                33.546974
                            ],
                            [
                                113.036261,
                                33.539865
                            ],
                            [
                                113.047333,
                                33.532204
                            ],
                            [
                                113.04381,
                                33.517532
                            ],
                            [
                                113.048214,
                                33.508317
                            ],
                            [
                                113.049221,
                                33.492087
                            ],
                            [
                                113.053373,
                                33.485725
                            ],
                            [
                                113.041168,
                                33.473701
                            ],
                            [
                                113.037897,
                                33.464331
                            ],
                            [
                                113.041357,
                                33.44659
                            ],
                            [
                                113.045698,
                                33.439472
                            ],
                            [
                                113.074826,
                                33.448444
                            ],
                            [
                                113.110309,
                                33.446138
                            ],
                            [
                                113.125659,
                                33.439723
                            ],
                            [
                                113.128742,
                                33.427642
                            ],
                            [
                                113.141765,
                                33.425987
                            ],
                            [
                                113.156109,
                                33.433607
                            ],
                            [
                                113.176052,
                                33.435713
                            ],
                            [
                                113.192975,
                                33.429797
                            ],
                            [
                                113.198134,
                                33.420523
                            ],
                            [
                                113.216316,
                                33.398861
                            ],
                            [
                                113.230912,
                                33.38848
                            ],
                            [
                                113.230534,
                                33.374937
                            ],
                            [
                                113.241418,
                                33.373733
                            ],
                            [
                                113.245004,
                                33.365356
                            ],
                            [
                                113.257964,
                                33.366158
                            ],
                            [
                                113.270609,
                                33.358834
                            ],
                            [
                                113.277089,
                                33.350254
                            ],
                            [
                                113.289923,
                                33.351709
                            ],
                            [
                                113.302632,
                                33.348999
                            ],
                            [
                                113.312194,
                                33.341121
                            ],
                            [
                                113.335472,
                                33.35201
                            ],
                            [
                                113.363908,
                                33.342476
                            ],
                            [
                                113.400397,
                                33.335852
                            ],
                            [
                                113.40738,
                                33.323004
                            ],
                            [
                                113.400838,
                                33.314722
                            ],
                            [
                                113.403857,
                                33.302724
                            ],
                            [
                                113.388318,
                                33.299059
                            ],
                            [
                                113.384732,
                                33.29203
                            ],
                            [
                                113.400146,
                                33.261044
                            ],
                            [
                                113.402851,
                                33.235224
                            ],
                            [
                                113.391212,
                                33.225928
                            ],
                            [
                                113.384103,
                                33.206128
                            ],
                            [
                                113.384417,
                                33.196679
                            ],
                            [
                                113.377875,
                                33.184313
                            ],
                            [
                                113.370136,
                                33.182855
                            ],
                            [
                                113.385802,
                                33.169381
                            ],
                            [
                                113.382467,
                                33.156156
                            ],
                            [
                                113.385424,
                                33.145595
                            ],
                            [
                                113.379888,
                                33.135485
                            ],
                            [
                                113.388821,
                                33.128393
                            ],
                            [
                                113.397881,
                                33.14997
                            ],
                            [
                                113.413105,
                                33.156659
                            ],
                            [
                                113.432545,
                                33.15681
                            ],
                            [
                                113.449217,
                                33.160581
                            ],
                            [
                                113.46029,
                                33.156458
                            ],
                            [
                                113.499987,
                                33.156206
                            ],
                            [
                                113.514772,
                                33.162492
                            ],
                            [
                                113.521378,
                                33.154698
                            ],
                            [
                                113.532324,
                                33.152736
                            ],
                            [
                                113.541321,
                                33.14308
                            ],
                            [
                                113.550254,
                                33.140113
                            ],
                            [
                                113.561201,
                                33.161134
                            ],
                            [
                                113.573846,
                                33.15691
                            ],
                            [
                                113.593601,
                                33.157715
                            ],
                            [
                                113.600144,
                                33.163146
                            ],
                            [
                                113.617004,
                                33.147255
                            ],
                            [
                                113.626001,
                                33.150423
                            ],
                            [
                                113.63506,
                                33.160833
                            ],
                            [
                                113.64846,
                                33.182402
                            ],
                            [
                                113.644623,
                                33.186575
                            ],
                            [
                                113.627511,
                                33.186475
                            ],
                            [
                                113.613796,
                                33.211506
                            ],
                            [
                                113.606875,
                                33.237786
                            ],
                            [
                                113.613167,
                                33.261798
                            ],
                            [
                                113.618766,
                                33.291477
                            ],
                            [
                                113.627448,
                                33.312212
                            ],
                            [
                                113.640282,
                                33.325162
                            ],
                            [
                                113.642106,
                                33.34905
                            ],
                            [
                                113.639149,
                                33.355221
                            ],
                            [
                                113.655003,
                                33.371175
                            ],
                            [
                                113.676897,
                                33.378298
                            ],
                            [
                                113.688347,
                                33.407737
                            ],
                            [
                                113.683125,
                                33.41952
                            ],
                            [
                                113.659407,
                                33.424283
                            ],
                            [
                                113.651669,
                                33.418417
                            ],
                            [
                                113.645252,
                                33.421776
                            ],
                            [
                                113.620842,
                                33.410946
                            ],
                            [
                                113.596809,
                                33.41215
                            ],
                            [
                                113.589008,
                                33.404728
                            ],
                            [
                                113.574727,
                                33.407537
                            ],
                            [
                                113.54736,
                                33.406433
                            ],
                            [
                                113.539811,
                                33.419019
                            ],
                            [
                                113.526662,
                                33.419269
                            ],
                            [
                                113.51754,
                                33.407186
                            ],
                            [
                                113.506341,
                                33.414607
                            ],
                            [
                                113.483945,
                                33.421124
                            ],
                            [
                                113.468846,
                                33.422077
                            ],
                            [
                                113.466518,
                                33.437367
                            ],
                            [
                                113.473501,
                                33.443683
                            ],
                            [
                                113.471803,
                                33.463378
                            ],
                            [
                                113.484322,
                                33.483721
                            ],
                            [
                                113.478597,
                                33.50431
                            ],
                            [
                                113.483001,
                                33.500152
                            ],
                            [
                                113.50307,
                                33.500252
                            ],
                            [
                                113.510808,
                                33.505011
                            ],
                            [
                                113.525278,
                                33.505061
                            ],
                            [
                                113.532073,
                                33.497347
                            ],
                            [
                                113.537609,
                                33.498499
                            ],
                            [
                                113.533708,
                                33.514978
                            ],
                            [
                                113.537672,
                                33.51633
                            ],
                            [
                                113.545536,
                                33.548626
                            ],
                            [
                                113.557363,
                                33.553582
                            ],
                            [
                                113.563151,
                                33.57055
                            ],
                            [
                                113.554281,
                                33.5706
                            ],
                            [
                                113.552267,
                                33.586715
                            ],
                            [
                                113.576803,
                                33.592619
                            ],
                            [
                                113.579383,
                                33.597222
                            ],
                            [
                                113.604673,
                                33.613131
                            ],
                            [
                                113.621534,
                                33.619885
                            ],
                            [
                                113.628203,
                                33.629038
                            ],
                            [
                                113.619143,
                                33.63799
                            ],
                            [
                                113.596746,
                                33.651892
                            ],
                            [
                                113.587624,
                                33.654642
                            ],
                            [
                                113.580515,
                                33.681738
                            ],
                            [
                                113.584101,
                                33.698131
                            ],
                            [
                                113.576677,
                                33.706327
                            ],
                            [
                                113.585485,
                                33.711024
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 410500,
                "name": "安阳市",
                "center": [
                    114.352482,
                    36.103442
                ],
                "centroid": [
                    114.358257,
                    35.878529
                ],
                "childrenNum": 9,
                "level": "city",
                "parent": {
                    "adcode": 410000
                },
                "subFeatureIndex": 4,
                "acroutes": [
                    100000,
                    410000
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                114.419073,
                                35.474181
                            ],
                            [
                                114.428573,
                                35.468947
                            ],
                            [
                                114.429139,
                                35.449523
                            ],
                            [
                                114.412027,
                                35.43582
                            ],
                            [
                                114.405043,
                                35.426325
                            ],
                            [
                                114.407686,
                                35.418004
                            ],
                            [
                                114.415172,
                                35.413255
                            ],
                            [
                                114.423666,
                                35.380155
                            ],
                            [
                                114.413474,
                                35.370163
                            ],
                            [
                                114.411083,
                                35.358064
                            ],
                            [
                                114.429076,
                                35.342876
                            ],
                            [
                                114.423414,
                                35.324842
                            ],
                            [
                                114.404226,
                                35.326313
                            ],
                            [
                                114.403659,
                                35.316805
                            ],
                            [
                                114.412782,
                                35.313521
                            ],
                            [
                                114.416493,
                                35.302785
                            ],
                            [
                                114.408189,
                                35.29249
                            ],
                            [
                                114.395732,
                                35.293078
                            ],
                            [
                                114.407497,
                                35.269738
                            ],
                            [
                                114.395481,
                                35.26449
                            ],
                            [
                                114.391266,
                                35.258114
                            ],
                            [
                                114.396299,
                                35.241828
                            ],
                            [
                                114.407497,
                                35.236627
                            ],
                            [
                                114.392146,
                                35.226912
                            ],
                            [
                                114.394348,
                                35.219797
                            ],
                            [
                                114.399696,
                                35.225097
                            ],
                            [
                                114.415298,
                                35.228188
                            ],
                            [
                                114.431404,
                                35.222055
                            ],
                            [
                                114.431781,
                                35.208755
                            ],
                            [
                                114.442602,
                                35.205958
                            ],
                            [
                                114.4499,
                                35.214448
                            ],
                            [
                                114.465376,
                                35.216706
                            ],
                            [
                                114.487836,
                                35.206645
                            ],
                            [
                                114.494756,
                                35.220141
                            ],
                            [
                                114.50413,
                                35.228286
                            ],
                            [
                                114.527093,
                                35.235646
                            ],
                            [
                                114.541437,
                                35.242809
                            ],
                            [
                                114.549364,
                                35.261891
                            ],
                            [
                                114.562198,
                                35.276064
                            ],
                            [
                                114.5968,
                                35.286116
                            ],
                            [
                                114.607495,
                                35.292686
                            ],
                            [
                                114.627313,
                                35.298275
                            ],
                            [
                                114.642915,
                                35.297148
                            ],
                            [
                                114.663173,
                                35.291559
                            ],
                            [
                                114.679907,
                                35.291166
                            ],
                            [
                                114.688715,
                                35.295138
                            ],
                            [
                                114.698341,
                                35.306756
                            ],
                            [
                                114.701675,
                                35.329008
                            ],
                            [
                                114.697397,
                                35.337486
                            ],
                            [
                                114.718598,
                                35.343611
                            ],
                            [
                                114.73722,
                                35.344689
                            ],
                            [
                                114.754521,
                                35.341308
                            ],
                            [
                                114.76163,
                                35.345228
                            ],
                            [
                                114.783964,
                                35.343023
                            ],
                            [
                                114.808877,
                                35.346942
                            ],
                            [
                                114.809632,
                                35.354242
                            ],
                            [
                                114.856942,
                                35.387794
                            ],
                            [
                                114.879339,
                                35.387452
                            ],
                            [
                                114.898087,
                                35.390781
                            ],
                            [
                                114.951248,
                                35.380791
                            ],
                            [
                                114.967605,
                                35.399204
                            ],
                            [
                                114.985787,
                                35.414332
                            ],
                            [
                                114.981509,
                                35.434107
                            ],
                            [
                                114.96383,
                                35.440665
                            ],
                            [
                                114.96188,
                                35.446146
                            ],
                            [
                                114.967668,
                                35.456716
                            ],
                            [
                                114.970751,
                                35.480785
                            ],
                            [
                                114.947347,
                                35.478144
                            ],
                            [
                                114.93942,
                                35.481225
                            ],
                            [
                                114.940616,
                                35.491448
                            ],
                            [
                                114.953324,
                                35.501815
                            ],
                            [
                                114.964334,
                                35.504749
                            ],
                            [
                                114.969492,
                                35.518
                            ],
                            [
                                114.968423,
                                35.537554
                            ],
                            [
                                114.962006,
                                35.571421
                            ],
                            [
                                114.952884,
                                35.581094
                            ],
                            [
                                114.90853,
                                35.585979
                            ],
                            [
                                114.884813,
                                35.599852
                            ],
                            [
                                114.883051,
                                35.616065
                            ],
                            [
                                114.874432,
                                35.623878
                            ],
                            [
                                114.875502,
                                35.628907
                            ],
                            [
                                114.890034,
                                35.646823
                            ],
                            [
                                114.905888,
                                35.649606
                            ],
                            [
                                114.911047,
                                35.660685
                            ],
                            [
                                114.919226,
                                35.664785
                            ],
                            [
                                114.918408,
                                35.687962
                            ],
                            [
                                114.910544,
                                35.700939
                            ],
                            [
                                114.915514,
                                35.706743
                            ],
                            [
                                114.907776,
                                35.722594
                            ],
                            [
                                114.889594,
                                35.738978
                            ],
                            [
                                114.887832,
                                35.753506
                            ],
                            [
                                114.893746,
                                35.764132
                            ],
                            [
                                114.908405,
                                35.765741
                            ],
                            [
                                114.921365,
                                35.780118
                            ],
                            [
                                114.943573,
                                35.799754
                            ],
                            [
                                114.948669,
                                35.819629
                            ],
                            [
                                114.94546,
                                35.82523
                            ],
                            [
                                114.93401,
                                35.828055
                            ],
                            [
                                114.933003,
                                35.84505
                            ],
                            [
                                114.935646,
                                35.853814
                            ],
                            [
                                114.953009,
                                35.85766
                            ],
                            [
                                114.959112,
                                35.862723
                            ],
                            [
                                114.969996,
                                35.881366
                            ],
                            [
                                114.970814,
                                35.890223
                            ],
                            [
                                114.97786,
                                35.904723
                            ],
                            [
                                114.972324,
                                35.923259
                            ],
                            [
                                114.98025,
                                35.949814
                            ],
                            [
                                114.988366,
                                35.964741
                            ],
                            [
                                114.983333,
                                35.982922
                            ],
                            [
                                114.986164,
                                35.991865
                            ],
                            [
                                114.980376,
                                36.003334
                            ],
                            [
                                114.974274,
                                35.999009
                            ],
                            [
                                114.974211,
                                36.012226
                            ],
                            [
                                114.983396,
                                36.019417
                            ],
                            [
                                114.983962,
                                36.02583
                            ],
                            [
                                114.968926,
                                36.032971
                            ],
                            [
                                114.94244,
                                36.03812
                            ],
                            [
                                114.920798,
                                36.048319
                            ],
                            [
                                114.914696,
                                36.05201
                            ],
                            [
                                114.92646,
                                36.089444
                            ],
                            [
                                114.922057,
                                36.103132
                            ],
                            [
                                114.913249,
                                36.107645
                            ],
                            [
                                114.907083,
                                36.119971
                            ],
                            [
                                114.912431,
                                36.140444
                            ],
                            [
                                114.893432,
                                36.140056
                            ],
                            [
                                114.89211,
                                36.143792
                            ],
                            [
                                114.868518,
                                36.146653
                            ],
                            [
                                114.858641,
                                36.144325
                            ],
                            [
                                114.857509,
                                36.127734
                            ],
                            [
                                114.841655,
                                36.131712
                            ],
                            [
                                114.831589,
                                36.130354
                            ],
                            [
                                114.825172,
                                36.123707
                            ],
                            [
                                114.802775,
                                36.130936
                            ],
                            [
                                114.790885,
                                36.130014
                            ],
                            [
                                114.778617,
                                36.133168
                            ],
                            [
                                114.777987,
                                36.128025
                            ],
                            [
                                114.76421,
                                36.125551
                            ],
                            [
                                114.762889,
                                36.134914
                            ],
                            [
                                114.751564,
                                36.138698
                            ],
                            [
                                114.751564,
                                36.146605
                            ],
                            [
                                114.734389,
                                36.155772
                            ],
                            [
                                114.720674,
                                36.140056
                            ],
                            [
                                114.711678,
                                36.145441
                            ],
                            [
                                114.692364,
                                36.146217
                            ],
                            [
                                114.691106,
                                36.138407
                            ],
                            [
                                114.655183,
                                36.14025
                            ],
                            [
                                114.63719,
                                36.135642
                            ],
                            [
                                114.630395,
                                36.124241
                            ],
                            [
                                114.619449,
                                36.123513
                            ],
                            [
                                114.61083,
                                36.128316
                            ],
                            [
                                114.604664,
                                36.121426
                            ],
                            [
                                114.582582,
                                36.121329
                            ],
                            [
                                114.58686,
                                36.14093
                            ],
                            [
                                114.575473,
                                36.143258
                            ],
                            [
                                114.568049,
                                36.152328
                            ],
                            [
                                114.558046,
                                36.150776
                            ],
                            [
                                114.543639,
                                36.161786
                            ],
                            [
                                114.531686,
                                36.161931
                            ],
                            [
                                114.532881,
                                36.171533
                            ],
                            [
                                114.504948,
                                36.172406
                            ],
                            [
                                114.505577,
                                36.177497
                            ],
                            [
                                114.489598,
                                36.178467
                            ],
                            [
                                114.483873,
                                36.183848
                            ],
                            [
                                114.480287,
                                36.177788
                            ],
                            [
                                114.466194,
                                36.197713
                            ],
                            [
                                114.452291,
                                36.202367
                            ],
                            [
                                114.431152,
                                36.202609
                            ],
                            [
                                114.4175,
                                36.205905
                            ],
                            [
                                114.408441,
                                36.224563
                            ],
                            [
                                114.392335,
                                36.221123
                            ],
                            [
                                114.367548,
                                36.225533
                            ],
                            [
                                114.356098,
                                36.23033
                            ],
                            [
                                114.353833,
                                36.242636
                            ],
                            [
                                114.346787,
                                36.245494
                            ],
                            [
                                114.345151,
                                36.255812
                            ],
                            [
                                114.329234,
                                36.255909
                            ],
                            [
                                114.328353,
                                36.248159
                            ],
                            [
                                114.312814,
                                36.251646
                            ],
                            [
                                114.309983,
                                36.246754
                            ],
                            [
                                114.298973,
                                36.24593
                            ],
                            [
                                114.273871,
                                36.254747
                            ],
                            [
                                114.256445,
                                36.263998
                            ],
                            [
                                114.241031,
                                36.251356
                            ],
                            [
                                114.235558,
                                36.252761
                            ],
                            [
                                114.22373,
                                36.270875
                            ],
                            [
                                114.210645,
                                36.272764
                            ],
                            [
                                114.203095,
                                36.245736
                            ],
                            [
                                114.185165,
                                36.248449
                            ],
                            [
                                114.181139,
                                36.243314
                            ],
                            [
                                114.168871,
                                36.243411
                            ],
                            [
                                114.176672,
                                36.263126
                            ],
                            [
                                114.164844,
                                36.269567
                            ],
                            [
                                114.162831,
                                36.26516
                            ],
                            [
                                114.131438,
                                36.281674
                            ],
                            [
                                114.121435,
                                36.272715
                            ],
                            [
                                114.097528,
                                36.275233
                            ],
                            [
                                114.092621,
                                36.2778
                            ],
                            [
                                114.085386,
                                36.2701
                            ],
                            [
                                114.060536,
                                36.276493
                            ],
                            [
                                114.058271,
                                36.285354
                            ],
                            [
                                114.042606,
                                36.297313
                            ],
                            [
                                114.047953,
                                36.310334
                            ],
                            [
                                114.061542,
                                36.317982
                            ],
                            [
                                114.055692,
                                36.329984
                            ],
                            [
                                114.045185,
                                36.325919
                            ],
                            [
                                114.029017,
                                36.326548
                            ],
                            [
                                114.025997,
                                36.330516
                            ],
                            [
                                114.03254,
                                36.339904
                            ],
                            [
                                114.030841,
                                36.350742
                            ],
                            [
                                114.024676,
                                36.354854
                            ],
                            [
                                114.015176,
                                36.352967
                            ],
                            [
                                114.008507,
                                36.342517
                            ],
                            [
                                113.985859,
                                36.357563
                            ],
                            [
                                113.977932,
                                36.358579
                            ],
                            [
                                113.979819,
                                36.344113
                            ],
                            [
                                113.994478,
                                36.34421
                            ],
                            [
                                113.994352,
                                36.337049
                            ],
                            [
                                114.001964,
                                36.331339
                            ],
                            [
                                113.991647,
                                36.326839
                            ],
                            [
                                113.993849,
                                36.314594
                            ],
                            [
                                113.98221,
                                36.317692
                            ],
                            [
                                113.977869,
                                36.329258
                            ],
                            [
                                113.968495,
                                36.33971
                            ],
                            [
                                113.964217,
                                36.35258
                            ],
                            [
                                113.953207,
                                36.358192
                            ],
                            [
                                113.946727,
                                36.354805
                            ],
                            [
                                113.948804,
                                36.346097
                            ],
                            [
                                113.960317,
                                36.344742
                            ],
                            [
                                113.956101,
                                36.335597
                            ],
                            [
                                113.93446,
                                36.33613
                            ],
                            [
                                113.931629,
                                36.319482
                            ],
                            [
                                113.911182,
                                36.314788
                            ],
                            [
                                113.901116,
                                36.337001
                            ],
                            [
                                113.881487,
                                36.353886
                            ],
                            [
                                113.853617,
                                36.350113
                            ],
                            [
                                113.849339,
                                36.346823
                            ],
                            [
                                113.853995,
                                36.329742
                            ],
                            [
                                113.834177,
                                36.334339
                            ],
                            [
                                113.818261,
                                36.331146
                            ],
                            [
                                113.801274,
                                36.338355
                            ],
                            [
                                113.796808,
                                36.347548
                            ],
                            [
                                113.777431,
                                36.349822
                            ],
                            [
                                113.778626,
                                36.359788
                            ],
                            [
                                113.763401,
                                36.356015
                            ],
                            [
                                113.75516,
                                36.365931
                            ],
                            [
                                113.7422,
                                36.364432
                            ],
                            [
                                113.743269,
                                36.357563
                            ],
                            [
                                113.73314,
                                36.357079
                            ],
                            [
                                113.731442,
                                36.363367
                            ],
                            [
                                113.728736,
                                36.341452
                            ],
                            [
                                113.736412,
                                36.324709
                            ],
                            [
                                113.723326,
                                36.304865
                            ],
                            [
                                113.709045,
                                36.299733
                            ],
                            [
                                113.716217,
                                36.262593
                            ],
                            [
                                113.709108,
                                36.261528
                            ],
                            [
                                113.700552,
                                36.252276
                            ],
                            [
                                113.703886,
                                36.23784
                            ],
                            [
                                113.695204,
                                36.228779
                            ],
                            [
                                113.677274,
                                36.222528
                            ],
                            [
                                113.672178,
                                36.211963
                            ],
                            [
                                113.682055,
                                36.216277
                            ],
                            [
                                113.698476,
                                36.21429
                            ],
                            [
                                113.705396,
                                36.20067
                            ],
                            [
                                113.691492,
                                36.20193
                            ],
                            [
                                113.686334,
                                36.195483
                            ],
                            [
                                113.697909,
                                36.181861
                            ],
                            [
                                113.672304,
                                36.175606
                            ],
                            [
                                113.664503,
                                36.177449
                            ],
                            [
                                113.651669,
                                36.172212
                            ],
                            [
                                113.659973,
                                36.164162
                            ],
                            [
                                113.679287,
                                36.159943
                            ],
                            [
                                113.681363,
                                36.150728
                            ],
                            [
                                113.695582,
                                36.153201
                            ],
                            [
                                113.706843,
                                36.147381
                            ],
                            [
                                113.702628,
                                36.143209
                            ],
                            [
                                113.705648,
                                36.134138
                            ],
                            [
                                113.713763,
                                36.132974
                            ],
                            [
                                113.693191,
                                36.124192
                            ],
                            [
                                113.673499,
                                36.125357
                            ],
                            [
                                113.668529,
                                36.129675
                            ],
                            [
                                113.655507,
                                36.125114
                            ],
                            [
                                113.673814,
                                36.111625
                            ],
                            [
                                113.669284,
                                36.104005
                            ],
                            [
                                113.679539,
                                36.094007
                            ],
                            [
                                113.684069,
                                36.078328
                            ],
                            [
                                113.68237,
                                36.066821
                            ],
                            [
                                113.685767,
                                36.055992
                            ],
                            [
                                113.668655,
                                36.049096
                            ],
                            [
                                113.66142,
                                36.04288
                            ],
                            [
                                113.660414,
                                36.034671
                            ],
                            [
                                113.670165,
                                36.029522
                            ],
                            [
                                113.695141,
                                36.026753
                            ],
                            [
                                113.695204,
                                36.018202
                            ],
                            [
                                113.680734,
                                36.014801
                            ],
                            [
                                113.695896,
                                35.999884
                            ],
                            [
                                113.686459,
                                35.986421
                            ],
                            [
                                113.678784,
                                35.98579
                            ],
                            [
                                113.648901,
                                35.994149
                            ],
                            [
                                113.637828,
                                35.988463
                            ],
                            [
                                113.636884,
                                35.975874
                            ],
                            [
                                113.647831,
                                35.967123
                            ],
                            [
                                113.653997,
                                35.93143
                            ],
                            [
                                113.654437,
                                35.917227
                            ],
                            [
                                113.648712,
                                35.908518
                            ],
                            [
                                113.637388,
                                35.869928
                            ],
                            [
                                113.644056,
                                35.854885
                            ],
                            [
                                113.658212,
                                35.853911
                            ],
                            [
                                113.661043,
                                35.837259
                            ],
                            [
                                113.700552,
                                35.837308
                            ],
                            [
                                113.709108,
                                35.833655
                            ],
                            [
                                113.705962,
                                35.826594
                            ],
                            [
                                113.711813,
                                35.81807
                            ],
                            [
                                113.726786,
                                35.823185
                            ],
                            [
                                113.731819,
                                35.818752
                            ],
                            [
                                113.742892,
                                35.819093
                            ],
                            [
                                113.756229,
                                35.793713
                            ],
                            [
                                113.751888,
                                35.788304
                            ],
                            [
                                113.757865,
                                35.782798
                            ],
                            [
                                113.759752,
                                35.767398
                            ],
                            [
                                113.778563,
                                35.763206
                            ],
                            [
                                113.776613,
                                35.759404
                            ],
                            [
                                113.800205,
                                35.740782
                            ],
                            [
                                113.808006,
                                35.742488
                            ],
                            [
                                113.801652,
                                35.733517
                            ],
                            [
                                113.799953,
                                35.713572
                            ],
                            [
                                113.794228,
                                35.695329
                            ],
                            [
                                113.777556,
                                35.684644
                            ],
                            [
                                113.785546,
                                35.674447
                            ],
                            [
                                113.806244,
                                35.672983
                            ],
                            [
                                113.811529,
                                35.676838
                            ],
                            [
                                113.843677,
                                35.677814
                            ],
                            [
                                113.859216,
                                35.682351
                            ],
                            [
                                113.868402,
                                35.680741
                            ],
                            [
                                113.886332,
                                35.684401
                            ],
                            [
                                113.901619,
                                35.677423
                            ],
                            [
                                113.923072,
                                35.681815
                            ],
                            [
                                113.927476,
                                35.686011
                            ],
                            [
                                113.931691,
                                35.703963
                            ],
                            [
                                113.949055,
                                35.70089
                            ],
                            [
                                113.956227,
                                35.691426
                            ],
                            [
                                113.969565,
                                35.689572
                            ],
                            [
                                113.98523,
                                35.700743
                            ],
                            [
                                113.995988,
                                35.704792
                            ],
                            [
                                113.998316,
                                35.719814
                            ],
                            [
                                114.002468,
                                35.724788
                            ],
                            [
                                114.017567,
                                35.72591
                            ],
                            [
                                114.032854,
                                35.737028
                            ],
                            [
                                114.042983,
                                35.748095
                            ],
                            [
                                114.055377,
                                35.749216
                            ],
                            [
                                114.067267,
                                35.759112
                            ],
                            [
                                114.066575,
                                35.775391
                            ],
                            [
                                114.071357,
                                35.779679
                            ],
                            [
                                114.078151,
                                35.803018
                            ],
                            [
                                114.069155,
                                35.805259
                            ],
                            [
                                114.051414,
                                35.797513
                            ],
                            [
                                114.037132,
                                35.80331
                            ],
                            [
                                114.025179,
                                35.797074
                            ],
                            [
                                114.022537,
                                35.804285
                            ],
                            [
                                114.035685,
                                35.818411
                            ],
                            [
                                114.035937,
                                35.824548
                            ],
                            [
                                114.025619,
                                35.829419
                            ],
                            [
                                114.014987,
                                35.845001
                            ],
                            [
                                114.013981,
                                35.852548
                            ],
                            [
                                114.019957,
                                35.858634
                            ],
                            [
                                114.038642,
                                35.859461
                            ],
                            [
                                114.056698,
                                35.870268
                            ],
                            [
                                114.070287,
                                35.873189
                            ],
                            [
                                114.075131,
                                35.880928
                            ],
                            [
                                114.07488,
                                35.904383
                            ],
                            [
                                114.081611,
                                35.915086
                            ],
                            [
                                114.052735,
                                35.93109
                            ],
                            [
                                114.040467,
                                35.935662
                            ],
                            [
                                114.038768,
                                35.944319
                            ],
                            [
                                114.028828,
                                35.950494
                            ],
                            [
                                114.030464,
                                35.97179
                            ],
                            [
                                114.044619,
                                35.972276
                            ],
                            [
                                114.065506,
                                35.964109
                            ],
                            [
                                114.073055,
                                35.974512
                            ],
                            [
                                114.084002,
                                35.974415
                            ],
                            [
                                114.094571,
                                35.981075
                            ],
                            [
                                114.108035,
                                35.981852
                            ],
                            [
                                114.103505,
                                35.995267
                            ],
                            [
                                114.111306,
                                36.017085
                            ],
                            [
                                114.121687,
                                36.027044
                            ],
                            [
                                114.135716,
                                36.031562
                            ],
                            [
                                114.158931,
                                36.047299
                            ],
                            [
                                114.175225,
                                36.052107
                            ],
                            [
                                114.179251,
                                36.039431
                            ],
                            [
                                114.174847,
                                36.031319
                            ],
                            [
                                114.178245,
                                36.013198
                            ],
                            [
                                114.169877,
                                36.000856
                            ],
                            [
                                114.174847,
                                35.988803
                            ],
                            [
                                114.181768,
                                35.982873
                            ],
                            [
                                114.191771,
                                35.981415
                            ],
                            [
                                114.197559,
                                35.990115
                            ],
                            [
                                114.205045,
                                35.988657
                            ],
                            [
                                114.218005,
                                35.997648
                            ],
                            [
                                114.223604,
                                35.981707
                            ],
                            [
                                114.251412,
                                35.971936
                            ],
                            [
                                114.279974,
                                35.972811
                            ],
                            [
                                114.279974,
                                35.947382
                            ],
                            [
                                114.296897,
                                35.957885
                            ],
                            [
                                114.309291,
                                35.952731
                            ],
                            [
                                114.293626,
                                35.938288
                            ],
                            [
                                114.303,
                                35.930604
                            ],
                            [
                                114.295576,
                                35.924621
                            ],
                            [
                                114.290166,
                                35.928853
                            ],
                            [
                                114.277206,
                                35.924475
                            ],
                            [
                                114.270789,
                                35.899858
                            ],
                            [
                                114.280855,
                                35.892315
                            ],
                            [
                                114.274626,
                                35.882242
                            ],
                            [
                                114.250908,
                                35.876791
                            ],
                            [
                                114.244303,
                                35.871875
                            ],
                            [
                                114.243044,
                                35.863259
                            ],
                            [
                                114.234425,
                                35.855956
                            ],
                            [
                                114.229204,
                                35.841057
                            ],
                            [
                                114.237005,
                                35.809156
                            ],
                            [
                                114.241786,
                                35.806526
                            ],
                            [
                                114.24317,
                                35.793079
                            ],
                            [
                                114.250845,
                                35.793566
                            ],
                            [
                                114.263365,
                                35.774416
                            ],
                            [
                                114.25569,
                                35.774416
                            ],
                            [
                                114.255249,
                                35.767349
                            ],
                            [
                                114.270411,
                                35.76072
                            ],
                            [
                                114.284315,
                                35.783285
                            ],
                            [
                                114.294632,
                                35.794346
                            ],
                            [
                                114.328353,
                                35.802141
                            ],
                            [
                                114.350373,
                                35.816025
                            ],
                            [
                                114.364717,
                                35.818947
                            ],
                            [
                                114.396802,
                                35.816804
                            ],
                            [
                                114.408441,
                                35.820749
                            ],
                            [
                                114.43845,
                                35.817437
                            ],
                            [
                                114.445811,
                                35.819191
                            ],
                            [
                                114.451347,
                                35.828737
                            ],
                            [
                                114.47085,
                                35.827471
                            ],
                            [
                                114.478273,
                                35.834824
                            ],
                            [
                                114.509478,
                                35.836723
                            ],
                            [
                                114.55295,
                                35.828201
                            ],
                            [
                                114.566476,
                                35.843735
                            ],
                            [
                                114.57044,
                                35.835993
                            ],
                            [
                                114.587552,
                                35.840083
                            ],
                            [
                                114.597618,
                                35.825181
                            ],
                            [
                                114.611647,
                                35.82221
                            ],
                            [
                                114.613849,
                                35.808085
                            ],
                            [
                                114.636561,
                                35.794054
                            ],
                            [
                                114.658706,
                                35.791471
                            ],
                            [
                                114.675252,
                                35.782067
                            ],
                            [
                                114.695572,
                                35.78733
                            ],
                            [
                                114.709224,
                                35.787427
                            ],
                            [
                                114.719857,
                                35.778363
                            ],
                            [
                                114.751439,
                                35.763352
                            ],
                            [
                                114.753389,
                                35.753018
                            ],
                            [
                                114.751439,
                                35.737661
                            ],
                            [
                                114.735648,
                                35.708645
                            ],
                            [
                                114.727029,
                                35.697865
                            ],
                            [
                                114.707903,
                                35.694304
                            ],
                            [
                                114.705638,
                                35.689523
                            ],
                            [
                                114.687897,
                                35.684157
                            ],
                            [
                                114.677454,
                                35.671031
                            ],
                            [
                                114.672924,
                                35.65395
                            ],
                            [
                                114.660719,
                                35.651119
                            ],
                            [
                                114.645243,
                                35.654828
                            ],
                            [
                                114.618694,
                                35.647458
                            ],
                            [
                                114.615611,
                                35.636572
                            ],
                            [
                                114.591704,
                                35.629054
                            ],
                            [
                                114.576857,
                                35.616798
                            ],
                            [
                                114.558361,
                                35.613477
                            ],
                            [
                                114.549301,
                                35.614796
                            ],
                            [
                                114.54345,
                                35.602635
                            ],
                            [
                                114.502558,
                                35.609277
                            ],
                            [
                                114.495008,
                                35.600047
                            ],
                            [
                                114.500167,
                                35.593404
                            ],
                            [
                                114.497587,
                                35.584123
                            ],
                            [
                                114.482677,
                                35.584416
                            ],
                            [
                                114.486137,
                                35.573033
                            ],
                            [
                                114.476071,
                                35.565215
                            ],
                            [
                                114.455499,
                                35.557641
                            ],
                            [
                                114.426182,
                                35.54425
                            ],
                            [
                                114.416871,
                                35.533839
                            ],
                            [
                                114.402275,
                                35.526018
                            ],
                            [
                                114.39504,
                                35.508857
                            ],
                            [
                                114.409259,
                                35.489149
                            ],
                            [
                                114.420394,
                                35.483769
                            ],
                            [
                                114.419073,
                                35.474181
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 410600,
                "name": "鹤壁市",
                "center": [
                    114.295444,
                    35.748236
                ],
                "centroid": [
                    114.31602,
                    35.721499
                ],
                "childrenNum": 5,
                "level": "city",
                "parent": {
                    "adcode": 410000
                },
                "subFeatureIndex": 5,
                "acroutes": [
                    100000,
                    410000
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                113.995988,
                                35.704792
                            ],
                            [
                                114.019769,
                                35.695621
                            ],
                            [
                                114.026815,
                                35.683766
                            ],
                            [
                                114.039838,
                                35.681522
                            ],
                            [
                                114.050218,
                                35.675667
                            ],
                            [
                                114.059026,
                                35.657366
                            ],
                            [
                                114.064311,
                                35.637793
                            ],
                            [
                                114.058523,
                                35.62671
                            ],
                            [
                                114.060284,
                                35.611377
                            ],
                            [
                                114.056195,
                                35.594528
                            ],
                            [
                                114.072804,
                                35.579629
                            ],
                            [
                                114.080102,
                                35.567316
                            ],
                            [
                                114.104889,
                                35.554269
                            ],
                            [
                                114.120114,
                                35.551142
                            ],
                            [
                                114.139176,
                                35.538336
                            ],
                            [
                                114.17145,
                                35.523965
                            ],
                            [
                                114.19196,
                                35.521862
                            ],
                            [
                                114.202214,
                                35.524845
                            ],
                            [
                                114.215615,
                                35.51756
                            ],
                            [
                                114.224863,
                                35.516533
                            ],
                            [
                                114.259842,
                                35.504945
                            ],
                            [
                                114.276325,
                                35.501277
                            ],
                            [
                                114.289914,
                                35.501815
                            ],
                            [
                                114.283686,
                                35.492181
                            ],
                            [
                                114.275822,
                                35.490176
                            ],
                            [
                                114.27255,
                                35.476187
                            ],
                            [
                                114.275444,
                                35.465376
                            ],
                            [
                                114.29803,
                                35.458722
                            ],
                            [
                                114.312374,
                                35.446978
                            ],
                            [
                                114.324012,
                                35.444531
                            ],
                            [
                                114.339426,
                                35.450648
                            ],
                            [
                                114.343704,
                                35.462147
                            ],
                            [
                                114.360439,
                                35.4688
                            ],
                            [
                                114.370001,
                                35.461755
                            ],
                            [
                                114.382018,
                                35.46655
                            ],
                            [
                                114.38466,
                                35.475355
                            ],
                            [
                                114.39504,
                                35.478192
                            ],
                            [
                                114.409699,
                                35.469191
                            ],
                            [
                                114.419073,
                                35.474181
                            ],
                            [
                                114.420394,
                                35.483769
                            ],
                            [
                                114.409259,
                                35.489149
                            ],
                            [
                                114.39504,
                                35.508857
                            ],
                            [
                                114.402275,
                                35.526018
                            ],
                            [
                                114.416871,
                                35.533839
                            ],
                            [
                                114.426182,
                                35.54425
                            ],
                            [
                                114.455499,
                                35.557641
                            ],
                            [
                                114.476071,
                                35.565215
                            ],
                            [
                                114.486137,
                                35.573033
                            ],
                            [
                                114.482677,
                                35.584416
                            ],
                            [
                                114.497587,
                                35.584123
                            ],
                            [
                                114.500167,
                                35.593404
                            ],
                            [
                                114.495008,
                                35.600047
                            ],
                            [
                                114.502558,
                                35.609277
                            ],
                            [
                                114.54345,
                                35.602635
                            ],
                            [
                                114.549301,
                                35.614796
                            ],
                            [
                                114.558361,
                                35.613477
                            ],
                            [
                                114.576857,
                                35.616798
                            ],
                            [
                                114.591704,
                                35.629054
                            ],
                            [
                                114.615611,
                                35.636572
                            ],
                            [
                                114.618694,
                                35.647458
                            ],
                            [
                                114.645243,
                                35.654828
                            ],
                            [
                                114.660719,
                                35.651119
                            ],
                            [
                                114.672924,
                                35.65395
                            ],
                            [
                                114.677454,
                                35.671031
                            ],
                            [
                                114.687897,
                                35.684157
                            ],
                            [
                                114.705638,
                                35.689523
                            ],
                            [
                                114.707903,
                                35.694304
                            ],
                            [
                                114.727029,
                                35.697865
                            ],
                            [
                                114.735648,
                                35.708645
                            ],
                            [
                                114.751439,
                                35.737661
                            ],
                            [
                                114.753389,
                                35.753018
                            ],
                            [
                                114.751439,
                                35.763352
                            ],
                            [
                                114.719857,
                                35.778363
                            ],
                            [
                                114.709224,
                                35.787427
                            ],
                            [
                                114.695572,
                                35.78733
                            ],
                            [
                                114.675252,
                                35.782067
                            ],
                            [
                                114.658706,
                                35.791471
                            ],
                            [
                                114.636561,
                                35.794054
                            ],
                            [
                                114.613849,
                                35.808085
                            ],
                            [
                                114.611647,
                                35.82221
                            ],
                            [
                                114.597618,
                                35.825181
                            ],
                            [
                                114.587552,
                                35.840083
                            ],
                            [
                                114.57044,
                                35.835993
                            ],
                            [
                                114.566476,
                                35.843735
                            ],
                            [
                                114.55295,
                                35.828201
                            ],
                            [
                                114.509478,
                                35.836723
                            ],
                            [
                                114.478273,
                                35.834824
                            ],
                            [
                                114.47085,
                                35.827471
                            ],
                            [
                                114.451347,
                                35.828737
                            ],
                            [
                                114.445811,
                                35.819191
                            ],
                            [
                                114.43845,
                                35.817437
                            ],
                            [
                                114.408441,
                                35.820749
                            ],
                            [
                                114.396802,
                                35.816804
                            ],
                            [
                                114.364717,
                                35.818947
                            ],
                            [
                                114.350373,
                                35.816025
                            ],
                            [
                                114.328353,
                                35.802141
                            ],
                            [
                                114.294632,
                                35.794346
                            ],
                            [
                                114.284315,
                                35.783285
                            ],
                            [
                                114.270411,
                                35.76072
                            ],
                            [
                                114.255249,
                                35.767349
                            ],
                            [
                                114.25569,
                                35.774416
                            ],
                            [
                                114.263365,
                                35.774416
                            ],
                            [
                                114.250845,
                                35.793566
                            ],
                            [
                                114.24317,
                                35.793079
                            ],
                            [
                                114.241786,
                                35.806526
                            ],
                            [
                                114.237005,
                                35.809156
                            ],
                            [
                                114.229204,
                                35.841057
                            ],
                            [
                                114.234425,
                                35.855956
                            ],
                            [
                                114.243044,
                                35.863259
                            ],
                            [
                                114.244303,
                                35.871875
                            ],
                            [
                                114.250908,
                                35.876791
                            ],
                            [
                                114.274626,
                                35.882242
                            ],
                            [
                                114.280855,
                                35.892315
                            ],
                            [
                                114.270789,
                                35.899858
                            ],
                            [
                                114.277206,
                                35.924475
                            ],
                            [
                                114.290166,
                                35.928853
                            ],
                            [
                                114.295576,
                                35.924621
                            ],
                            [
                                114.303,
                                35.930604
                            ],
                            [
                                114.293626,
                                35.938288
                            ],
                            [
                                114.309291,
                                35.952731
                            ],
                            [
                                114.296897,
                                35.957885
                            ],
                            [
                                114.279974,
                                35.947382
                            ],
                            [
                                114.279974,
                                35.972811
                            ],
                            [
                                114.251412,
                                35.971936
                            ],
                            [
                                114.223604,
                                35.981707
                            ],
                            [
                                114.218005,
                                35.997648
                            ],
                            [
                                114.205045,
                                35.988657
                            ],
                            [
                                114.197559,
                                35.990115
                            ],
                            [
                                114.191771,
                                35.981415
                            ],
                            [
                                114.181768,
                                35.982873
                            ],
                            [
                                114.174847,
                                35.988803
                            ],
                            [
                                114.169877,
                                36.000856
                            ],
                            [
                                114.178245,
                                36.013198
                            ],
                            [
                                114.174847,
                                36.031319
                            ],
                            [
                                114.179251,
                                36.039431
                            ],
                            [
                                114.175225,
                                36.052107
                            ],
                            [
                                114.158931,
                                36.047299
                            ],
                            [
                                114.135716,
                                36.031562
                            ],
                            [
                                114.121687,
                                36.027044
                            ],
                            [
                                114.111306,
                                36.017085
                            ],
                            [
                                114.103505,
                                35.995267
                            ],
                            [
                                114.108035,
                                35.981852
                            ],
                            [
                                114.094571,
                                35.981075
                            ],
                            [
                                114.084002,
                                35.974415
                            ],
                            [
                                114.073055,
                                35.974512
                            ],
                            [
                                114.065506,
                                35.964109
                            ],
                            [
                                114.044619,
                                35.972276
                            ],
                            [
                                114.030464,
                                35.97179
                            ],
                            [
                                114.028828,
                                35.950494
                            ],
                            [
                                114.038768,
                                35.944319
                            ],
                            [
                                114.040467,
                                35.935662
                            ],
                            [
                                114.052735,
                                35.93109
                            ],
                            [
                                114.081611,
                                35.915086
                            ],
                            [
                                114.07488,
                                35.904383
                            ],
                            [
                                114.075131,
                                35.880928
                            ],
                            [
                                114.070287,
                                35.873189
                            ],
                            [
                                114.056698,
                                35.870268
                            ],
                            [
                                114.038642,
                                35.859461
                            ],
                            [
                                114.019957,
                                35.858634
                            ],
                            [
                                114.013981,
                                35.852548
                            ],
                            [
                                114.014987,
                                35.845001
                            ],
                            [
                                114.025619,
                                35.829419
                            ],
                            [
                                114.035937,
                                35.824548
                            ],
                            [
                                114.035685,
                                35.818411
                            ],
                            [
                                114.022537,
                                35.804285
                            ],
                            [
                                114.025179,
                                35.797074
                            ],
                            [
                                114.037132,
                                35.80331
                            ],
                            [
                                114.051414,
                                35.797513
                            ],
                            [
                                114.069155,
                                35.805259
                            ],
                            [
                                114.078151,
                                35.803018
                            ],
                            [
                                114.071357,
                                35.779679
                            ],
                            [
                                114.066575,
                                35.775391
                            ],
                            [
                                114.067267,
                                35.759112
                            ],
                            [
                                114.055377,
                                35.749216
                            ],
                            [
                                114.042983,
                                35.748095
                            ],
                            [
                                114.032854,
                                35.737028
                            ],
                            [
                                114.017567,
                                35.72591
                            ],
                            [
                                114.002468,
                                35.724788
                            ],
                            [
                                113.998316,
                                35.719814
                            ],
                            [
                                113.995988,
                                35.704792
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 410700,
                "name": "新乡市",
                "center": [
                    113.883991,
                    35.302616
                ],
                "centroid": [
                    114.095247,
                    35.263966
                ],
                "childrenNum": 12,
                "level": "city",
                "parent": {
                    "adcode": 410000
                },
                "subFeatureIndex": 6,
                "acroutes": [
                    100000,
                    410000
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                114.951248,
                                35.380791
                            ],
                            [
                                114.898087,
                                35.390781
                            ],
                            [
                                114.879339,
                                35.387452
                            ],
                            [
                                114.856942,
                                35.387794
                            ],
                            [
                                114.809632,
                                35.354242
                            ],
                            [
                                114.808877,
                                35.346942
                            ],
                            [
                                114.783964,
                                35.343023
                            ],
                            [
                                114.76163,
                                35.345228
                            ],
                            [
                                114.754521,
                                35.341308
                            ],
                            [
                                114.73722,
                                35.344689
                            ],
                            [
                                114.718598,
                                35.343611
                            ],
                            [
                                114.697397,
                                35.337486
                            ],
                            [
                                114.701675,
                                35.329008
                            ],
                            [
                                114.698341,
                                35.306756
                            ],
                            [
                                114.688715,
                                35.295138
                            ],
                            [
                                114.679907,
                                35.291166
                            ],
                            [
                                114.663173,
                                35.291559
                            ],
                            [
                                114.642915,
                                35.297148
                            ],
                            [
                                114.627313,
                                35.298275
                            ],
                            [
                                114.607495,
                                35.292686
                            ],
                            [
                                114.5968,
                                35.286116
                            ],
                            [
                                114.562198,
                                35.276064
                            ],
                            [
                                114.549364,
                                35.261891
                            ],
                            [
                                114.541437,
                                35.242809
                            ],
                            [
                                114.527093,
                                35.235646
                            ],
                            [
                                114.50413,
                                35.228286
                            ],
                            [
                                114.494756,
                                35.220141
                            ],
                            [
                                114.487836,
                                35.206645
                            ],
                            [
                                114.465376,
                                35.216706
                            ],
                            [
                                114.4499,
                                35.214448
                            ],
                            [
                                114.442602,
                                35.205958
                            ],
                            [
                                114.431781,
                                35.208755
                            ],
                            [
                                114.431404,
                                35.222055
                            ],
                            [
                                114.415298,
                                35.228188
                            ],
                            [
                                114.399696,
                                35.225097
                            ],
                            [
                                114.394348,
                                35.219797
                            ],
                            [
                                114.392146,
                                35.226912
                            ],
                            [
                                114.407497,
                                35.236627
                            ],
                            [
                                114.396299,
                                35.241828
                            ],
                            [
                                114.391266,
                                35.258114
                            ],
                            [
                                114.395481,
                                35.26449
                            ],
                            [
                                114.407497,
                                35.269738
                            ],
                            [
                                114.395732,
                                35.293078
                            ],
                            [
                                114.408189,
                                35.29249
                            ],
                            [
                                114.416493,
                                35.302785
                            ],
                            [
                                114.412782,
                                35.313521
                            ],
                            [
                                114.403659,
                                35.316805
                            ],
                            [
                                114.404226,
                                35.326313
                            ],
                            [
                                114.423414,
                                35.324842
                            ],
                            [
                                114.429076,
                                35.342876
                            ],
                            [
                                114.411083,
                                35.358064
                            ],
                            [
                                114.413474,
                                35.370163
                            ],
                            [
                                114.423666,
                                35.380155
                            ],
                            [
                                114.415172,
                                35.413255
                            ],
                            [
                                114.407686,
                                35.418004
                            ],
                            [
                                114.405043,
                                35.426325
                            ],
                            [
                                114.412027,
                                35.43582
                            ],
                            [
                                114.429139,
                                35.449523
                            ],
                            [
                                114.428573,
                                35.468947
                            ],
                            [
                                114.419073,
                                35.474181
                            ],
                            [
                                114.409699,
                                35.469191
                            ],
                            [
                                114.39504,
                                35.478192
                            ],
                            [
                                114.38466,
                                35.475355
                            ],
                            [
                                114.382018,
                                35.46655
                            ],
                            [
                                114.370001,
                                35.461755
                            ],
                            [
                                114.360439,
                                35.4688
                            ],
                            [
                                114.343704,
                                35.462147
                            ],
                            [
                                114.339426,
                                35.450648
                            ],
                            [
                                114.324012,
                                35.444531
                            ],
                            [
                                114.312374,
                                35.446978
                            ],
                            [
                                114.29803,
                                35.458722
                            ],
                            [
                                114.275444,
                                35.465376
                            ],
                            [
                                114.27255,
                                35.476187
                            ],
                            [
                                114.275822,
                                35.490176
                            ],
                            [
                                114.283686,
                                35.492181
                            ],
                            [
                                114.289914,
                                35.501815
                            ],
                            [
                                114.276325,
                                35.501277
                            ],
                            [
                                114.259842,
                                35.504945
                            ],
                            [
                                114.224863,
                                35.516533
                            ],
                            [
                                114.215615,
                                35.51756
                            ],
                            [
                                114.202214,
                                35.524845
                            ],
                            [
                                114.19196,
                                35.521862
                            ],
                            [
                                114.17145,
                                35.523965
                            ],
                            [
                                114.139176,
                                35.538336
                            ],
                            [
                                114.120114,
                                35.551142
                            ],
                            [
                                114.104889,
                                35.554269
                            ],
                            [
                                114.080102,
                                35.567316
                            ],
                            [
                                114.072804,
                                35.579629
                            ],
                            [
                                114.056195,
                                35.594528
                            ],
                            [
                                114.060284,
                                35.611377
                            ],
                            [
                                114.058523,
                                35.62671
                            ],
                            [
                                114.064311,
                                35.637793
                            ],
                            [
                                114.059026,
                                35.657366
                            ],
                            [
                                114.050218,
                                35.675667
                            ],
                            [
                                114.039838,
                                35.681522
                            ],
                            [
                                114.026815,
                                35.683766
                            ],
                            [
                                114.019769,
                                35.695621
                            ],
                            [
                                113.995988,
                                35.704792
                            ],
                            [
                                113.98523,
                                35.700743
                            ],
                            [
                                113.969565,
                                35.689572
                            ],
                            [
                                113.956227,
                                35.691426
                            ],
                            [
                                113.949055,
                                35.70089
                            ],
                            [
                                113.931691,
                                35.703963
                            ],
                            [
                                113.927476,
                                35.686011
                            ],
                            [
                                113.923072,
                                35.681815
                            ],
                            [
                                113.901619,
                                35.677423
                            ],
                            [
                                113.886332,
                                35.684401
                            ],
                            [
                                113.868402,
                                35.680741
                            ],
                            [
                                113.859216,
                                35.682351
                            ],
                            [
                                113.843677,
                                35.677814
                            ],
                            [
                                113.811529,
                                35.676838
                            ],
                            [
                                113.806244,
                                35.672983
                            ],
                            [
                                113.785546,
                                35.674447
                            ],
                            [
                                113.777556,
                                35.684644
                            ],
                            [
                                113.794228,
                                35.695329
                            ],
                            [
                                113.799953,
                                35.713572
                            ],
                            [
                                113.801652,
                                35.733517
                            ],
                            [
                                113.808006,
                                35.742488
                            ],
                            [
                                113.800205,
                                35.740782
                            ],
                            [
                                113.776613,
                                35.759404
                            ],
                            [
                                113.778563,
                                35.763206
                            ],
                            [
                                113.759752,
                                35.767398
                            ],
                            [
                                113.757865,
                                35.782798
                            ],
                            [
                                113.751888,
                                35.788304
                            ],
                            [
                                113.756229,
                                35.793713
                            ],
                            [
                                113.742892,
                                35.819093
                            ],
                            [
                                113.731819,
                                35.818752
                            ],
                            [
                                113.726786,
                                35.823185
                            ],
                            [
                                113.711813,
                                35.81807
                            ],
                            [
                                113.705962,
                                35.826594
                            ],
                            [
                                113.709108,
                                35.833655
                            ],
                            [
                                113.700552,
                                35.837308
                            ],
                            [
                                113.661043,
                                35.837259
                            ],
                            [
                                113.650285,
                                35.826594
                            ],
                            [
                                113.641225,
                                35.822503
                            ],
                            [
                                113.623799,
                                35.831513
                            ],
                            [
                                113.606057,
                                35.82372
                            ],
                            [
                                113.585296,
                                35.825766
                            ],
                            [
                                113.582906,
                                35.818314
                            ],
                            [
                                113.588945,
                                35.813443
                            ],
                            [
                                113.586177,
                                35.806136
                            ],
                            [
                                113.604988,
                                35.800095
                            ],
                            [
                                113.583472,
                                35.794249
                            ],
                            [
                                113.583157,
                                35.786794
                            ],
                            [
                                113.592972,
                                35.789669
                            ],
                            [
                                113.599137,
                                35.775098
                            ],
                            [
                                113.595929,
                                35.759063
                            ],
                            [
                                113.586806,
                                35.744048
                            ],
                            [
                                113.591147,
                                35.727958
                            ],
                            [
                                113.601968,
                                35.706402
                            ],
                            [
                                113.59316,
                                35.691426
                            ],
                            [
                                113.614928,
                                35.682986
                            ],
                            [
                                113.623484,
                                35.671665
                            ],
                            [
                                113.61908,
                                35.667225
                            ],
                            [
                                113.624994,
                                35.652388
                            ],
                            [
                                113.624868,
                                35.632032
                            ],
                            [
                                113.591965,
                                35.631543
                            ],
                            [
                                113.578565,
                                35.633545
                            ],
                            [
                                113.572966,
                                35.646775
                            ],
                            [
                                113.565416,
                                35.64492
                            ],
                            [
                                113.560069,
                                35.660441
                            ],
                            [
                                113.547989,
                                35.657562
                            ],
                            [
                                113.547423,
                                35.648629
                            ],
                            [
                                113.553337,
                                35.63872
                            ],
                            [
                                113.556671,
                                35.619776
                            ],
                            [
                                113.547172,
                                35.616847
                            ],
                            [
                                113.542453,
                                35.596774
                            ],
                            [
                                113.533016,
                                35.594039
                            ],
                            [
                                113.529556,
                                35.587787
                            ],
                            [
                                113.506719,
                                35.565997
                            ],
                            [
                                113.506593,
                                35.5486
                            ],
                            [
                                113.49854,
                                35.532373
                            ],
                            [
                                113.508669,
                                35.523427
                            ],
                            [
                                113.506593,
                                35.516484
                            ],
                            [
                                113.491997,
                                35.516484
                            ],
                            [
                                113.485392,
                                35.520738
                            ],
                            [
                                113.462555,
                                35.515555
                            ],
                            [
                                113.440535,
                                35.507879
                            ],
                            [
                                113.416629,
                                35.516191
                            ],
                            [
                                113.401404,
                                35.50695
                            ],
                            [
                                113.391778,
                                35.506852
                            ],
                            [
                                113.383159,
                                35.495067
                            ],
                            [
                                113.390772,
                                35.485774
                            ],
                            [
                                113.392093,
                                35.472225
                            ],
                            [
                                113.404046,
                                35.46151
                            ],
                            [
                                113.427638,
                                35.448887
                            ],
                            [
                                113.447707,
                                35.432443
                            ],
                            [
                                113.458843,
                                35.413304
                            ],
                            [
                                113.462366,
                                35.396853
                            ],
                            [
                                113.482246,
                                35.369967
                            ],
                            [
                                113.476207,
                                35.363942
                            ],
                            [
                                113.465952,
                                35.363844
                            ],
                            [
                                113.469978,
                                35.353214
                            ],
                            [
                                113.466581,
                                35.349686
                            ],
                            [
                                113.480044,
                                35.33974
                            ],
                            [
                                113.478157,
                                35.327195
                            ],
                            [
                                113.485014,
                                35.316265
                            ],
                            [
                                113.486461,
                                35.294108
                            ],
                            [
                                113.511878,
                                35.293961
                            ],
                            [
                                113.518798,
                                35.288813
                            ],
                            [
                                113.523265,
                                35.263656
                            ],
                            [
                                113.538804,
                                35.243201
                            ],
                            [
                                113.54044,
                                35.228384
                            ],
                            [
                                113.528172,
                                35.220141
                            ],
                            [
                                113.52144,
                                35.211504
                            ],
                            [
                                113.521063,
                                35.192901
                            ],
                            [
                                113.532828,
                                35.164572
                            ],
                            [
                                113.534967,
                                35.151803
                            ],
                            [
                                113.542642,
                                35.144632
                            ],
                            [
                                113.565102,
                                35.137461
                            ],
                            [
                                113.564598,
                                35.127685
                            ],
                            [
                                113.593852,
                                35.131173
                            ],
                            [
                                113.60027,
                                35.120709
                            ],
                            [
                                113.607064,
                                35.099284
                            ],
                            [
                                113.620464,
                                35.068513
                            ],
                            [
                                113.645503,
                                35.038075
                            ],
                            [
                                113.645503,
                                35.019236
                            ],
                            [
                                113.629964,
                                35.016777
                            ],
                            [
                                113.634431,
                                35.008167
                            ],
                            [
                                113.644371,
                                35.004379
                            ],
                            [
                                113.634494,
                                34.997687
                            ],
                            [
                                113.617696,
                                34.992175
                            ],
                            [
                                113.60763,
                                34.982382
                            ],
                            [
                                113.595299,
                                34.961857
                            ],
                            [
                                113.592091,
                                34.933743
                            ],
                            [
                                113.631348,
                                34.929311
                            ],
                            [
                                113.650348,
                                34.928769
                            ],
                            [
                                113.665069,
                                34.918525
                            ],
                            [
                                113.670731,
                                34.910299
                            ],
                            [
                                113.684824,
                                34.906358
                            ],
                            [
                                113.716846,
                                34.913402
                            ],
                            [
                                113.725528,
                                34.917392
                            ],
                            [
                                113.749057,
                                34.919017
                            ],
                            [
                                113.766106,
                                34.91488
                            ],
                            [
                                113.777116,
                                34.905028
                            ],
                            [
                                113.78649,
                                34.890445
                            ],
                            [
                                113.800456,
                                34.87995
                            ],
                            [
                                113.826062,
                                34.877683
                            ],
                            [
                                113.870163,
                                34.885666
                            ],
                            [
                                113.905331,
                                34.901333
                            ],
                            [
                                113.953585,
                                34.898082
                            ],
                            [
                                113.973654,
                                34.910447
                            ],
                            [
                                113.985293,
                                34.928276
                            ],
                            [
                                114.018385,
                                34.958608
                            ],
                            [
                                114.028451,
                                34.959346
                            ],
                            [
                                114.051225,
                                34.944527
                            ],
                            [
                                114.080542,
                                34.944527
                            ],
                            [
                                114.101869,
                                34.954768
                            ],
                            [
                                114.120491,
                                34.956638
                            ],
                            [
                                114.160566,
                                34.933496
                            ],
                            [
                                114.172834,
                                34.931871
                            ],
                            [
                                114.200704,
                                34.939504
                            ],
                            [
                                114.208505,
                                34.926602
                            ],
                            [
                                114.22071,
                                34.919066
                            ],
                            [
                                114.226624,
                                34.913156
                            ],
                            [
                                114.243988,
                                34.905126
                            ],
                            [
                                114.284441,
                                34.90823
                            ],
                            [
                                114.340118,
                                34.907146
                            ],
                            [
                                114.350499,
                                34.908082
                            ],
                            [
                                114.367233,
                                34.918968
                            ],
                            [
                                114.383024,
                                34.936894
                            ],
                            [
                                114.40064,
                                34.939504
                            ],
                            [
                                114.417815,
                                34.930788
                            ],
                            [
                                114.442728,
                                34.914486
                            ],
                            [
                                114.513378,
                                34.895273
                            ],
                            [
                                114.540682,
                                34.899264
                            ],
                            [
                                114.557165,
                                34.905521
                            ],
                            [
                                114.586608,
                                34.912466
                            ],
                            [
                                114.633981,
                                34.905225
                            ],
                            [
                                114.660279,
                                34.898722
                            ],
                            [
                                114.679593,
                                34.909018
                            ],
                            [
                                114.695572,
                                34.894387
                            ],
                            [
                                114.709161,
                                34.89212
                            ],
                            [
                                114.724323,
                                34.885222
                            ],
                            [
                                114.733886,
                                34.888474
                            ],
                            [
                                114.76119,
                                34.89148
                            ],
                            [
                                114.774779,
                                34.901382
                            ],
                            [
                                114.778994,
                                34.916751
                            ],
                            [
                                114.768173,
                                34.927882
                            ],
                            [
                                114.74175,
                                34.948712
                            ],
                            [
                                114.741435,
                                34.960675
                            ],
                            [
                                114.756597,
                                34.97559
                            ],
                            [
                                114.765908,
                                34.977707
                            ],
                            [
                                114.800384,
                                35.006691
                            ],
                            [
                                114.815861,
                                35.014022
                            ],
                            [
                                114.824668,
                                35.0123
                            ],
                            [
                                114.838635,
                                35.018154
                            ],
                            [
                                114.852664,
                                35.029124
                            ],
                            [
                                114.850903,
                                35.041911
                            ],
                            [
                                114.833979,
                                35.042157
                            ],
                            [
                                114.819258,
                                35.051796
                            ],
                            [
                                114.83184,
                                35.074167
                            ],
                            [
                                114.861158,
                                35.082966
                            ],
                            [
                                114.876256,
                                35.091126
                            ],
                            [
                                114.882925,
                                35.098743
                            ],
                            [
                                114.883554,
                                35.109653
                            ],
                            [
                                114.872545,
                                35.126015
                            ],
                            [
                                114.860654,
                                35.137412
                            ],
                            [
                                114.841718,
                                35.151165
                            ],
                            [
                                114.841026,
                                35.159219
                            ],
                            [
                                114.850274,
                                35.172625
                            ],
                            [
                                114.861661,
                                35.182395
                            ],
                            [
                                114.876571,
                                35.189023
                            ],
                            [
                                114.909348,
                                35.194521
                            ],
                            [
                                114.928285,
                                35.194766
                            ],
                            [
                                114.9325,
                                35.198644
                            ],
                            [
                                114.929732,
                                35.248205
                            ],
                            [
                                114.954645,
                                35.255465
                            ],
                            [
                                114.957728,
                                35.261155
                            ],
                            [
                                114.975595,
                                35.261547
                            ],
                            [
                                114.975784,
                                35.270277
                            ],
                            [
                                114.963579,
                                35.273759
                            ],
                            [
                                114.98025,
                                35.294696
                            ],
                            [
                                115.003151,
                                35.316363
                            ],
                            [
                                115.014538,
                                35.318128
                            ],
                            [
                                115.017243,
                                35.337437
                            ],
                            [
                                114.976979,
                                35.352381
                            ],
                            [
                                114.968171,
                                35.354389
                            ],
                            [
                                114.960873,
                                35.369722
                            ],
                            [
                                114.951248,
                                35.380791
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 410800,
                "name": "焦作市",
                "center": [
                    113.238266,
                    35.23904
                ],
                "centroid": [
                    113.137719,
                    35.114644
                ],
                "childrenNum": 10,
                "level": "city",
                "parent": {
                    "adcode": 410000
                },
                "subFeatureIndex": 7,
                "acroutes": [
                    100000,
                    410000
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                112.827266,
                                34.819218
                            ],
                            [
                                112.838653,
                                34.812116
                            ],
                            [
                                112.853501,
                                34.810736
                            ],
                            [
                                112.866461,
                                34.829524
                            ],
                            [
                                112.873192,
                                34.832827
                            ],
                            [
                                112.879106,
                                34.849688
                            ],
                            [
                                112.884516,
                                34.853089
                            ],
                            [
                                112.902321,
                                34.852301
                            ],
                            [
                                112.914148,
                                34.84747
                            ],
                            [
                                112.938181,
                                34.831595
                            ],
                            [
                                112.943025,
                                34.831102
                            ],
                            [
                                112.976117,
                                34.847765
                            ],
                            [
                                112.989077,
                                34.856343
                            ],
                            [
                                112.992851,
                                34.863539
                            ],
                            [
                                113.004364,
                                34.864081
                            ],
                            [
                                113.025063,
                                34.854913
                            ],
                            [
                                113.039595,
                                34.841948
                            ],
                            [
                                113.06023,
                                34.83756
                            ],
                            [
                                113.107666,
                                34.844709
                            ],
                            [
                                113.119431,
                                34.853977
                            ],
                            [
                                113.14793,
                                34.856096
                            ],
                            [
                                113.139815,
                                34.884631
                            ],
                            [
                                113.179512,
                                34.893697
                            ],
                            [
                                113.197631,
                                34.900299
                            ],
                            [
                                113.227703,
                                34.908427
                            ],
                            [
                                113.236951,
                                34.925174
                            ],
                            [
                                113.239342,
                                34.939504
                            ],
                            [
                                113.243934,
                                34.946201
                            ],
                            [
                                113.260543,
                                34.953586
                            ],
                            [
                                113.28986,
                                34.952601
                            ],
                            [
                                113.315277,
                                34.942212
                            ],
                            [
                                113.333018,
                                34.944871
                            ],
                            [
                                113.343462,
                                34.950533
                            ],
                            [
                                113.362587,
                                34.970323
                            ],
                            [
                                113.37561,
                                34.98002
                            ],
                            [
                                113.407821,
                                34.989518
                            ],
                            [
                                113.427198,
                                34.983563
                            ],
                            [
                                113.429463,
                                34.964761
                            ],
                            [
                                113.449658,
                                34.960232
                            ],
                            [
                                113.477339,
                                34.957278
                            ],
                            [
                                113.495835,
                                34.959937
                            ],
                            [
                                113.515086,
                                34.965992
                            ],
                            [
                                113.543271,
                                34.96801
                            ],
                            [
                                113.552582,
                                34.965155
                            ],
                            [
                                113.57479,
                                34.950583
                            ],
                            [
                                113.592091,
                                34.933743
                            ],
                            [
                                113.595299,
                                34.961857
                            ],
                            [
                                113.60763,
                                34.982382
                            ],
                            [
                                113.617696,
                                34.992175
                            ],
                            [
                                113.634494,
                                34.997687
                            ],
                            [
                                113.644371,
                                35.004379
                            ],
                            [
                                113.634431,
                                35.008167
                            ],
                            [
                                113.629964,
                                35.016777
                            ],
                            [
                                113.645503,
                                35.019236
                            ],
                            [
                                113.645503,
                                35.038075
                            ],
                            [
                                113.620464,
                                35.068513
                            ],
                            [
                                113.607064,
                                35.099284
                            ],
                            [
                                113.60027,
                                35.120709
                            ],
                            [
                                113.593852,
                                35.131173
                            ],
                            [
                                113.564598,
                                35.127685
                            ],
                            [
                                113.565102,
                                35.137461
                            ],
                            [
                                113.542642,
                                35.144632
                            ],
                            [
                                113.534967,
                                35.151803
                            ],
                            [
                                113.532828,
                                35.164572
                            ],
                            [
                                113.521063,
                                35.192901
                            ],
                            [
                                113.52144,
                                35.211504
                            ],
                            [
                                113.528172,
                                35.220141
                            ],
                            [
                                113.54044,
                                35.228384
                            ],
                            [
                                113.538804,
                                35.243201
                            ],
                            [
                                113.523265,
                                35.263656
                            ],
                            [
                                113.518798,
                                35.288813
                            ],
                            [
                                113.511878,
                                35.293961
                            ],
                            [
                                113.486461,
                                35.294108
                            ],
                            [
                                113.485014,
                                35.316265
                            ],
                            [
                                113.478157,
                                35.327195
                            ],
                            [
                                113.480044,
                                35.33974
                            ],
                            [
                                113.466581,
                                35.349686
                            ],
                            [
                                113.469978,
                                35.353214
                            ],
                            [
                                113.465952,
                                35.363844
                            ],
                            [
                                113.476207,
                                35.363942
                            ],
                            [
                                113.482246,
                                35.369967
                            ],
                            [
                                113.462366,
                                35.396853
                            ],
                            [
                                113.458843,
                                35.413304
                            ],
                            [
                                113.447707,
                                35.432443
                            ],
                            [
                                113.427638,
                                35.448887
                            ],
                            [
                                113.404046,
                                35.46151
                            ],
                            [
                                113.392093,
                                35.472225
                            ],
                            [
                                113.390772,
                                35.485774
                            ],
                            [
                                113.383159,
                                35.495067
                            ],
                            [
                                113.370766,
                                35.4801
                            ],
                            [
                                113.357743,
                                35.479415
                            ],
                            [
                                113.34818,
                                35.46836
                            ],
                            [
                                113.325909,
                                35.469289
                            ],
                            [
                                113.31232,
                                35.481274
                            ],
                            [
                                113.295522,
                                35.47154
                            ],
                            [
                                113.294705,
                                35.467284
                            ],
                            [
                                113.309426,
                                35.466158
                            ],
                            [
                                113.322197,
                                35.461559
                            ],
                            [
                                113.323959,
                                35.453339
                            ],
                            [
                                113.315151,
                                35.451871
                            ],
                            [
                                113.306406,
                                35.460777
                            ],
                            [
                                113.299486,
                                35.450208
                            ],
                            [
                                113.297347,
                                35.438512
                            ],
                            [
                                113.304393,
                                35.42701
                            ],
                            [
                                113.27841,
                                35.435135
                            ],
                            [
                                113.265387,
                                35.434597
                            ],
                            [
                                113.262116,
                                35.440763
                            ],
                            [
                                113.253497,
                                35.440274
                            ],
                            [
                                113.244815,
                                35.448446
                            ],
                            [
                                113.230031,
                                35.453242
                            ],
                            [
                                113.208515,
                                35.447272
                            ],
                            [
                                113.190019,
                                35.449082
                            ],
                            [
                                113.190962,
                                35.434107
                            ],
                            [
                                113.184482,
                                35.424759
                            ],
                            [
                                113.188572,
                                35.415654
                            ],
                            [
                                113.185237,
                                35.409045
                            ],
                            [
                                113.175737,
                                35.414528
                            ],
                            [
                                113.164224,
                                35.408555
                            ],
                            [
                                113.167056,
                                35.400232
                            ],
                            [
                                113.177247,
                                35.397833
                            ],
                            [
                                113.170138,
                                35.386717
                            ],
                            [
                                113.154662,
                                35.380889
                            ],
                            [
                                113.154159,
                                35.36933
                            ],
                            [
                                113.148748,
                                35.370163
                            ],
                            [
                                113.148874,
                                35.351205
                            ],
                            [
                                113.136669,
                                35.347334
                            ],
                            [
                                113.13799,
                                35.336261
                            ],
                            [
                                113.12654,
                                35.332242
                            ],
                            [
                                113.107603,
                                35.340818
                            ],
                            [
                                113.096216,
                                35.337388
                            ],
                            [
                                113.084074,
                                35.340524
                            ],
                            [
                                113.067151,
                                35.353557
                            ],
                            [
                                113.060608,
                                35.352283
                            ],
                            [
                                113.039658,
                                35.360219
                            ],
                            [
                                113.020218,
                                35.356006
                            ],
                            [
                                112.998199,
                                35.362472
                            ],
                            [
                                112.990838,
                                35.355712
                            ],
                            [
                                112.994047,
                                35.345424
                            ],
                            [
                                112.985302,
                                35.338123
                            ],
                            [
                                112.986309,
                                35.316608
                            ],
                            [
                                112.99153,
                                35.302344
                            ],
                            [
                                112.988951,
                                35.28999
                            ],
                            [
                                112.982785,
                                35.287244
                            ],
                            [
                                112.964667,
                                35.293127
                            ],
                            [
                                112.948184,
                                35.285969
                            ],
                            [
                                112.936042,
                                35.2844
                            ],
                            [
                                112.936671,
                                35.271895
                            ],
                            [
                                112.929687,
                                35.256888
                            ],
                            [
                                112.907102,
                                35.245801
                            ],
                            [
                                112.893639,
                                35.248647
                            ],
                            [
                                112.884705,
                                35.244232
                            ],
                            [
                                112.868096,
                                35.243888
                            ],
                            [
                                112.857087,
                                35.247371
                            ],
                            [
                                112.855136,
                                35.253307
                            ],
                            [
                                112.822233,
                                35.258114
                            ],
                            [
                                112.798264,
                                35.238688
                            ],
                            [
                                112.784423,
                                35.234567
                            ],
                            [
                                112.784926,
                                35.222938
                            ],
                            [
                                112.767248,
                                35.204093
                            ],
                            [
                                112.758,
                                35.204436
                            ],
                            [
                                112.76687,
                                35.182985
                            ],
                            [
                                112.761963,
                                35.158041
                            ],
                            [
                                112.766304,
                                35.107196
                            ],
                            [
                                112.754288,
                                35.098891
                            ],
                            [
                                112.753219,
                                35.08508
                            ],
                            [
                                112.743341,
                                35.06458
                            ],
                            [
                                112.736043,
                                35.060008
                            ],
                            [
                                112.735289,
                                35.043338
                            ],
                            [
                                112.72711,
                                35.035026
                            ],
                            [
                                112.698988,
                                35.023221
                            ],
                            [
                                112.684581,
                                35.012497
                            ],
                            [
                                112.675962,
                                34.993504
                            ],
                            [
                                112.666462,
                                34.9875
                            ],
                            [
                                112.653062,
                                34.988681
                            ],
                            [
                                112.644695,
                                34.978888
                            ],
                            [
                                112.624752,
                                34.977903
                            ],
                            [
                                112.614182,
                                34.98002
                            ],
                            [
                                112.596001,
                                34.971013
                            ],
                            [
                                112.579392,
                                34.971751
                            ],
                            [
                                112.5692,
                                34.958608
                            ],
                            [
                                112.571654,
                                34.948761
                            ],
                            [
                                112.578134,
                                34.944083
                            ],
                            [
                                112.579329,
                                34.933398
                            ],
                            [
                                112.585369,
                                34.926503
                            ],
                            [
                                112.618209,
                                34.920298
                            ],
                            [
                                112.638404,
                                34.919756
                            ],
                            [
                                112.638152,
                                34.896998
                            ],
                            [
                                112.642115,
                                34.895717
                            ],
                            [
                                112.636328,
                                34.88266
                            ],
                            [
                                112.638215,
                                34.854174
                            ],
                            [
                                112.656648,
                                34.859645
                            ],
                            [
                                112.676088,
                                34.853188
                            ],
                            [
                                112.696723,
                                34.840617
                            ],
                            [
                                112.72214,
                                34.828833
                            ],
                            [
                                112.753281,
                                34.828587
                            ],
                            [
                                112.773288,
                                34.835884
                            ],
                            [
                                112.78782,
                                34.83761
                            ],
                            [
                                112.813363,
                                34.832877
                            ],
                            [
                                112.827266,
                                34.819218
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 410900,
                "name": "濮阳市",
                "center": [
                    115.041299,
                    35.768234
                ],
                "centroid": [
                    115.287416,
                    35.809288
                ],
                "childrenNum": 6,
                "level": "city",
                "parent": {
                    "adcode": 410000
                },
                "subFeatureIndex": 8,
                "acroutes": [
                    100000,
                    410000
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                115.017243,
                                35.337437
                            ],
                            [
                                115.025359,
                                35.346354
                            ],
                            [
                                115.03511,
                                35.368302
                            ],
                            [
                                115.043226,
                                35.376971
                            ],
                            [
                                115.057758,
                                35.378489
                            ],
                            [
                                115.075437,
                                35.375159
                            ],
                            [
                                115.088648,
                                35.392985
                            ],
                            [
                                115.084811,
                                35.410073
                            ],
                            [
                                115.091605,
                                35.416045
                            ],
                            [
                                115.105886,
                                35.403953
                            ],
                            [
                                115.11482,
                                35.4041
                            ],
                            [
                                115.118343,
                                35.416388
                            ],
                            [
                                115.11784,
                                35.400134
                            ],
                            [
                                115.126584,
                                35.408751
                            ],
                            [
                                115.126459,
                                35.418053
                            ],
                            [
                                115.136902,
                                35.421528
                            ],
                            [
                                115.167666,
                                35.426129
                            ],
                            [
                                115.189497,
                                35.42515
                            ],
                            [
                                115.197927,
                                35.420696
                            ],
                            [
                                115.209817,
                                35.423094
                            ],
                            [
                                115.237373,
                                35.423094
                            ],
                            [
                                115.257505,
                                35.435576
                            ],
                            [
                                115.272604,
                                35.448299
                            ],
                            [
                                115.270842,
                                35.456813
                            ],
                            [
                                115.286696,
                                35.464495
                            ],
                            [
                                115.307143,
                                35.480002
                            ],
                            [
                                115.339102,
                                35.490665
                            ],
                            [
                                115.355774,
                                35.490127
                            ],
                            [
                                115.357976,
                                35.506559
                            ],
                            [
                                115.350301,
                                35.52944
                            ],
                            [
                                115.353509,
                                35.540585
                            ],
                            [
                                115.360492,
                                35.543273
                            ],
                            [
                                115.34596,
                                35.546987
                            ],
                            [
                                115.345079,
                                35.553634
                            ],
                            [
                                115.357976,
                                35.554709
                            ],
                            [
                                115.359234,
                                35.56546
                            ],
                            [
                                115.369489,
                                35.559743
                            ],
                            [
                                115.370747,
                                35.57103
                            ],
                            [
                                115.383267,
                                35.56888
                            ],
                            [
                                115.38377,
                                35.577674
                            ],
                            [
                                115.389747,
                                35.577332
                            ],
                            [
                                115.394465,
                                35.586907
                            ],
                            [
                                115.411892,
                                35.603612
                            ],
                            [
                                115.416233,
                                35.624025
                            ],
                            [
                                115.439384,
                                35.643455
                            ],
                            [
                                115.45247,
                                35.660734
                            ],
                            [
                                115.461467,
                                35.680839
                            ],
                            [
                                115.485939,
                                35.710157
                            ],
                            [
                                115.511545,
                                35.727129
                            ],
                            [
                                115.524127,
                                35.726349
                            ],
                            [
                                115.533249,
                                35.734151
                            ],
                            [
                                115.552815,
                                35.730347
                            ],
                            [
                                115.562504,
                                35.738637
                            ],
                            [
                                115.583076,
                                35.730591
                            ],
                            [
                                115.588927,
                                35.738539
                            ],
                            [
                                115.619502,
                                35.739222
                            ],
                            [
                                115.665114,
                                35.751069
                            ],
                            [
                                115.69355,
                                35.754091
                            ],
                            [
                                115.698268,
                                35.768421
                            ],
                            [
                                115.696255,
                                35.788889
                            ],
                            [
                                115.704434,
                                35.788938
                            ],
                            [
                                115.706384,
                                35.8056
                            ],
                            [
                                115.717394,
                                35.802726
                            ],
                            [
                                115.720288,
                                35.817096
                            ],
                            [
                                115.7279,
                                35.815635
                            ],
                            [
                                115.73482,
                                35.832925
                            ],
                            [
                                115.753128,
                                35.832925
                            ],
                            [
                                115.752876,
                                35.838379
                            ],
                            [
                                115.76376,
                                35.838379
                            ],
                            [
                                115.773386,
                                35.854155
                            ],
                            [
                                115.816795,
                                35.844271
                            ],
                            [
                                115.821325,
                                35.852694
                            ],
                            [
                                115.841331,
                                35.850016
                            ],
                            [
                                115.840891,
                                35.857173
                            ],
                            [
                                115.863099,
                                35.855518
                            ],
                            [
                                115.865489,
                                35.868613
                            ],
                            [
                                115.872598,
                                35.872799
                            ],
                            [
                                115.871403,
                                35.858342
                            ],
                            [
                                115.875115,
                                35.859218
                            ],
                            [
                                115.876058,
                                35.875038
                            ],
                            [
                                115.882853,
                                35.879857
                            ],
                            [
                                115.88323,
                                35.895381
                            ],
                            [
                                115.889081,
                                35.897522
                            ],
                            [
                                115.88474,
                                35.909102
                            ],
                            [
                                115.87241,
                                35.909346
                            ],
                            [
                                115.875115,
                                35.920194
                            ],
                            [
                                115.907829,
                                35.926858
                            ],
                            [
                                115.909968,
                                35.935759
                            ],
                            [
                                115.906319,
                                35.945388
                            ],
                            [
                                115.911856,
                                35.960268
                            ],
                            [
                                115.957656,
                                35.967998
                            ],
                            [
                                115.985148,
                                35.974123
                            ],
                            [
                                116.008489,
                                35.973103
                            ],
                            [
                                116.038561,
                                35.963428
                            ],
                            [
                                116.04869,
                                35.970283
                            ],
                            [
                                116.05259,
                                35.999155
                            ],
                            [
                                116.062845,
                                36.02889
                            ],
                            [
                                116.073666,
                                36.026121
                            ],
                            [
                                116.079517,
                                36.042637
                            ],
                            [
                                116.076057,
                                36.056915
                            ],
                            [
                                116.087129,
                                36.071385
                            ],
                            [
                                116.087758,
                                36.080949
                            ],
                            [
                                116.096881,
                                36.092163
                            ],
                            [
                                116.099334,
                                36.112061
                            ],
                            [
                                116.057435,
                                36.104927
                            ],
                            [
                                116.02881,
                                36.072308
                            ],
                            [
                                116.016416,
                                36.061383
                            ],
                            [
                                115.989804,
                                36.045454
                            ],
                            [
                                115.964073,
                                36.041617
                            ],
                            [
                                115.935888,
                                36.031416
                            ],
                            [
                                115.922928,
                                36.021555
                            ],
                            [
                                115.913806,
                                36.020243
                            ],
                            [
                                115.896002,
                                36.026219
                            ],
                            [
                                115.872221,
                                36.016696
                            ],
                            [
                                115.859701,
                                36.003723
                            ],
                            [
                                115.846238,
                                36.004986
                            ],
                            [
                                115.837493,
                                36.011012
                            ],
                            [
                                115.817298,
                                36.012761
                            ],
                            [
                                115.797481,
                                36.006978
                            ],
                            [
                                115.779866,
                                35.99376
                            ],
                            [
                                115.786723,
                                35.991233
                            ],
                            [
                                115.774518,
                                35.981901
                            ],
                            [
                                115.774707,
                                35.974512
                            ],
                            [
                                115.764326,
                                35.970964
                            ],
                            [
                                115.736016,
                                35.966929
                            ],
                            [
                                115.717897,
                                35.971401
                            ],
                            [
                                115.698709,
                                35.966053
                            ],
                            [
                                115.687007,
                                35.955211
                            ],
                            [
                                115.68405,
                                35.944367
                            ],
                            [
                                115.651776,
                                35.928901
                            ],
                            [
                                115.642402,
                                35.920048
                            ],
                            [
                                115.607297,
                                35.925837
                            ],
                            [
                                115.583768,
                                35.921702
                            ],
                            [
                                115.548223,
                                35.898009
                            ],
                            [
                                115.503429,
                                35.888714
                            ],
                            [
                                115.460082,
                                35.867737
                            ],
                            [
                                115.433848,
                                35.839061
                            ],
                            [
                                115.432841,
                                35.83385
                            ],
                            [
                                115.417931,
                                35.824987
                            ],
                            [
                                115.407614,
                                35.808669
                            ],
                            [
                                115.370936,
                                35.78884
                            ],
                            [
                                115.363512,
                                35.779923
                            ],
                            [
                                115.335013,
                                35.796733
                            ],
                            [
                                115.335705,
                                35.81432
                            ],
                            [
                                115.344072,
                                35.83872
                            ],
                            [
                                115.349608,
                                35.860971
                            ],
                            [
                                115.338158,
                                35.864719
                            ],
                            [
                                115.343632,
                                35.872118
                            ],
                            [
                                115.356906,
                                35.87022
                            ],
                            [
                                115.364267,
                                35.894019
                            ],
                            [
                                115.367413,
                                35.92034
                            ],
                            [
                                115.364141,
                                35.929485
                            ],
                            [
                                115.354138,
                                35.93751
                            ],
                            [
                                115.356529,
                                35.954628
                            ],
                            [
                                115.363135,
                                35.972033
                            ],
                            [
                                115.386286,
                                35.974464
                            ],
                            [
                                115.395975,
                                35.991671
                            ],
                            [
                                115.419693,
                                36.004743
                            ],
                            [
                                115.443096,
                                36.008874
                            ],
                            [
                                115.447752,
                                36.012664
                            ],
                            [
                                115.448884,
                                36.047397
                            ],
                            [
                                115.441586,
                                36.05575
                            ],
                            [
                                115.459579,
                                36.063374
                            ],
                            [
                                115.455112,
                                36.071288
                            ],
                            [
                                115.459768,
                                36.080415
                            ],
                            [
                                115.466374,
                                36.079687
                            ],
                            [
                                115.484241,
                                36.125842
                            ],
                            [
                                115.483549,
                                36.148982
                            ],
                            [
                                115.46996,
                                36.152862
                            ],
                            [
                                115.46392,
                                36.17129
                            ],
                            [
                                115.451275,
                                36.169739
                            ],
                            [
                                115.449639,
                                36.150146
                            ],
                            [
                                115.431332,
                                36.149176
                            ],
                            [
                                115.423656,
                                36.140347
                            ],
                            [
                                115.407802,
                                36.139571
                            ],
                            [
                                115.404594,
                                36.155626
                            ],
                            [
                                115.400127,
                                36.14025
                            ],
                            [
                                115.392641,
                                36.129189
                            ],
                            [
                                115.377919,
                                36.12851
                            ],
                            [
                                115.369237,
                                36.102695
                            ],
                            [
                                115.3598,
                                36.095318
                            ],
                            [
                                115.341367,
                                36.0876
                            ],
                            [
                                115.333251,
                                36.090609
                            ],
                            [
                                115.323248,
                                36.086775
                            ],
                            [
                                115.307961,
                                36.090706
                            ],
                            [
                                115.297517,
                                36.104491
                            ],
                            [
                                115.301166,
                                36.130111
                            ],
                            [
                                115.279335,
                                36.137825
                            ],
                            [
                                115.264111,
                                36.158827
                            ],
                            [
                                115.260399,
                                36.171581
                            ],
                            [
                                115.242091,
                                36.191218
                            ],
                            [
                                115.21334,
                                36.203482
                            ],
                            [
                                115.20296,
                                36.204063
                            ],
                            [
                                115.201765,
                                36.212739
                            ],
                            [
                                115.189245,
                                36.19558
                            ],
                            [
                                115.170686,
                                36.190975
                            ],
                            [
                                115.156845,
                                36.194708
                            ],
                            [
                                115.156657,
                                36.201882
                            ],
                            [
                                115.142879,
                                36.209686
                            ],
                            [
                                115.124949,
                                36.209976
                            ],
                            [
                                115.110416,
                                36.19941
                            ],
                            [
                                115.104565,
                                36.172212
                            ],
                            [
                                115.099469,
                                36.171678
                            ],
                            [
                                115.069523,
                                36.179436
                            ],
                            [
                                115.062728,
                                36.178224
                            ],
                            [
                                115.048447,
                                36.162028
                            ],
                            [
                                115.049391,
                                36.147284
                            ],
                            [
                                115.044987,
                                36.130839
                            ],
                            [
                                115.045931,
                                36.112207
                            ],
                            [
                                115.038381,
                                36.106675
                            ],
                            [
                                114.998432,
                                36.069734
                            ],
                            [
                                114.98931,
                                36.065898
                            ],
                            [
                                114.968675,
                                36.070414
                            ],
                            [
                                114.954582,
                                36.067792
                            ],
                            [
                                114.933381,
                                36.054876
                            ],
                            [
                                114.932123,
                                36.050068
                            ],
                            [
                                114.920798,
                                36.048319
                            ],
                            [
                                114.94244,
                                36.03812
                            ],
                            [
                                114.968926,
                                36.032971
                            ],
                            [
                                114.983962,
                                36.02583
                            ],
                            [
                                114.983396,
                                36.019417
                            ],
                            [
                                114.974211,
                                36.012226
                            ],
                            [
                                114.974274,
                                35.999009
                            ],
                            [
                                114.980376,
                                36.003334
                            ],
                            [
                                114.986164,
                                35.991865
                            ],
                            [
                                114.983333,
                                35.982922
                            ],
                            [
                                114.988366,
                                35.964741
                            ],
                            [
                                114.98025,
                                35.949814
                            ],
                            [
                                114.972324,
                                35.923259
                            ],
                            [
                                114.97786,
                                35.904723
                            ],
                            [
                                114.970814,
                                35.890223
                            ],
                            [
                                114.969996,
                                35.881366
                            ],
                            [
                                114.959112,
                                35.862723
                            ],
                            [
                                114.953009,
                                35.85766
                            ],
                            [
                                114.935646,
                                35.853814
                            ],
                            [
                                114.933003,
                                35.84505
                            ],
                            [
                                114.93401,
                                35.828055
                            ],
                            [
                                114.94546,
                                35.82523
                            ],
                            [
                                114.948669,
                                35.819629
                            ],
                            [
                                114.943573,
                                35.799754
                            ],
                            [
                                114.921365,
                                35.780118
                            ],
                            [
                                114.908405,
                                35.765741
                            ],
                            [
                                114.893746,
                                35.764132
                            ],
                            [
                                114.887832,
                                35.753506
                            ],
                            [
                                114.889594,
                                35.738978
                            ],
                            [
                                114.907776,
                                35.722594
                            ],
                            [
                                114.915514,
                                35.706743
                            ],
                            [
                                114.910544,
                                35.700939
                            ],
                            [
                                114.918408,
                                35.687962
                            ],
                            [
                                114.919226,
                                35.664785
                            ],
                            [
                                114.911047,
                                35.660685
                            ],
                            [
                                114.905888,
                                35.649606
                            ],
                            [
                                114.890034,
                                35.646823
                            ],
                            [
                                114.875502,
                                35.628907
                            ],
                            [
                                114.874432,
                                35.623878
                            ],
                            [
                                114.883051,
                                35.616065
                            ],
                            [
                                114.884813,
                                35.599852
                            ],
                            [
                                114.90853,
                                35.585979
                            ],
                            [
                                114.952884,
                                35.581094
                            ],
                            [
                                114.962006,
                                35.571421
                            ],
                            [
                                114.968423,
                                35.537554
                            ],
                            [
                                114.969492,
                                35.518
                            ],
                            [
                                114.964334,
                                35.504749
                            ],
                            [
                                114.953324,
                                35.501815
                            ],
                            [
                                114.940616,
                                35.491448
                            ],
                            [
                                114.93942,
                                35.481225
                            ],
                            [
                                114.947347,
                                35.478144
                            ],
                            [
                                114.970751,
                                35.480785
                            ],
                            [
                                114.967668,
                                35.456716
                            ],
                            [
                                114.96188,
                                35.446146
                            ],
                            [
                                114.96383,
                                35.440665
                            ],
                            [
                                114.981509,
                                35.434107
                            ],
                            [
                                114.985787,
                                35.414332
                            ],
                            [
                                114.967605,
                                35.399204
                            ],
                            [
                                114.951248,
                                35.380791
                            ],
                            [
                                114.960873,
                                35.369722
                            ],
                            [
                                114.968171,
                                35.354389
                            ],
                            [
                                114.976979,
                                35.352381
                            ],
                            [
                                115.017243,
                                35.337437
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                115.504939,
                                35.899079
                            ],
                            [
                                115.51079,
                                35.907983
                            ],
                            [
                                115.505442,
                                35.914405
                            ],
                            [
                                115.490721,
                                35.908372
                            ],
                            [
                                115.490343,
                                35.899858
                            ],
                            [
                                115.497264,
                                35.895041
                            ],
                            [
                                115.504939,
                                35.899079
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 411000,
                "name": "许昌市",
                "center": [
                    113.826063,
                    34.022956
                ],
                "centroid": [
                    113.715606,
                    34.071457
                ],
                "childrenNum": 6,
                "level": "city",
                "parent": {
                    "adcode": 410000
                },
                "subFeatureIndex": 9,
                "acroutes": [
                    100000,
                    410000
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                114.259905,
                                34.251854
                            ],
                            [
                                114.246442,
                                34.240433
                            ],
                            [
                                114.210267,
                                34.241228
                            ],
                            [
                                114.202906,
                                34.234623
                            ],
                            [
                                114.198314,
                                34.217737
                            ],
                            [
                                114.160503,
                                34.213564
                            ],
                            [
                                114.155345,
                                34.202039
                            ],
                            [
                                114.129299,
                                34.198214
                            ],
                            [
                                114.122882,
                                34.204176
                            ],
                            [
                                114.109544,
                                34.206958
                            ],
                            [
                                114.108475,
                                34.218929
                            ],
                            [
                                114.102058,
                                34.224343
                            ],
                            [
                                114.10816,
                                34.228813
                            ],
                            [
                                114.098661,
                                34.241923
                            ],
                            [
                                114.081926,
                                34.24952
                            ],
                            [
                                114.076453,
                                34.239639
                            ],
                            [
                                114.068589,
                                34.250265
                            ],
                            [
                                114.058837,
                                34.244753
                            ],
                            [
                                114.050847,
                                34.247137
                            ],
                            [
                                114.041033,
                                34.237851
                            ],
                            [
                                114.011275,
                                34.242022
                            ],
                            [
                                114.00316,
                                34.252549
                            ],
                            [
                                114.000266,
                                34.263471
                            ],
                            [
                                113.990577,
                                34.261138
                            ],
                            [
                                113.992905,
                                34.27335
                            ],
                            [
                                113.977303,
                                34.275583
                            ],
                            [
                                113.972459,
                                34.283426
                            ],
                            [
                                113.96472,
                                34.283128
                            ],
                            [
                                113.964406,
                                34.292954
                            ],
                            [
                                113.937354,
                                34.298612
                            ],
                            [
                                113.934271,
                                34.304864
                            ],
                            [
                                113.916278,
                                34.301688
                            ],
                            [
                                113.904702,
                                34.294543
                            ],
                            [
                                113.896083,
                                34.303375
                            ],
                            [
                                113.899229,
                                34.315879
                            ],
                            [
                                113.894573,
                                34.323767
                            ],
                            [
                                113.885451,
                                34.327785
                            ],
                            [
                                113.880481,
                                34.32972
                            ],
                            [
                                113.85022,
                                34.32719
                            ],
                            [
                                113.848584,
                                34.322725
                            ],
                            [
                                113.832353,
                                34.32342
                            ],
                            [
                                113.803791,
                                34.33721
                            ],
                            [
                                113.791208,
                                34.331803
                            ],
                            [
                                113.793159,
                                34.328083
                            ],
                            [
                                113.777242,
                                34.314589
                            ],
                            [
                                113.756732,
                                34.313795
                            ],
                            [
                                113.736852,
                                34.317863
                            ],
                            [
                                113.727227,
                                34.305757
                            ],
                            [
                                113.713386,
                                34.301391
                            ],
                            [
                                113.71326,
                                34.29092
                            ],
                            [
                                113.7003,
                                34.289381
                            ],
                            [
                                113.70332,
                                34.276725
                            ],
                            [
                                113.679728,
                                34.282532
                            ],
                            [
                                113.669851,
                                34.275385
                            ],
                            [
                                113.658589,
                                34.275037
                            ],
                            [
                                113.643994,
                                34.288488
                            ],
                            [
                                113.634494,
                                34.290026
                            ],
                            [
                                113.624805,
                                34.303375
                            ],
                            [
                                113.608951,
                                34.3132
                            ],
                            [
                                113.600836,
                                34.313299
                            ],
                            [
                                113.579697,
                                34.319897
                            ],
                            [
                                113.566737,
                                34.318359
                            ],
                            [
                                113.556608,
                                34.311513
                            ],
                            [
                                113.529619,
                                34.317913
                            ],
                            [
                                113.516848,
                                34.328579
                            ],
                            [
                                113.518169,
                                34.335771
                            ],
                            [
                                113.510871,
                                34.342715
                            ],
                            [
                                113.498729,
                                34.338598
                            ],
                            [
                                113.482875,
                                34.342864
                            ],
                            [
                                113.471425,
                                34.330811
                            ],
                            [
                                113.459409,
                                34.334432
                            ],
                            [
                                113.429085,
                                34.350303
                            ],
                            [
                                113.414175,
                                34.349361
                            ],
                            [
                                113.406751,
                                34.355213
                            ],
                            [
                                113.414867,
                                34.374947
                            ],
                            [
                                113.401655,
                                34.377525
                            ],
                            [
                                113.389828,
                                34.375988
                            ],
                            [
                                113.366991,
                                34.379805
                            ],
                            [
                                113.370388,
                                34.389918
                            ],
                            [
                                113.353968,
                                34.396411
                            ],
                            [
                                113.348809,
                                34.404738
                            ],
                            [
                                113.32528,
                                34.404986
                            ],
                            [
                                113.315969,
                                34.391157
                            ],
                            [
                                113.320436,
                                34.383375
                            ],
                            [
                                113.314019,
                                34.373856
                            ],
                            [
                                113.314648,
                                34.352287
                            ],
                            [
                                113.276586,
                                34.351444
                            ],
                            [
                                113.276334,
                                34.342814
                            ],
                            [
                                113.267904,
                                34.337805
                            ],
                            [
                                113.235567,
                                34.339045
                            ],
                            [
                                113.224557,
                                34.33473
                            ],
                            [
                                113.223362,
                                34.325057
                            ],
                            [
                                113.210276,
                                34.312009
                            ],
                            [
                                113.196436,
                                34.312257
                            ],
                            [
                                113.18379,
                                34.295634
                            ],
                            [
                                113.184356,
                                34.290225
                            ],
                            [
                                113.175297,
                                34.281639
                            ],
                            [
                                113.15202,
                                34.266351
                            ],
                            [
                                113.142583,
                                34.272804
                            ],
                            [
                                113.109365,
                                34.263471
                            ],
                            [
                                113.097726,
                                34.26223
                            ],
                            [
                                113.082439,
                                34.26645
                            ],
                            [
                                113.077343,
                                34.262677
                            ],
                            [
                                113.070171,
                                34.247186
                            ],
                            [
                                113.066962,
                                34.223647
                            ],
                            [
                                113.075392,
                                34.215502
                            ],
                            [
                                113.094203,
                                34.21118
                            ],
                            [
                                113.103892,
                                34.205418
                            ],
                            [
                                113.106094,
                                34.198115
                            ],
                            [
                                113.101941,
                                34.18778
                            ],
                            [
                                113.103011,
                                34.176798
                            ],
                            [
                                113.118047,
                                34.156818
                            ],
                            [
                                113.129811,
                                34.145733
                            ],
                            [
                                113.126477,
                                34.134696
                            ],
                            [
                                113.130629,
                                34.124105
                            ],
                            [
                                113.146483,
                                34.117939
                            ],
                            [
                                113.150384,
                                34.108141
                            ],
                            [
                                113.157493,
                                34.103118
                            ],
                            [
                                113.177876,
                                34.101228
                            ],
                            [
                                113.210654,
                                34.107445
                            ],
                            [
                                113.222355,
                                34.102422
                            ],
                            [
                                113.227137,
                                34.092523
                            ],
                            [
                                113.235064,
                                34.091926
                            ],
                            [
                                113.241166,
                                34.097945
                            ],
                            [
                                113.240097,
                                34.108539
                            ],
                            [
                                113.252113,
                                34.114308
                            ],
                            [
                                113.257398,
                                34.112319
                            ],
                            [
                                113.264381,
                                34.098542
                            ],
                            [
                                113.278914,
                                34.100134
                            ],
                            [
                                113.283129,
                                34.086802
                            ],
                            [
                                113.30043,
                                34.082623
                            ],
                            [
                                113.331949,
                                34.063268
                            ],
                            [
                                113.320687,
                                34.054858
                            ],
                            [
                                113.334528,
                                34.027183
                            ],
                            [
                                113.345034,
                                34.029075
                            ],
                            [
                                113.346104,
                                34.03928
                            ],
                            [
                                113.35466,
                                34.043112
                            ],
                            [
                                113.368626,
                                34.039877
                            ],
                            [
                                113.386368,
                                34.039827
                            ],
                            [
                                113.395742,
                                34.031315
                            ],
                            [
                                113.402222,
                                34.002687
                            ],
                            [
                                113.41342,
                                33.987049
                            ],
                            [
                                113.412665,
                                33.952028
                            ],
                            [
                                113.410715,
                                33.943308
                            ],
                            [
                                113.386116,
                                33.927808
                            ],
                            [
                                113.381586,
                                33.912007
                            ],
                            [
                                113.365481,
                                33.890519
                            ],
                            [
                                113.360762,
                                33.879997
                            ],
                            [
                                113.36762,
                                33.862691
                            ],
                            [
                                113.384669,
                                33.843286
                            ],
                            [
                                113.385802,
                                33.834854
                            ],
                            [
                                113.38102,
                                33.815542
                            ],
                            [
                                113.386053,
                                33.801817
                            ],
                            [
                                113.393351,
                                33.797873
                            ],
                            [
                                113.372401,
                                33.785593
                            ],
                            [
                                113.425814,
                                33.762175
                            ],
                            [
                                113.434873,
                                33.765371
                            ],
                            [
                                113.448211,
                                33.75868
                            ],
                            [
                                113.451042,
                                33.739301
                            ],
                            [
                                113.489481,
                                33.746094
                            ],
                            [
                                113.504014,
                                33.751238
                            ],
                            [
                                113.51798,
                                33.750439
                            ],
                            [
                                113.544341,
                                33.757131
                            ],
                            [
                                113.549373,
                                33.750489
                            ],
                            [
                                113.573091,
                                33.752137
                            ],
                            [
                                113.576552,
                                33.736304
                            ],
                            [
                                113.58775,
                                33.727062
                            ],
                            [
                                113.580767,
                                33.715171
                            ],
                            [
                                113.585485,
                                33.711024
                            ],
                            [
                                113.6087,
                                33.709175
                            ],
                            [
                                113.596746,
                                33.698081
                            ],
                            [
                                113.598256,
                                33.687536
                            ],
                            [
                                113.612475,
                                33.695732
                            ],
                            [
                                113.629335,
                                33.688885
                            ],
                            [
                                113.637954,
                                33.695532
                            ],
                            [
                                113.637388,
                                33.702679
                            ],
                            [
                                113.645063,
                                33.695932
                            ],
                            [
                                113.670983,
                                33.699081
                            ],
                            [
                                113.684257,
                                33.693833
                            ],
                            [
                                113.701936,
                                33.691234
                            ],
                            [
                                113.70678,
                                33.693683
                            ],
                            [
                                113.710303,
                                33.707876
                            ],
                            [
                                113.716406,
                                33.710624
                            ],
                            [
                                113.724018,
                                33.695632
                            ],
                            [
                                113.741822,
                                33.702329
                            ],
                            [
                                113.74371,
                                33.713422
                            ],
                            [
                                113.75906,
                                33.717519
                            ],
                            [
                                113.762206,
                                33.731808
                            ],
                            [
                                113.750378,
                                33.7398
                            ],
                            [
                                113.737167,
                                33.741948
                            ],
                            [
                                113.734399,
                                33.752337
                            ],
                            [
                                113.742703,
                                33.76672
                            ],
                            [
                                113.752895,
                                33.771463
                            ],
                            [
                                113.752958,
                                33.791484
                            ],
                            [
                                113.761262,
                                33.807756
                            ],
                            [
                                113.759312,
                                33.827918
                            ],
                            [
                                113.731127,
                                33.835652
                            ],
                            [
                                113.729554,
                                33.845032
                            ],
                            [
                                113.722445,
                                33.848624
                            ],
                            [
                                113.725528,
                                33.856406
                            ],
                            [
                                113.735908,
                                33.859199
                            ],
                            [
                                113.738802,
                                33.868627
                            ],
                            [
                                113.760318,
                                33.868477
                            ],
                            [
                                113.773719,
                                33.877654
                            ],
                            [
                                113.76554,
                                33.883638
                            ],
                            [
                                113.77806,
                                33.884934
                            ],
                            [
                                113.78303,
                                33.880945
                            ],
                            [
                                113.797814,
                                33.883887
                            ],
                            [
                                113.806936,
                                33.880995
                            ],
                            [
                                113.811969,
                                33.885782
                            ],
                            [
                                113.813353,
                                33.88638
                            ],
                            [
                                113.818009,
                                33.88663
                            ],
                            [
                                113.820148,
                                33.890669
                            ],
                            [
                                113.824363,
                                33.89022
                            ],
                            [
                                113.826565,
                                33.875808
                            ],
                            [
                                113.853051,
                                33.873315
                            ],
                            [
                                113.861481,
                                33.884486
                            ],
                            [
                                113.860097,
                                33.907222
                            ],
                            [
                                113.871296,
                                33.909615
                            ],
                            [
                                113.857455,
                                33.939769
                            ],
                            [
                                113.859783,
                                33.94859
                            ],
                            [
                                113.870226,
                                33.945401
                            ],
                            [
                                113.885765,
                                33.948988
                            ],
                            [
                                113.88803,
                                33.943407
                            ],
                            [
                                113.90055,
                                33.943009
                            ],
                            [
                                113.901305,
                                33.94849
                            ],
                            [
                                113.916341,
                                33.945849
                            ],
                            [
                                113.922066,
                                33.957409
                            ],
                            [
                                113.951949,
                                33.97365
                            ],
                            [
                                113.977492,
                                33.98152
                            ],
                            [
                                113.99907,
                                33.981819
                            ],
                            [
                                114.021971,
                                33.987248
                            ],
                            [
                                114.037762,
                                33.986053
                            ],
                            [
                                114.053867,
                                33.978781
                            ],
                            [
                                114.059152,
                                33.96538
                            ],
                            [
                                114.057453,
                                33.952875
                            ],
                            [
                                114.064877,
                                33.949237
                            ],
                            [
                                114.076704,
                                33.952676
                            ],
                            [
                                114.087336,
                                33.934686
                            ],
                            [
                                114.103882,
                                33.934736
                            ],
                            [
                                114.103757,
                                33.925815
                            ],
                            [
                                114.114515,
                                33.928058
                            ],
                            [
                                114.125902,
                                33.915547
                            ],
                            [
                                114.128418,
                                33.885433
                            ],
                            [
                                114.116465,
                                33.872068
                            ],
                            [
                                114.115081,
                                33.863788
                            ],
                            [
                                114.132445,
                                33.853613
                            ],
                            [
                                114.145971,
                                33.841939
                            ],
                            [
                                114.159623,
                                33.816191
                            ],
                            [
                                114.15503,
                                33.809304
                            ],
                            [
                                114.161447,
                                33.79982
                            ],
                            [
                                114.178308,
                                33.806409
                            ],
                            [
                                114.179503,
                                33.799321
                            ],
                            [
                                114.190638,
                                33.801917
                            ],
                            [
                                114.19888,
                                33.797374
                            ],
                            [
                                114.211525,
                                33.798123
                            ],
                            [
                                114.217565,
                                33.793131
                            ],
                            [
                                114.242604,
                                33.790785
                            ],
                            [
                                114.249776,
                                33.779252
                            ],
                            [
                                114.290354,
                                33.771813
                            ],
                            [
                                114.309983,
                                33.781349
                            ],
                            [
                                114.313066,
                                33.80012
                            ],
                            [
                                114.325082,
                                33.818337
                            ],
                            [
                                114.323383,
                                33.832908
                            ],
                            [
                                114.316085,
                                33.833207
                            ],
                            [
                                114.310738,
                                33.842637
                            ],
                            [
                                114.301301,
                                33.842188
                            ],
                            [
                                114.301112,
                                33.852365
                            ],
                            [
                                114.312122,
                                33.853263
                            ],
                            [
                                114.315834,
                                33.865734
                            ],
                            [
                                114.311304,
                                33.87142
                            ],
                            [
                                114.3164,
                                33.880446
                            ],
                            [
                                114.305642,
                                33.889572
                            ],
                            [
                                114.299917,
                                33.953024
                            ],
                            [
                                114.31036,
                                33.96
                            ],
                            [
                                114.307026,
                                33.978233
                            ],
                            [
                                114.312248,
                                33.98162
                            ],
                            [
                                114.311745,
                                34.001492
                            ],
                            [
                                114.295324,
                                34.007467
                            ],
                            [
                                114.287523,
                                34.022902
                            ],
                            [
                                114.281987,
                                34.046597
                            ],
                            [
                                114.271103,
                                34.053813
                            ],
                            [
                                114.270411,
                                34.063219
                            ],
                            [
                                114.262107,
                                34.095856
                            ],
                            [
                                114.273431,
                                34.102571
                            ],
                            [
                                114.273808,
                                34.107545
                            ],
                            [
                                114.285133,
                                34.120873
                            ],
                            [
                                114.28746,
                                34.137033
                            ],
                            [
                                114.275255,
                                34.174661
                            ],
                            [
                                114.276199,
                                34.190811
                            ],
                            [
                                114.287649,
                                34.206958
                            ],
                            [
                                114.286013,
                                34.218234
                            ],
                            [
                                114.273053,
                                34.227869
                            ],
                            [
                                114.272676,
                                34.24237
                            ],
                            [
                                114.259905,
                                34.251854
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                113.813353,
                                33.88638
                            ],
                            [
                                113.811969,
                                33.885782
                            ],
                            [
                                113.811718,
                                33.879449
                            ],
                            [
                                113.826565,
                                33.875808
                            ],
                            [
                                113.824363,
                                33.89022
                            ],
                            [
                                113.820148,
                                33.890669
                            ],
                            [
                                113.818009,
                                33.88663
                            ],
                            [
                                113.813353,
                                33.88638
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 411100,
                "name": "漯河市",
                "center": [
                    114.026405,
                    33.575855
                ],
                "centroid": [
                    113.905678,
                    33.65448
                ],
                "childrenNum": 5,
                "level": "city",
                "parent": {
                    "adcode": 410000
                },
                "subFeatureIndex": 10,
                "acroutes": [
                    100000,
                    410000
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                113.688347,
                                33.407737
                            ],
                            [
                                113.693065,
                                33.418216
                            ],
                            [
                                113.710429,
                                33.417013
                            ],
                            [
                                113.713197,
                                33.430249
                            ],
                            [
                                113.721187,
                                33.432705
                            ],
                            [
                                113.766861,
                                33.432154
                            ],
                            [
                                113.771139,
                                33.435713
                            ],
                            [
                                113.799513,
                                33.43481
                            ],
                            [
                                113.805804,
                                33.446189
                            ],
                            [
                                113.825999,
                                33.460723
                            ],
                            [
                                113.847515,
                                33.466836
                            ],
                            [
                                113.856134,
                                33.47796
                            ],
                            [
                                113.865508,
                                33.479362
                            ],
                            [
                                113.914139,
                                33.478511
                            ],
                            [
                                113.933768,
                                33.465884
                            ],
                            [
                                113.94528,
                                33.465633
                            ],
                            [
                                113.95434,
                                33.473901
                            ],
                            [
                                113.967929,
                                33.477408
                            ],
                            [
                                113.9712,
                                33.482619
                            ],
                            [
                                113.981329,
                                33.482268
                            ],
                            [
                                113.998693,
                                33.500904
                            ],
                            [
                                114.001084,
                                33.510671
                            ],
                            [
                                114.01354,
                                33.511071
                            ],
                            [
                                114.014924,
                                33.522039
                            ],
                            [
                                114.033735,
                                33.523892
                            ],
                            [
                                114.038579,
                                33.5296
                            ],
                            [
                                114.052168,
                                33.528999
                            ],
                            [
                                114.055692,
                                33.523942
                            ],
                            [
                                114.075572,
                                33.517782
                            ],
                            [
                                114.099101,
                                33.503108
                            ],
                            [
                                114.116276,
                                33.51027
                            ],
                            [
                                114.118101,
                                33.502406
                            ],
                            [
                                114.104071,
                                33.499351
                            ],
                            [
                                114.103505,
                                33.491586
                            ],
                            [
                                114.115836,
                                33.488631
                            ],
                            [
                                114.130683,
                                33.495093
                            ],
                            [
                                114.131501,
                                33.472298
                            ],
                            [
                                114.151507,
                                33.468139
                            ],
                            [
                                114.150312,
                                33.460372
                            ],
                            [
                                114.159937,
                                33.456713
                            ],
                            [
                                114.171639,
                                33.459019
                            ],
                            [
                                114.180384,
                                33.453656
                            ],
                            [
                                114.171324,
                                33.440926
                            ],
                            [
                                114.190575,
                                33.426489
                            ],
                            [
                                114.195294,
                                33.447692
                            ],
                            [
                                114.211399,
                                33.453757
                            ],
                            [
                                114.230714,
                                33.451551
                            ],
                            [
                                114.247574,
                                33.45967
                            ],
                            [
                                114.266636,
                                33.461625
                            ],
                            [
                                114.284629,
                                33.472548
                            ],
                            [
                                114.279785,
                                33.489282
                            ],
                            [
                                114.283371,
                                33.500353
                            ],
                            [
                                114.281106,
                                33.513976
                            ],
                            [
                                114.289348,
                                33.522089
                            ],
                            [
                                114.295324,
                                33.553782
                            ],
                            [
                                114.282868,
                                33.558688
                            ],
                            [
                                114.278653,
                                33.57015
                            ],
                            [
                                114.265378,
                                33.593219
                            ],
                            [
                                114.265881,
                                33.597923
                            ],
                            [
                                114.279659,
                                33.604427
                            ],
                            [
                                114.277332,
                                33.621735
                            ],
                            [
                                114.264938,
                                33.635239
                            ],
                            [
                                114.264183,
                                33.654742
                            ],
                            [
                                114.260849,
                                33.661942
                            ],
                            [
                                114.259842,
                                33.680588
                            ],
                            [
                                114.250783,
                                33.693233
                            ],
                            [
                                114.249084,
                                33.704328
                            ],
                            [
                                114.214231,
                                33.691334
                            ],
                            [
                                114.196489,
                                33.690934
                            ],
                            [
                                114.186549,
                                33.682538
                            ],
                            [
                                114.186235,
                                33.67219
                            ],
                            [
                                114.169563,
                                33.664791
                            ],
                            [
                                114.162265,
                                33.669941
                            ],
                            [
                                114.152639,
                                33.662242
                            ],
                            [
                                114.149745,
                                33.650442
                            ],
                            [
                                114.125398,
                                33.652842
                            ],
                            [
                                114.116402,
                                33.651392
                            ],
                            [
                                114.118226,
                                33.67159
                            ],
                            [
                                114.115836,
                                33.684587
                            ],
                            [
                                114.097717,
                                33.683187
                            ],
                            [
                                114.091489,
                                33.71642
                            ],
                            [
                                114.095263,
                                33.728061
                            ],
                            [
                                114.106839,
                                33.739051
                            ],
                            [
                                114.10319,
                                33.756832
                            ],
                            [
                                114.098032,
                                33.765072
                            ],
                            [
                                114.133262,
                                33.768118
                            ],
                            [
                                114.142007,
                                33.765921
                            ],
                            [
                                114.139931,
                                33.783097
                            ],
                            [
                                114.133703,
                                33.791484
                            ],
                            [
                                114.134772,
                                33.806409
                            ],
                            [
                                114.145404,
                                33.810551
                            ],
                            [
                                114.15503,
                                33.809304
                            ],
                            [
                                114.159623,
                                33.816191
                            ],
                            [
                                114.145971,
                                33.841939
                            ],
                            [
                                114.132445,
                                33.853613
                            ],
                            [
                                114.115081,
                                33.863788
                            ],
                            [
                                114.116465,
                                33.872068
                            ],
                            [
                                114.128418,
                                33.885433
                            ],
                            [
                                114.125902,
                                33.915547
                            ],
                            [
                                114.114515,
                                33.928058
                            ],
                            [
                                114.103757,
                                33.925815
                            ],
                            [
                                114.103882,
                                33.934736
                            ],
                            [
                                114.087336,
                                33.934686
                            ],
                            [
                                114.076704,
                                33.952676
                            ],
                            [
                                114.064877,
                                33.949237
                            ],
                            [
                                114.057453,
                                33.952875
                            ],
                            [
                                114.059152,
                                33.96538
                            ],
                            [
                                114.053867,
                                33.978781
                            ],
                            [
                                114.037762,
                                33.986053
                            ],
                            [
                                114.021971,
                                33.987248
                            ],
                            [
                                113.99907,
                                33.981819
                            ],
                            [
                                113.977492,
                                33.98152
                            ],
                            [
                                113.951949,
                                33.97365
                            ],
                            [
                                113.922066,
                                33.957409
                            ],
                            [
                                113.916341,
                                33.945849
                            ],
                            [
                                113.901305,
                                33.94849
                            ],
                            [
                                113.90055,
                                33.943009
                            ],
                            [
                                113.88803,
                                33.943407
                            ],
                            [
                                113.885765,
                                33.948988
                            ],
                            [
                                113.870226,
                                33.945401
                            ],
                            [
                                113.859783,
                                33.94859
                            ],
                            [
                                113.857455,
                                33.939769
                            ],
                            [
                                113.871296,
                                33.909615
                            ],
                            [
                                113.860097,
                                33.907222
                            ],
                            [
                                113.861481,
                                33.884486
                            ],
                            [
                                113.853051,
                                33.873315
                            ],
                            [
                                113.826565,
                                33.875808
                            ],
                            [
                                113.811718,
                                33.879449
                            ],
                            [
                                113.811969,
                                33.885782
                            ],
                            [
                                113.806936,
                                33.880995
                            ],
                            [
                                113.797814,
                                33.883887
                            ],
                            [
                                113.78303,
                                33.880945
                            ],
                            [
                                113.77806,
                                33.884934
                            ],
                            [
                                113.76554,
                                33.883638
                            ],
                            [
                                113.773719,
                                33.877654
                            ],
                            [
                                113.760318,
                                33.868477
                            ],
                            [
                                113.738802,
                                33.868627
                            ],
                            [
                                113.735908,
                                33.859199
                            ],
                            [
                                113.725528,
                                33.856406
                            ],
                            [
                                113.722445,
                                33.848624
                            ],
                            [
                                113.729554,
                                33.845032
                            ],
                            [
                                113.731127,
                                33.835652
                            ],
                            [
                                113.759312,
                                33.827918
                            ],
                            [
                                113.761262,
                                33.807756
                            ],
                            [
                                113.752958,
                                33.791484
                            ],
                            [
                                113.752895,
                                33.771463
                            ],
                            [
                                113.742703,
                                33.76672
                            ],
                            [
                                113.734399,
                                33.752337
                            ],
                            [
                                113.737167,
                                33.741948
                            ],
                            [
                                113.750378,
                                33.7398
                            ],
                            [
                                113.762206,
                                33.731808
                            ],
                            [
                                113.75906,
                                33.717519
                            ],
                            [
                                113.74371,
                                33.713422
                            ],
                            [
                                113.741822,
                                33.702329
                            ],
                            [
                                113.724018,
                                33.695632
                            ],
                            [
                                113.716406,
                                33.710624
                            ],
                            [
                                113.710303,
                                33.707876
                            ],
                            [
                                113.70678,
                                33.693683
                            ],
                            [
                                113.701936,
                                33.691234
                            ],
                            [
                                113.684257,
                                33.693833
                            ],
                            [
                                113.670983,
                                33.699081
                            ],
                            [
                                113.645063,
                                33.695932
                            ],
                            [
                                113.637388,
                                33.702679
                            ],
                            [
                                113.637954,
                                33.695532
                            ],
                            [
                                113.629335,
                                33.688885
                            ],
                            [
                                113.612475,
                                33.695732
                            ],
                            [
                                113.598256,
                                33.687536
                            ],
                            [
                                113.596746,
                                33.698081
                            ],
                            [
                                113.6087,
                                33.709175
                            ],
                            [
                                113.585485,
                                33.711024
                            ],
                            [
                                113.576677,
                                33.706327
                            ],
                            [
                                113.584101,
                                33.698131
                            ],
                            [
                                113.580515,
                                33.681738
                            ],
                            [
                                113.587624,
                                33.654642
                            ],
                            [
                                113.596746,
                                33.651892
                            ],
                            [
                                113.619143,
                                33.63799
                            ],
                            [
                                113.628203,
                                33.629038
                            ],
                            [
                                113.621534,
                                33.619885
                            ],
                            [
                                113.604673,
                                33.613131
                            ],
                            [
                                113.579383,
                                33.597222
                            ],
                            [
                                113.576803,
                                33.592619
                            ],
                            [
                                113.552267,
                                33.586715
                            ],
                            [
                                113.554281,
                                33.5706
                            ],
                            [
                                113.563151,
                                33.57055
                            ],
                            [
                                113.557363,
                                33.553582
                            ],
                            [
                                113.545536,
                                33.548626
                            ],
                            [
                                113.537672,
                                33.51633
                            ],
                            [
                                113.533708,
                                33.514978
                            ],
                            [
                                113.537609,
                                33.498499
                            ],
                            [
                                113.532073,
                                33.497347
                            ],
                            [
                                113.525278,
                                33.505061
                            ],
                            [
                                113.510808,
                                33.505011
                            ],
                            [
                                113.50307,
                                33.500252
                            ],
                            [
                                113.483001,
                                33.500152
                            ],
                            [
                                113.478597,
                                33.50431
                            ],
                            [
                                113.484322,
                                33.483721
                            ],
                            [
                                113.471803,
                                33.463378
                            ],
                            [
                                113.473501,
                                33.443683
                            ],
                            [
                                113.466518,
                                33.437367
                            ],
                            [
                                113.468846,
                                33.422077
                            ],
                            [
                                113.483945,
                                33.421124
                            ],
                            [
                                113.506341,
                                33.414607
                            ],
                            [
                                113.51754,
                                33.407186
                            ],
                            [
                                113.526662,
                                33.419269
                            ],
                            [
                                113.539811,
                                33.419019
                            ],
                            [
                                113.54736,
                                33.406433
                            ],
                            [
                                113.574727,
                                33.407537
                            ],
                            [
                                113.589008,
                                33.404728
                            ],
                            [
                                113.596809,
                                33.41215
                            ],
                            [
                                113.620842,
                                33.410946
                            ],
                            [
                                113.645252,
                                33.421776
                            ],
                            [
                                113.651669,
                                33.418417
                            ],
                            [
                                113.659407,
                                33.424283
                            ],
                            [
                                113.683125,
                                33.41952
                            ],
                            [
                                113.688347,
                                33.407737
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 411200,
                "name": "三门峡市",
                "center": [
                    111.194099,
                    34.777338
                ],
                "centroid": [
                    111.112608,
                    34.36205
                ],
                "childrenNum": 6,
                "level": "city",
                "parent": {
                    "adcode": 410000
                },
                "subFeatureIndex": 11,
                "acroutes": [
                    100000,
                    410000
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                111.973358,
                                35.070234
                            ],
                            [
                                111.963166,
                                35.079329
                            ],
                            [
                                111.952156,
                                35.082131
                            ],
                            [
                                111.928376,
                                35.082032
                            ],
                            [
                                111.917618,
                                35.071119
                            ],
                            [
                                111.900065,
                                35.07982
                            ],
                            [
                                111.885595,
                                35.069988
                            ],
                            [
                                111.86452,
                                35.076772
                            ],
                            [
                                111.8615,
                                35.074757
                            ],
                            [
                                111.818405,
                                35.068464
                            ],
                            [
                                111.8101,
                                35.06222
                            ],
                            [
                                111.812051,
                                35.04855
                            ],
                            [
                                111.809534,
                                35.036846
                            ],
                            [
                                111.793555,
                                35.026664
                            ],
                            [
                                111.782419,
                                35.030058
                            ],
                            [
                                111.768578,
                                35.01535
                            ],
                            [
                                111.749138,
                                35.016383
                            ],
                            [
                                111.739324,
                                35.004231
                            ],
                            [
                                111.711769,
                                35.003641
                            ],
                            [
                                111.69711,
                                34.998966
                            ],
                            [
                                111.687107,
                                34.988485
                            ],
                            [
                                111.669617,
                                34.988189
                            ],
                            [
                                111.665528,
                                34.980955
                            ],
                            [
                                111.67572,
                                34.971406
                            ],
                            [
                                111.681697,
                                34.950927
                            ],
                            [
                                111.66169,
                                34.938815
                            ],
                            [
                                111.645082,
                                34.93783
                            ],
                            [
                                111.621552,
                                34.916308
                            ],
                            [
                                111.617652,
                                34.89483
                            ],
                            [
                                111.605824,
                                34.892367
                            ],
                            [
                                111.591858,
                                34.881625
                            ],
                            [
                                111.589404,
                                34.861863
                            ],
                            [
                                111.58305,
                                34.852794
                            ],
                            [
                                111.570782,
                                34.843329
                            ],
                            [
                                111.561031,
                                34.845251
                            ],
                            [
                                111.554488,
                                34.852202
                            ],
                            [
                                111.543982,
                                34.853286
                            ],
                            [
                                111.527813,
                                34.850132
                            ],
                            [
                                111.515356,
                                34.840173
                            ],
                            [
                                111.508688,
                                34.839187
                            ],
                            [
                                111.502648,
                                34.829968
                            ],
                            [
                                111.480126,
                                34.826023
                            ],
                            [
                                111.464649,
                                34.82691
                            ],
                            [
                                111.45062,
                                34.836624
                            ],
                            [
                                111.439358,
                                34.838152
                            ],
                            [
                                111.430991,
                                34.829277
                            ],
                            [
                                111.415389,
                                34.827453
                            ],
                            [
                                111.39532,
                                34.814878
                            ],
                            [
                                111.35537,
                                34.823064
                            ],
                            [
                                111.3504,
                                34.829376
                            ],
                            [
                                111.340334,
                                34.831299
                            ],
                            [
                                111.322656,
                                34.819711
                            ],
                            [
                                111.30611,
                                34.815223
                            ],
                            [
                                111.294157,
                                34.807678
                            ],
                            [
                                111.282141,
                                34.809453
                            ],
                            [
                                111.268048,
                                34.817936
                            ],
                            [
                                111.255214,
                                34.819563
                            ],
                            [
                                111.249112,
                                34.81404
                            ],
                            [
                                111.239864,
                                34.793571
                            ],
                            [
                                111.223443,
                                34.789427
                            ],
                            [
                                111.209414,
                                34.80097
                            ],
                            [
                                111.177769,
                                34.803979
                            ],
                            [
                                111.168144,
                                34.813201
                            ],
                            [
                                111.16072,
                                34.814582
                            ],
                            [
                                111.148515,
                                34.80748
                            ],
                            [
                                111.129767,
                                34.779955
                            ],
                            [
                                111.124419,
                                34.761698
                            ],
                            [
                                111.118254,
                                34.756566
                            ],
                            [
                                111.066414,
                                34.751581
                            ],
                            [
                                111.035336,
                                34.740871
                            ],
                            [
                                111.018475,
                                34.732282
                            ],
                            [
                                110.976324,
                                34.70646
                            ],
                            [
                                110.963993,
                                34.70641
                            ],
                            [
                                110.952354,
                                34.720581
                            ],
                            [
                                110.935494,
                                34.730505
                            ],
                            [
                                110.919766,
                                34.730258
                            ],
                            [
                                110.915739,
                                34.723247
                            ],
                            [
                                110.917438,
                                34.71357
                            ],
                            [
                                110.903723,
                                34.668823
                            ],
                            [
                                110.893469,
                                34.651629
                            ],
                            [
                                110.883717,
                                34.644117
                            ],
                            [
                                110.861572,
                                34.639719
                            ],
                            [
                                110.853205,
                                34.635271
                            ],
                            [
                                110.83452,
                                34.617526
                            ],
                            [
                                110.824328,
                                34.615845
                            ],
                            [
                                110.816023,
                                34.622618
                            ],
                            [
                                110.808222,
                                34.6371
                            ],
                            [
                                110.791865,
                                34.649751
                            ],
                            [
                                110.76129,
                                34.653506
                            ],
                            [
                                110.749148,
                                34.652271
                            ],
                            [
                                110.741158,
                                34.639225
                            ],
                            [
                                110.732728,
                                34.633195
                            ],
                            [
                                110.712659,
                                34.607837
                            ],
                            [
                                110.706367,
                                34.60398
                            ],
                            [
                                110.653521,
                                34.608034
                            ],
                            [
                                110.610992,
                                34.607293
                            ],
                            [
                                110.594509,
                                34.60314
                            ],
                            [
                                110.547388,
                                34.583558
                            ],
                            [
                                110.53317,
                                34.583459
                            ],
                            [
                                110.488502,
                                34.610753
                            ],
                            [
                                110.475857,
                                34.610457
                            ],
                            [
                                110.465602,
                                34.605463
                            ],
                            [
                                110.437732,
                                34.597849
                            ],
                            [
                                110.424835,
                                34.588454
                            ],
                            [
                                110.407723,
                                34.589245
                            ],
                            [
                                110.379161,
                                34.600519
                            ],
                            [
                                110.367207,
                                34.566792
                            ],
                            [
                                110.376141,
                                34.563082
                            ],
                            [
                                110.399355,
                                34.562834
                            ],
                            [
                                110.404514,
                                34.557591
                            ],
                            [
                                110.372744,
                                34.544332
                            ],
                            [
                                110.362048,
                                34.526419
                            ],
                            [
                                110.360476,
                                34.51761
                            ],
                            [
                                110.368843,
                                34.493206
                            ],
                            [
                                110.378217,
                                34.486423
                            ],
                            [
                                110.379727,
                                34.478501
                            ],
                            [
                                110.393442,
                                34.464833
                            ],
                            [
                                110.395266,
                                34.453937
                            ],
                            [
                                110.401998,
                                34.447101
                            ],
                            [
                                110.402941,
                                34.433478
                            ],
                            [
                                110.40961,
                                34.429069
                            ],
                            [
                                110.409484,
                                34.421587
                            ],
                            [
                                110.431,
                                34.409446
                            ],
                            [
                                110.458178,
                                34.402409
                            ],
                            [
                                110.467427,
                                34.409743
                            ],
                            [
                                110.47592,
                                34.409149
                            ],
                            [
                                110.473718,
                                34.393239
                            ],
                            [
                                110.489446,
                                34.355312
                            ],
                            [
                                110.50272,
                                34.345195
                            ],
                            [
                                110.503287,
                                34.334283
                            ],
                            [
                                110.498128,
                                34.320096
                            ],
                            [
                                110.473844,
                                34.322973
                            ],
                            [
                                110.465854,
                                34.305906
                            ],
                            [
                                110.449308,
                                34.291466
                            ],
                            [
                                110.431315,
                                34.290374
                            ],
                            [
                                110.426471,
                                34.27608
                            ],
                            [
                                110.432573,
                                34.272903
                            ],
                            [
                                110.442513,
                                34.253989
                            ],
                            [
                                110.439682,
                                34.243413
                            ],
                            [
                                110.48976,
                                34.232339
                            ],
                            [
                                110.507879,
                                34.217588
                            ],
                            [
                                110.52411,
                                34.219674
                            ],
                            [
                                110.551414,
                                34.212819
                            ],
                            [
                                110.557139,
                                34.193395
                            ],
                            [
                                110.589099,
                                34.190264
                            ],
                            [
                                110.587715,
                                34.178687
                            ],
                            [
                                110.62175,
                                34.177444
                            ],
                            [
                                110.634144,
                                34.169791
                            ],
                            [
                                110.641945,
                                34.160894
                            ],
                            [
                                110.639114,
                                34.150903
                            ],
                            [
                                110.624204,
                                34.137331
                            ],
                            [
                                110.628545,
                                34.133055
                            ],
                            [
                                110.618164,
                                34.124055
                            ],
                            [
                                110.614012,
                                34.113712
                            ],
                            [
                                110.591804,
                                34.101676
                            ],
                            [
                                110.595138,
                                34.064761
                            ],
                            [
                                110.58847,
                                34.061676
                            ],
                            [
                                110.589728,
                                34.038583
                            ],
                            [
                                110.586645,
                                34.023997
                            ],
                            [
                                110.612062,
                                34.024246
                            ],
                            [
                                110.619486,
                                34.035646
                            ],
                            [
                                110.631502,
                                34.025541
                            ],
                            [
                                110.628104,
                                34.019019
                            ],
                            [
                                110.634459,
                                34.01633
                            ],
                            [
                                110.638925,
                                34.004977
                            ],
                            [
                                110.649558,
                                33.992278
                            ],
                            [
                                110.65176,
                                33.969665
                            ],
                            [
                                110.670948,
                                33.966427
                            ],
                            [
                                110.675603,
                                33.946596
                            ],
                            [
                                110.669564,
                                33.939271
                            ],
                            [
                                110.650501,
                                33.93673
                            ],
                            [
                                110.626028,
                                33.924619
                            ],
                            [
                                110.62584,
                                33.90782
                            ],
                            [
                                110.61181,
                                33.908069
                            ],
                            [
                                110.592182,
                                33.900591
                            ],
                            [
                                110.587274,
                                33.887727
                            ],
                            [
                                110.600612,
                                33.87127
                            ],
                            [
                                110.612943,
                                33.867429
                            ],
                            [
                                110.612125,
                                33.852515
                            ],
                            [
                                110.627664,
                                33.84573
                            ],
                            [
                                110.649495,
                                33.84598
                            ],
                            [
                                110.667928,
                                33.852166
                            ],
                            [
                                110.684914,
                                33.838796
                            ],
                            [
                                110.712596,
                                33.833607
                            ],
                            [
                                110.722725,
                                33.818886
                            ],
                            [
                                110.725996,
                                33.807707
                            ],
                            [
                                110.741347,
                                33.798822
                            ],
                            [
                                110.753677,
                                33.799471
                            ],
                            [
                                110.765568,
                                33.795028
                            ],
                            [
                                110.782177,
                                33.796076
                            ],
                            [
                                110.78419,
                                33.782398
                            ],
                            [
                                110.7991,
                                33.775508
                            ],
                            [
                                110.80753,
                                33.757281
                            ],
                            [
                                110.815898,
                                33.753036
                            ],
                            [
                                110.816841,
                                33.737353
                            ],
                            [
                                110.832192,
                                33.712823
                            ],
                            [
                                110.823195,
                                33.692834
                            ],
                            [
                                110.825397,
                                33.684137
                            ],
                            [
                                110.833199,
                                33.677789
                            ],
                            [
                                110.841818,
                                33.663241
                            ],
                            [
                                110.857734,
                                33.657792
                            ],
                            [
                                110.87881,
                                33.634639
                            ],
                            [
                                110.89976,
                                33.632989
                            ],
                            [
                                110.90473,
                                33.628638
                            ],
                            [
                                110.940841,
                                33.620035
                            ],
                            [
                                110.951411,
                                33.609029
                            ],
                            [
                                110.966573,
                                33.609179
                            ],
                            [
                                110.979658,
                                33.595871
                            ],
                            [
                                111.003691,
                                33.578658
                            ],
                            [
                                111.009982,
                                33.56054
                            ],
                            [
                                111.025144,
                                33.550578
                            ],
                            [
                                111.058425,
                                33.555534
                            ],
                            [
                                111.070063,
                                33.566346
                            ],
                            [
                                111.089126,
                                33.563743
                            ],
                            [
                                111.102903,
                                33.573903
                            ],
                            [
                                111.114542,
                                33.578758
                            ],
                            [
                                111.123224,
                                33.598623
                            ],
                            [
                                111.133982,
                                33.612381
                            ],
                            [
                                111.134674,
                                33.627437
                            ],
                            [
                                111.143922,
                                33.633189
                            ],
                            [
                                111.152101,
                                33.645441
                            ],
                            [
                                111.146439,
                                33.658592
                            ],
                            [
                                111.140273,
                                33.661292
                            ],
                            [
                                111.133164,
                                33.678939
                            ],
                            [
                                111.141406,
                                33.678739
                            ],
                            [
                                111.151598,
                                33.684787
                            ],
                            [
                                111.170471,
                                33.682138
                            ],
                            [
                                111.181292,
                                33.686886
                            ],
                            [
                                111.186199,
                                33.704128
                            ],
                            [
                                111.195196,
                                33.713272
                            ],
                            [
                                111.197209,
                                33.732207
                            ],
                            [
                                111.194441,
                                33.745494
                            ],
                            [
                                111.196077,
                                33.757731
                            ],
                            [
                                111.208533,
                                33.781948
                            ],
                            [
                                111.222437,
                                33.797574
                            ],
                            [
                                111.234831,
                                33.801268
                            ],
                            [
                                111.240367,
                                33.796925
                            ],
                            [
                                111.260813,
                                33.796775
                            ],
                            [
                                111.261568,
                                33.822878
                            ],
                            [
                                111.240304,
                                33.842488
                            ],
                            [
                                111.232062,
                                33.856805
                            ],
                            [
                                111.216397,
                                33.865135
                            ],
                            [
                                111.21948,
                                33.872766
                            ],
                            [
                                111.203689,
                                33.883438
                            ],
                            [
                                111.206017,
                                33.891616
                            ],
                            [
                                111.212811,
                                33.884087
                            ],
                            [
                                111.234516,
                                33.894857
                            ],
                            [
                                111.234768,
                                33.901738
                            ],
                            [
                                111.226652,
                                33.913104
                            ],
                            [
                                111.230049,
                                33.924768
                            ],
                            [
                                111.239989,
                                33.933141
                            ],
                            [
                                111.259366,
                                33.929852
                            ],
                            [
                                111.276793,
                                33.935533
                            ],
                            [
                                111.29013,
                                33.926662
                            ],
                            [
                                111.303342,
                                33.928207
                            ],
                            [
                                111.305921,
                                33.941364
                            ],
                            [
                                111.324795,
                                33.963039
                            ],
                            [
                                111.344109,
                                33.973351
                            ],
                            [
                                111.356,
                                33.984509
                            ],
                            [
                                111.353609,
                                33.996263
                            ],
                            [
                                111.355119,
                                34.015185
                            ],
                            [
                                111.342285,
                                34.037936
                            ],
                            [
                                111.342096,
                                34.056053
                            ],
                            [
                                111.354301,
                                34.084464
                            ],
                            [
                                111.367198,
                                34.092473
                            ],
                            [
                                111.358768,
                                34.108788
                            ],
                            [
                                111.344738,
                                34.109037
                            ],
                            [
                                111.334735,
                                34.115601
                            ],
                            [
                                111.313408,
                                34.116546
                            ],
                            [
                                111.306362,
                                34.125149
                            ],
                            [
                                111.305292,
                                34.140165
                            ],
                            [
                                111.296925,
                                34.145137
                            ],
                            [
                                111.281889,
                                34.138524
                            ],
                            [
                                111.276856,
                                34.148318
                            ],
                            [
                                111.267922,
                                34.146528
                            ],
                            [
                                111.253201,
                                34.15309
                            ],
                            [
                                111.248671,
                                34.162882
                            ],
                            [
                                111.234516,
                                34.178537
                            ],
                            [
                                111.214699,
                                34.181221
                            ],
                            [
                                111.207401,
                                34.197419
                            ],
                            [
                                111.175819,
                                34.209541
                            ],
                            [
                                111.158958,
                                34.223101
                            ],
                            [
                                111.166571,
                                34.228962
                            ],
                            [
                                111.180915,
                                34.230203
                            ],
                            [
                                111.187772,
                                34.250265
                            ],
                            [
                                111.182488,
                                34.256421
                            ],
                            [
                                111.181921,
                                34.27876
                            ],
                            [
                                111.191547,
                                34.301837
                            ],
                            [
                                111.185444,
                                34.31697
                            ],
                            [
                                111.16915,
                                34.334878
                            ],
                            [
                                111.166634,
                                34.344798
                            ],
                            [
                                111.159839,
                                34.350799
                            ],
                            [
                                111.141217,
                                34.353031
                            ],
                            [
                                111.138449,
                                34.35675
                            ],
                            [
                                111.141217,
                                34.373113
                            ],
                            [
                                111.147949,
                                34.38853
                            ],
                            [
                                111.156819,
                                34.394677
                            ],
                            [
                                111.171415,
                                34.394974
                            ],
                            [
                                111.188967,
                                34.399286
                            ],
                            [
                                111.191232,
                                34.41792
                            ],
                            [
                                111.197712,
                                34.418762
                            ],
                            [
                                111.21344,
                                34.429812
                            ],
                            [
                                111.213252,
                                34.437441
                            ],
                            [
                                111.220235,
                                34.457949
                            ],
                            [
                                111.227533,
                                34.459732
                            ],
                            [
                                111.244708,
                                34.453788
                            ],
                            [
                                111.272012,
                                34.447547
                            ],
                            [
                                111.271383,
                                34.470677
                            ],
                            [
                                111.289313,
                                34.485581
                            ],
                            [
                                111.300008,
                                34.488948
                            ],
                            [
                                111.306676,
                                34.474193
                            ],
                            [
                                111.324732,
                                34.471717
                            ],
                            [
                                111.344424,
                                34.472955
                            ],
                            [
                                111.358642,
                                34.480333
                            ],
                            [
                                111.370595,
                                34.473301
                            ],
                            [
                                111.385065,
                                34.473103
                            ],
                            [
                                111.394816,
                                34.482016
                            ],
                            [
                                111.418346,
                                34.490829
                            ],
                            [
                                111.451689,
                                34.505928
                            ],
                            [
                                111.45754,
                                34.512561
                            ],
                            [
                                111.484655,
                                34.525528
                            ],
                            [
                                111.489437,
                                34.533842
                            ],
                            [
                                111.5029,
                                34.545074
                            ],
                            [
                                111.525045,
                                34.54829
                            ],
                            [
                                111.538634,
                                34.543342
                            ],
                            [
                                111.544736,
                                34.544925
                            ],
                            [
                                111.562037,
                                34.558728
                            ],
                            [
                                111.574305,
                                34.564467
                            ],
                            [
                                111.584434,
                                34.556057
                            ],
                            [
                                111.594437,
                                34.565308
                            ],
                            [
                                111.608089,
                                34.56229
                            ],
                            [
                                111.619099,
                                34.55576
                            ],
                            [
                                111.670058,
                                34.540571
                            ],
                            [
                                111.683584,
                                34.533298
                            ],
                            [
                                111.692643,
                                34.535673
                            ],
                            [
                                111.681445,
                                34.547647
                            ],
                            [
                                111.672008,
                                34.572232
                            ],
                            [
                                111.687044,
                                34.571886
                            ],
                            [
                                111.696292,
                                34.575744
                            ],
                            [
                                111.702835,
                                34.584943
                            ],
                            [
                                111.740079,
                                34.600272
                            ],
                            [
                                111.758764,
                                34.597454
                            ],
                            [
                                111.764112,
                                34.609171
                            ],
                            [
                                111.778393,
                                34.608331
                            ],
                            [
                                111.797078,
                                34.626028
                            ],
                            [
                                111.811296,
                                34.633887
                            ],
                            [
                                111.821362,
                                34.634431
                            ],
                            [
                                111.823752,
                                34.646242
                            ],
                            [
                                111.830736,
                                34.649207
                            ],
                            [
                                111.863953,
                                34.647082
                            ],
                            [
                                111.888867,
                                34.61891
                            ],
                            [
                                111.905664,
                                34.6198
                            ],
                            [
                                111.928879,
                                34.600272
                            ],
                            [
                                111.94165,
                                34.620492
                            ],
                            [
                                111.943223,
                                34.629637
                            ],
                            [
                                111.953666,
                                34.639521
                            ],
                            [
                                111.967444,
                                34.64308
                            ],
                            [
                                111.971408,
                                34.65069
                            ],
                            [
                                111.980089,
                                34.654
                            ],
                            [
                                111.972855,
                                34.66739
                            ],
                            [
                                111.984997,
                                34.686013
                            ],
                            [
                                111.982921,
                                34.695052
                            ],
                            [
                                111.993238,
                                34.693866
                            ],
                            [
                                111.997642,
                                34.717125
                            ],
                            [
                                112.01488,
                                34.724235
                            ],
                            [
                                112.014125,
                                34.731048
                            ],
                            [
                                111.995692,
                                34.736823
                            ],
                            [
                                112.000536,
                                34.745017
                            ],
                            [
                                111.997831,
                                34.750693
                            ],
                            [
                                112.011042,
                                34.750644
                            ],
                            [
                                112.019347,
                                34.762587
                            ],
                            [
                                112.017459,
                                34.769939
                            ],
                            [
                                112.031174,
                                34.777735
                            ],
                            [
                                112.028784,
                                34.778968
                            ],
                            [
                                112.021171,
                                34.777537
                            ],
                            [
                                112.018466,
                                34.785678
                            ],
                            [
                                112.030231,
                                34.782668
                            ],
                            [
                                112.031992,
                                34.782965
                            ],
                            [
                                112.030105,
                                34.792584
                            ],
                            [
                                112.016327,
                                34.797073
                            ],
                            [
                                112.012804,
                                34.803781
                            ],
                            [
                                112.020731,
                                34.811327
                            ],
                            [
                                112.01444,
                                34.817985
                            ],
                            [
                                111.986003,
                                34.837856
                            ],
                            [
                                111.982858,
                                34.846139
                            ],
                            [
                                111.990722,
                                34.853779
                            ],
                            [
                                111.981411,
                                34.857624
                            ],
                            [
                                111.957944,
                                34.851167
                            ],
                            [
                                111.948948,
                                34.852301
                            ],
                            [
                                111.949829,
                                34.863391
                            ],
                            [
                                111.922336,
                                34.883941
                            ],
                            [
                                111.898744,
                                34.885912
                            ],
                            [
                                111.883267,
                                34.894239
                            ],
                            [
                                111.88396,
                                34.911974
                            ],
                            [
                                111.890062,
                                34.920347
                            ],
                            [
                                111.906168,
                                34.929606
                            ],
                            [
                                111.921707,
                                34.934038
                            ],
                            [
                                111.933975,
                                34.947678
                            ],
                            [
                                111.950835,
                                34.947776
                            ],
                            [
                                111.981914,
                                34.960626
                            ],
                            [
                                111.983235,
                                34.970471
                            ],
                            [
                                111.961153,
                                34.975689
                            ],
                            [
                                111.95763,
                                34.986221
                            ],
                            [
                                111.967192,
                                34.989912
                            ],
                            [
                                111.981033,
                                34.990059
                            ],
                            [
                                111.978139,
                                34.997195
                            ],
                            [
                                111.991917,
                                35.005018
                            ],
                            [
                                111.967067,
                                35.014169
                            ],
                            [
                                111.940203,
                                35.030599
                            ],
                            [
                                111.939511,
                                35.0366
                            ],
                            [
                                111.958573,
                                35.0486
                            ],
                            [
                                111.958699,
                                35.062908
                            ],
                            [
                                111.973358,
                                35.070234
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                112.031992,
                                34.782965
                            ],
                            [
                                112.030231,
                                34.782668
                            ],
                            [
                                112.028784,
                                34.778968
                            ],
                            [
                                112.031174,
                                34.777735
                            ],
                            [
                                112.031992,
                                34.782965
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 411300,
                "name": "南阳市",
                "center": [
                    112.540918,
                    32.999082
                ],
                "centroid": [
                    112.288385,
                    33.044723
                ],
                "childrenNum": 13,
                "level": "city",
                "parent": {
                    "adcode": 410000
                },
                "subFeatureIndex": 12,
                "acroutes": [
                    100000,
                    410000
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                111.009982,
                                33.56054
                            ],
                            [
                                111.003691,
                                33.548075
                            ],
                            [
                                111.003565,
                                33.533105
                            ],
                            [
                                111.019482,
                                33.520837
                            ],
                            [
                                111.027346,
                                33.493139
                            ],
                            [
                                111.027346,
                                33.469542
                            ],
                            [
                                111.020866,
                                33.45085
                            ],
                            [
                                110.996708,
                                33.435963
                            ],
                            [
                                111.011429,
                                33.407336
                            ],
                            [
                                111.011052,
                                33.398861
                            ],
                            [
                                111.017406,
                                33.385019
                            ],
                            [
                                111.026151,
                                33.375338
                            ],
                            [
                                111.02722,
                                33.365506
                            ],
                            [
                                111.023005,
                                33.35487
                            ],
                            [
                                111.029988,
                                33.339415
                            ],
                            [
                                111.026025,
                                33.330382
                            ],
                            [
                                111.000356,
                                33.323957
                            ],
                            [
                                110.999476,
                                33.313416
                            ],
                            [
                                111.007969,
                                33.303678
                            ],
                            [
                                110.998469,
                                33.301418
                            ],
                            [
                                110.997903,
                                33.290975
                            ],
                            [
                                110.991297,
                                33.276112
                            ],
                            [
                                110.982867,
                                33.270085
                            ],
                            [
                                110.997022,
                                33.254766
                            ],
                            [
                                110.985006,
                                33.255419
                            ],
                            [
                                110.997274,
                                33.238941
                            ],
                            [
                                111.01231,
                                33.233113
                            ],
                            [
                                111.016714,
                                33.223968
                            ],
                            [
                                111.030366,
                                33.214571
                            ],
                            [
                                111.032442,
                                33.209345
                            ],
                            [
                                111.051441,
                                33.20065
                            ],
                            [
                                111.057858,
                                33.183609
                            ],
                            [
                                111.037223,
                                33.160984
                            ],
                            [
                                111.045527,
                                33.158168
                            ],
                            [
                                111.061885,
                                33.174006
                            ],
                            [
                                111.073272,
                                33.180643
                            ],
                            [
                                111.088811,
                                33.182051
                            ],
                            [
                                111.0985,
                                33.176923
                            ],
                            [
                                111.106678,
                                33.164453
                            ],
                            [
                                111.128257,
                                33.154547
                            ],
                            [
                                111.132032,
                                33.137749
                            ],
                            [
                                111.139267,
                                33.134379
                            ],
                            [
                                111.146313,
                                33.123815
                            ],
                            [
                                111.162544,
                                33.124268
                            ],
                            [
                                111.179531,
                                33.115463
                            ],
                            [
                                111.177014,
                                33.101174
                            ],
                            [
                                111.190918,
                                33.086731
                            ],
                            [
                                111.192868,
                                33.071631
                            ],
                            [
                                111.167829,
                                33.06398
                            ],
                            [
                                111.15078,
                                33.053206
                            ],
                            [
                                111.148263,
                                33.042381
                            ],
                            [
                                111.152982,
                                33.039712
                            ],
                            [
                                111.179845,
                                33.043942
                            ],
                            [
                                111.189345,
                                33.038655
                            ],
                            [
                                111.221682,
                                33.042633
                            ],
                            [
                                111.24043,
                                33.037194
                            ],
                            [
                                111.240556,
                                33.019971
                            ],
                            [
                                111.2588,
                                33.006472
                            ],
                            [
                                111.269495,
                                32.987831
                            ],
                            [
                                111.273647,
                                32.971858
                            ],
                            [
                                111.267797,
                                32.963744
                            ],
                            [
                                111.253138,
                                32.955781
                            ],
                            [
                                111.245526,
                                32.944188
                            ],
                            [
                                111.24282,
                                32.930627
                            ],
                            [
                                111.24993,
                                32.91424
                            ],
                            [
                                111.246344,
                                32.888518
                            ],
                            [
                                111.2549,
                                32.884029
                            ],
                            [
                                111.269621,
                                32.898455
                            ],
                            [
                                111.280127,
                                32.904355
                            ],
                            [
                                111.290697,
                                32.892554
                            ],
                            [
                                111.289879,
                                32.86506
                            ],
                            [
                                111.293528,
                                32.859409
                            ],
                            [
                                111.316365,
                                32.85078
                            ],
                            [
                                111.331275,
                                32.841142
                            ],
                            [
                                111.358642,
                                32.837003
                            ],
                            [
                                111.380032,
                                32.828827
                            ],
                            [
                                111.385065,
                                32.821305
                            ],
                            [
                                111.396138,
                                32.794547
                            ],
                            [
                                111.405637,
                                32.782529
                            ],
                            [
                                111.404128,
                                32.77561
                            ],
                            [
                                111.41023,
                                32.769347
                            ],
                            [
                                111.413564,
                                32.757174
                            ],
                            [
                                111.422938,
                                32.751011
                            ],
                            [
                                111.437597,
                                32.750253
                            ],
                            [
                                111.447285,
                                32.754951
                            ],
                            [
                                111.448229,
                                32.761467
                            ],
                            [
                                111.46295,
                                32.764296
                            ],
                            [
                                111.461063,
                                32.771671
                            ],
                            [
                                111.468172,
                                32.770862
                            ],
                            [
                                111.475659,
                                32.758437
                            ],
                            [
                                111.469808,
                                32.753638
                            ],
                            [
                                111.46899,
                                32.738633
                            ],
                            [
                                111.456974,
                                32.72696
                            ],
                            [
                                111.444391,
                                32.736713
                            ],
                            [
                                111.441749,
                                32.726758
                            ],
                            [
                                111.431494,
                                32.735045
                            ],
                            [
                                111.425455,
                                32.73267
                            ],
                            [
                                111.44112,
                                32.722816
                            ],
                            [
                                111.464649,
                                32.722362
                            ],
                            [
                                111.472639,
                                32.717763
                            ],
                            [
                                111.467858,
                                32.707351
                            ],
                            [
                                111.479874,
                                32.694664
                            ],
                            [
                                111.513029,
                                32.673986
                            ],
                            [
                                111.526555,
                                32.654163
                            ],
                            [
                                111.524793,
                                32.647285
                            ],
                            [
                                111.530267,
                                32.628316
                            ],
                            [
                                111.55908,
                                32.601095
                            ],
                            [
                                111.57764,
                                32.593505
                            ],
                            [
                                111.603685,
                                32.610254
                            ],
                            [
                                111.618344,
                                32.627608
                            ],
                            [
                                111.634009,
                                32.635145
                            ],
                            [
                                111.640804,
                                32.634741
                            ],
                            [
                                111.640804,
                                32.617338
                            ],
                            [
                                111.646403,
                                32.606206
                            ],
                            [
                                111.673015,
                                32.61496
                            ],
                            [
                                111.69214,
                                32.605953
                            ],
                            [
                                111.713593,
                                32.60656
                            ],
                            [
                                111.729258,
                                32.594011
                            ],
                            [
                                111.740331,
                                32.589253
                            ],
                            [
                                111.747377,
                                32.577612
                            ],
                            [
                                111.766817,
                                32.56521
                            ],
                            [
                                111.785061,
                                32.557312
                            ],
                            [
                                111.809157,
                                32.536704
                            ],
                            [
                                111.827024,
                                32.538071
                            ],
                            [
                                111.828219,
                                32.531285
                            ],
                            [
                                111.858291,
                                32.528702
                            ],
                            [
                                111.862758,
                                32.513609
                            ],
                            [
                                111.870245,
                                32.506315
                            ],
                            [
                                111.889936,
                                32.503174
                            ],
                            [
                                111.915353,
                                32.507733
                            ],
                            [
                                111.932339,
                                32.51523
                            ],
                            [
                                111.948696,
                                32.517003
                            ],
                            [
                                111.956434,
                                32.512292
                            ],
                            [
                                111.966815,
                                32.494916
                            ],
                            [
                                111.977384,
                                32.471151
                            ],
                            [
                                111.992861,
                                32.467351
                            ],
                            [
                                111.990407,
                                32.457468
                            ],
                            [
                                112.001102,
                                32.459444
                            ],
                            [
                                112.007079,
                                32.45103
                            ],
                            [
                                112.014377,
                                32.450321
                            ],
                            [
                                112.032495,
                                32.462435
                            ],
                            [
                                112.038095,
                                32.470087
                            ],
                            [
                                112.047972,
                                32.473736
                            ],
                            [
                                112.064014,
                                32.474243
                            ],
                            [
                                112.069865,
                                32.460002
                            ],
                            [
                                112.065965,
                                32.444643
                            ],
                            [
                                112.07515,
                                32.436887
                            ],
                            [
                                112.086034,
                                32.435316
                            ],
                            [
                                112.081315,
                                32.425682
                            ],
                            [
                                112.084398,
                                32.419699
                            ],
                            [
                                112.093646,
                                32.418888
                            ],
                            [
                                112.108431,
                                32.40474
                            ],
                            [
                                112.12441,
                                32.398755
                            ],
                            [
                                112.130261,
                                32.403117
                            ],
                            [
                                112.13737,
                                32.390589
                            ],
                            [
                                112.156873,
                                32.377096
                            ],
                            [
                                112.164485,
                                32.385314
                            ],
                            [
                                112.150645,
                                32.384198
                            ],
                            [
                                112.161717,
                                32.399313
                            ],
                            [
                                112.146555,
                                32.403117
                            ],
                            [
                                112.150204,
                                32.411637
                            ],
                            [
                                112.164674,
                                32.411282
                            ],
                            [
                                112.172475,
                                32.405906
                            ],
                            [
                                112.172161,
                                32.39835
                            ],
                            [
                                112.178829,
                                32.392111
                            ],
                            [
                                112.17279,
                                32.385162
                            ],
                            [
                                112.205882,
                                32.392973
                            ],
                            [
                                112.229033,
                                32.385365
                            ],
                            [
                                112.230921,
                                32.377451
                            ],
                            [
                                112.251619,
                                32.368116
                            ],
                            [
                                112.255394,
                                32.359745
                            ],
                            [
                                112.261999,
                                32.358882
                            ],
                            [
                                112.288297,
                                32.345587
                            ],
                            [
                                112.299495,
                                32.334929
                            ],
                            [
                                112.32812,
                                32.321682
                            ],
                            [
                                112.329819,
                                32.338178
                            ],
                            [
                                112.338627,
                                32.34853
                            ],
                            [
                                112.351146,
                                32.350459
                            ],
                            [
                                112.360017,
                                32.36563
                            ],
                            [
                                112.368195,
                                32.367913
                            ],
                            [
                                112.38795,
                                32.363702
                            ],
                            [
                                112.39097,
                                32.37116
                            ],
                            [
                                112.414184,
                                32.363195
                            ],
                            [
                                112.417519,
                                32.357005
                            ],
                            [
                                112.450422,
                                32.342847
                            ],
                            [
                                112.445515,
                                32.355584
                            ],
                            [
                                112.460236,
                                32.368269
                            ],
                            [
                                112.472756,
                                32.371769
                            ],
                            [
                                112.477222,
                                32.380799
                            ],
                            [
                                112.495656,
                                32.374915
                            ],
                            [
                                112.506539,
                                32.380749
                            ],
                            [
                                112.521638,
                                32.383082
                            ],
                            [
                                112.531201,
                                32.377147
                            ],
                            [
                                112.544727,
                                32.395509
                            ],
                            [
                                112.545231,
                                32.403878
                            ],
                            [
                                112.561714,
                                32.398907
                            ],
                            [
                                112.577819,
                                32.387952
                            ],
                            [
                                112.57719,
                                32.382524
                            ],
                            [
                                112.58908,
                                32.381307
                            ],
                            [
                                112.59663,
                                32.385568
                            ],
                            [
                                112.61198,
                                32.387039
                            ],
                            [
                                112.630477,
                                32.379937
                            ],
                            [
                                112.645513,
                                32.368472
                            ],
                            [
                                112.672062,
                                32.368116
                            ],
                            [
                                112.685651,
                                32.357715
                            ],
                            [
                                112.713647,
                                32.35259
                            ],
                            [
                                112.719183,
                                32.361774
                            ],
                            [
                                112.73359,
                                32.366239
                            ],
                            [
                                112.734911,
                                32.351677
                            ],
                            [
                                112.754099,
                                32.342847
                            ],
                            [
                                112.767877,
                                32.344166
                            ],
                            [
                                112.77637,
                                32.358375
                            ],
                            [
                                112.804052,
                                32.372277
                            ],
                            [
                                112.835634,
                                32.381611
                            ],
                            [
                                112.860736,
                                32.395814
                            ],
                            [
                                112.870487,
                                32.397842
                            ],
                            [
                                112.878603,
                                32.392567
                            ],
                            [
                                112.877219,
                                32.379531
                            ],
                            [
                                112.888857,
                                32.376792
                            ],
                            [
                                112.902384,
                                32.388662
                            ],
                            [
                                112.911883,
                                32.390741
                            ],
                            [
                                112.948184,
                                32.388256
                            ],
                            [
                                112.960389,
                                32.385314
                            ],
                            [
                                112.969888,
                                32.37116
                            ],
                            [
                                112.98807,
                                32.372327
                            ],
                            [
                                112.991908,
                                32.378314
                            ],
                            [
                                112.988636,
                                32.399567
                            ],
                            [
                                113.00059,
                                32.416758
                            ],
                            [
                                113.012543,
                                32.417164
                            ],
                            [
                                113.025314,
                                32.424618
                            ],
                            [
                                113.05029,
                                32.417925
                            ],
                            [
                                113.058846,
                                32.404638
                            ],
                            [
                                113.078915,
                                32.394393
                            ],
                            [
                                113.107981,
                                32.398502
                            ],
                            [
                                113.118739,
                                32.375828
                            ],
                            [
                                113.150258,
                                32.376284
                            ],
                            [
                                113.155606,
                                32.380749
                            ],
                            [
                                113.159695,
                                32.400784
                            ],
                            [
                                113.159129,
                                32.410673
                            ],
                            [
                                113.172718,
                                32.42117
                            ],
                            [
                                113.185678,
                                32.42188
                            ],
                            [
                                113.211786,
                                32.431969
                            ],
                            [
                                113.226508,
                                32.42548
                            ],
                            [
                                113.236322,
                                32.406971
                            ],
                            [
                                113.259537,
                                32.390589
                            ],
                            [
                                113.273189,
                                32.384756
                            ],
                            [
                                113.295397,
                                32.367406
                            ],
                            [
                                113.298731,
                                32.35396
                            ],
                            [
                                113.325217,
                                32.346602
                            ],
                            [
                                113.333333,
                                32.335945
                            ],
                            [
                                113.31773,
                                32.327012
                            ],
                            [
                                113.31836,
                                32.319042
                            ],
                            [
                                113.332074,
                                32.316098
                            ],
                            [
                                113.347677,
                                32.298633
                            ],
                            [
                                113.365166,
                                32.294774
                            ],
                            [
                                113.376679,
                                32.298379
                            ],
                            [
                                113.394106,
                                32.288072
                            ],
                            [
                                113.397944,
                                32.279286
                            ],
                            [
                                113.410023,
                                32.278017
                            ],
                            [
                                113.420466,
                                32.269535
                            ],
                            [
                                113.428834,
                                32.270551
                            ],
                            [
                                113.471048,
                                32.299141
                            ],
                            [
                                113.480296,
                                32.298989
                            ],
                            [
                                113.500239,
                                32.312697
                            ],
                            [
                                113.511689,
                                32.316809
                            ],
                            [
                                113.528738,
                                32.330362
                            ],
                            [
                                113.542013,
                                32.326809
                            ],
                            [
                                113.550066,
                                32.328737
                            ],
                            [
                                113.547675,
                                32.316047
                            ],
                            [
                                113.55082,
                                32.302543
                            ],
                            [
                                113.561516,
                                32.307366
                            ],
                            [
                                113.556608,
                                32.324169
                            ],
                            [
                                113.551261,
                                32.329245
                            ],
                            [
                                113.565227,
                                32.340208
                            ],
                            [
                                113.583032,
                                32.34305
                            ],
                            [
                                113.579194,
                                32.355229
                            ],
                            [
                                113.589637,
                                32.349495
                            ],
                            [
                                113.605617,
                                32.35056
                            ],
                            [
                                113.593286,
                                32.358578
                            ],
                            [
                                113.593727,
                                32.365275
                            ],
                            [
                                113.604233,
                                32.365174
                            ],
                            [
                                113.611845,
                                32.35873
                            ],
                            [
                                113.624994,
                                32.363601
                            ],
                            [
                                113.624617,
                                32.37948
                            ],
                            [
                                113.63657,
                                32.385923
                            ],
                            [
                                113.643302,
                                32.402559
                            ],
                            [
                                113.651228,
                                32.413412
                            ],
                            [
                                113.662741,
                                32.410115
                            ],
                            [
                                113.665006,
                                32.422235
                            ],
                            [
                                113.67199,
                                32.41762
                            ],
                            [
                                113.683817,
                                32.420206
                            ],
                            [
                                113.6908,
                                32.415846
                            ],
                            [
                                113.702187,
                                32.420206
                            ],
                            [
                                113.70785,
                                32.410318
                            ],
                            [
                                113.718608,
                                32.417215
                            ],
                            [
                                113.710555,
                                32.421221
                            ],
                            [
                                113.725339,
                                32.436025
                            ],
                            [
                                113.730875,
                                32.449307
                            ],
                            [
                                113.730498,
                                32.46061
                            ],
                            [
                                113.73767,
                                32.453362
                            ],
                            [
                                113.741319,
                                32.465374
                            ],
                            [
                                113.753398,
                                32.465425
                            ],
                            [
                                113.761828,
                                32.470645
                            ],
                            [
                                113.764219,
                                32.489951
                            ],
                            [
                                113.759375,
                                32.508797
                            ],
                            [
                                113.768245,
                                32.534425
                            ],
                            [
                                113.774285,
                                32.537362
                            ],
                            [
                                113.763212,
                                32.547895
                            ],
                            [
                                113.769126,
                                32.559287
                            ],
                            [
                                113.782023,
                                32.566172
                            ],
                            [
                                113.789698,
                                32.586368
                            ],
                            [
                                113.805301,
                                32.597705
                            ],
                            [
                                113.814423,
                                32.600842
                            ],
                            [
                                113.809264,
                                32.603828
                            ],
                            [
                                113.799072,
                                32.620879
                            ],
                            [
                                113.785169,
                                32.631402
                            ],
                            [
                                113.791963,
                                32.642075
                            ],
                            [
                                113.781079,
                                32.652595
                            ],
                            [
                                113.771894,
                                32.655276
                            ],
                            [
                                113.761199,
                                32.652697
                            ],
                            [
                                113.729114,
                                32.669688
                            ],
                            [
                                113.717727,
                                32.683694
                            ],
                            [
                                113.696274,
                                32.695624
                            ],
                            [
                                113.668404,
                                32.692389
                            ],
                            [
                                113.649089,
                                32.708261
                            ],
                            [
                                113.642987,
                                32.703106
                            ],
                            [
                                113.623358,
                                32.706138
                            ],
                            [
                                113.614676,
                                32.711344
                            ],
                            [
                                113.609832,
                                32.696484
                            ],
                            [
                                113.616941,
                                32.69158
                            ],
                            [
                                113.619332,
                                32.667362
                            ],
                            [
                                113.594041,
                                32.661092
                            ],
                            [
                                113.596243,
                                32.649763
                            ],
                            [
                                113.588882,
                                32.650421
                            ],
                            [
                                113.583535,
                                32.633577
                            ],
                            [
                                113.571582,
                                32.624775
                            ],
                            [
                                113.565416,
                                32.602715
                            ],
                            [
                                113.542264,
                                32.589152
                            ],
                            [
                                113.524397,
                                32.593505
                            ],
                            [
                                113.513513,
                                32.579384
                            ],
                            [
                                113.512759,
                                32.571538
                            ],
                            [
                                113.492752,
                                32.567741
                            ],
                            [
                                113.472621,
                                32.578574
                            ],
                            [
                                113.458843,
                                32.575689
                            ],
                            [
                                113.458528,
                                32.585508
                            ],
                            [
                                113.447393,
                                32.584698
                            ],
                            [
                                113.437893,
                                32.589203
                            ],
                            [
                                113.422354,
                                32.605245
                            ],
                            [
                                113.400712,
                                32.61324
                            ],
                            [
                                113.382216,
                                32.593353
                            ],
                            [
                                113.372024,
                                32.576245
                            ],
                            [
                                113.364537,
                                32.569462
                            ],
                            [
                                113.351577,
                                32.573664
                            ],
                            [
                                113.342832,
                                32.567893
                            ],
                            [
                                113.326349,
                                32.577561
                            ],
                            [
                                113.321631,
                                32.58733
                            ],
                            [
                                113.315717,
                                32.587988
                            ],
                            [
                                113.31037,
                                32.579536
                            ],
                            [
                                113.303135,
                                32.586723
                            ],
                            [
                                113.282311,
                                32.591986
                            ],
                            [
                                113.280486,
                                32.595984
                            ],
                            [
                                113.249785,
                                32.593555
                            ],
                            [
                                113.243871,
                                32.578827
                            ],
                            [
                                113.221286,
                                32.570424
                            ],
                            [
                                113.205432,
                                32.569969
                            ],
                            [
                                113.198575,
                                32.579536
                            ],
                            [
                                113.200651,
                                32.585103
                            ],
                            [
                                113.196121,
                                32.606156
                            ],
                            [
                                113.201783,
                                32.614504
                            ],
                            [
                                113.20279,
                                32.632262
                            ],
                            [
                                113.19222,
                                32.635398
                            ],
                            [
                                113.186181,
                                32.646476
                            ],
                            [
                                113.18788,
                                32.652241
                            ],
                            [
                                113.20172,
                                32.660333
                            ],
                            [
                                113.210276,
                                32.678941
                            ],
                            [
                                113.220594,
                                32.684452
                            ],
                            [
                                113.236196,
                                32.679143
                            ],
                            [
                                113.243305,
                                32.66984
                            ],
                            [
                                113.252679,
                                32.666907
                            ],
                            [
                                113.258467,
                                32.653961
                            ],
                            [
                                113.269351,
                                32.662053
                            ],
                            [
                                113.259914,
                                32.677778
                            ],
                            [
                                113.236259,
                                32.682581
                            ],
                            [
                                113.241103,
                                32.691429
                            ],
                            [
                                113.231226,
                                32.701488
                            ],
                            [
                                113.213736,
                                32.703055
                            ],
                            [
                                113.207697,
                                32.717257
                            ],
                            [
                                113.191528,
                                32.717712
                            ],
                            [
                                113.193982,
                                32.733378
                            ],
                            [
                                113.201343,
                                32.738835
                            ],
                            [
                                113.199959,
                                32.750253
                            ],
                            [
                                113.177247,
                                32.775307
                            ],
                            [
                                113.185237,
                                32.788286
                            ],
                            [
                                113.184294,
                                32.801364
                            ],
                            [
                                113.17838,
                                32.806665
                            ],
                            [
                                113.187062,
                                32.819943
                            ],
                            [
                                113.175737,
                                32.83241
                            ],
                            [
                                113.165797,
                                32.838063
                            ],
                            [
                                113.167999,
                                32.847046
                            ],
                            [
                                113.177059,
                                32.852446
                            ],
                            [
                                113.187062,
                                32.866422
                            ],
                            [
                                113.195681,
                                32.871871
                            ],
                            [
                                113.205558,
                                32.884937
                            ],
                            [
                                113.201154,
                                32.888821
                            ],
                            [
                                113.208137,
                                32.916408
                            ],
                            [
                                113.199015,
                                32.920291
                            ],
                            [
                                113.181714,
                                32.920644
                            ],
                            [
                                113.161897,
                                32.92745
                            ],
                            [
                                113.15592,
                                32.936122
                            ],
                            [
                                113.145854,
                                32.940306
                            ],
                            [
                                113.140129,
                                32.930627
                            ],
                            [
                                113.11553,
                                32.932996
                            ],
                            [
                                113.109805,
                                32.94202
                            ],
                            [
                                113.097789,
                                32.946406
                            ],
                            [
                                113.108799,
                                32.97332
                            ],
                            [
                                113.116097,
                                32.986421
                            ],
                            [
                                113.120312,
                                33.001182
                            ],
                            [
                                113.127358,
                                33.010552
                            ],
                            [
                                113.142016,
                                33.016647
                            ],
                            [
                                113.161456,
                                33.038906
                            ],
                            [
                                113.165546,
                                33.048977
                            ],
                            [
                                113.18574,
                                33.056932
                            ],
                            [
                                113.190019,
                                33.067202
                            ],
                            [
                                113.206124,
                                33.070826
                            ],
                            [
                                113.219273,
                                33.064584
                            ],
                            [
                                113.237077,
                                33.077017
                            ],
                            [
                                113.250477,
                                33.077822
                            ],
                            [
                                113.257335,
                                33.083409
                            ],
                            [
                                113.271427,
                                33.08049
                            ],
                            [
                                113.301436,
                                33.080138
                            ],
                            [
                                113.313138,
                                33.075608
                            ],
                            [
                                113.325469,
                                33.079181
                            ],
                            [
                                113.333836,
                                33.085976
                            ],
                            [
                                113.357239,
                                33.091613
                            ],
                            [
                                113.386619,
                                33.113451
                            ],
                            [
                                113.388821,
                                33.128393
                            ],
                            [
                                113.379888,
                                33.135485
                            ],
                            [
                                113.385424,
                                33.145595
                            ],
                            [
                                113.382467,
                                33.156156
                            ],
                            [
                                113.385802,
                                33.169381
                            ],
                            [
                                113.370136,
                                33.182855
                            ],
                            [
                                113.377875,
                                33.184313
                            ],
                            [
                                113.384417,
                                33.196679
                            ],
                            [
                                113.384103,
                                33.206128
                            ],
                            [
                                113.391212,
                                33.225928
                            ],
                            [
                                113.402851,
                                33.235224
                            ],
                            [
                                113.400146,
                                33.261044
                            ],
                            [
                                113.384732,
                                33.29203
                            ],
                            [
                                113.388318,
                                33.299059
                            ],
                            [
                                113.403857,
                                33.302724
                            ],
                            [
                                113.400838,
                                33.314722
                            ],
                            [
                                113.40738,
                                33.323004
                            ],
                            [
                                113.400397,
                                33.335852
                            ],
                            [
                                113.363908,
                                33.342476
                            ],
                            [
                                113.335472,
                                33.35201
                            ],
                            [
                                113.312194,
                                33.341121
                            ],
                            [
                                113.302632,
                                33.348999
                            ],
                            [
                                113.289923,
                                33.351709
                            ],
                            [
                                113.277089,
                                33.350254
                            ],
                            [
                                113.270609,
                                33.358834
                            ],
                            [
                                113.257964,
                                33.366158
                            ],
                            [
                                113.245004,
                                33.365356
                            ],
                            [
                                113.241418,
                                33.373733
                            ],
                            [
                                113.230534,
                                33.374937
                            ],
                            [
                                113.230912,
                                33.38848
                            ],
                            [
                                113.216316,
                                33.398861
                            ],
                            [
                                113.198134,
                                33.420523
                            ],
                            [
                                113.192975,
                                33.429797
                            ],
                            [
                                113.176052,
                                33.435713
                            ],
                            [
                                113.156109,
                                33.433607
                            ],
                            [
                                113.141765,
                                33.425987
                            ],
                            [
                                113.128742,
                                33.427642
                            ],
                            [
                                113.125659,
                                33.439723
                            ],
                            [
                                113.110309,
                                33.446138
                            ],
                            [
                                113.074826,
                                33.448444
                            ],
                            [
                                113.045698,
                                33.439472
                            ],
                            [
                                113.041357,
                                33.44659
                            ],
                            [
                                113.037897,
                                33.464331
                            ],
                            [
                                113.041168,
                                33.473701
                            ],
                            [
                                113.053373,
                                33.485725
                            ],
                            [
                                113.049221,
                                33.492087
                            ],
                            [
                                113.048214,
                                33.508317
                            ],
                            [
                                113.04381,
                                33.517532
                            ],
                            [
                                113.047333,
                                33.532204
                            ],
                            [
                                113.036261,
                                33.539865
                            ],
                            [
                                113.036701,
                                33.546974
                            ],
                            [
                                113.027642,
                                33.546874
                            ],
                            [
                                113.022861,
                                33.56119
                            ],
                            [
                                112.997255,
                                33.569399
                            ],
                            [
                                112.990775,
                                33.567797
                            ],
                            [
                                112.986497,
                                33.575805
                            ],
                            [
                                112.972908,
                                33.584613
                            ],
                            [
                                112.963597,
                                33.583662
                            ],
                            [
                                112.950134,
                                33.590968
                            ],
                            [
                                112.94271,
                                33.607629
                            ],
                            [
                                112.917545,
                                33.605627
                            ],
                            [
                                112.893513,
                                33.616133
                            ],
                            [
                                112.887914,
                                33.608329
                            ],
                            [
                                112.869669,
                                33.611531
                            ],
                            [
                                112.854822,
                                33.603626
                            ],
                            [
                                112.85262,
                                33.584413
                            ],
                            [
                                112.845637,
                                33.578107
                            ],
                            [
                                112.82022,
                                33.574804
                            ],
                            [
                                112.81179,
                                33.580309
                            ],
                            [
                                112.783668,
                                33.567747
                            ],
                            [
                                112.773413,
                                33.56079
                            ],
                            [
                                112.760076,
                                33.571751
                            ],
                            [
                                112.750387,
                                33.571151
                            ],
                            [
                                112.743215,
                                33.578858
                            ],
                            [
                                112.725411,
                                33.586765
                            ],
                            [
                                112.70572,
                                33.585263
                            ],
                            [
                                112.689174,
                                33.587165
                            ],
                            [
                                112.683889,
                                33.591718
                            ],
                            [
                                112.664386,
                                33.597673
                            ],
                            [
                                112.660234,
                                33.605377
                            ],
                            [
                                112.646205,
                                33.602876
                            ],
                            [
                                112.63444,
                                33.594821
                            ],
                            [
                                112.617705,
                                33.597272
                            ],
                            [
                                112.611351,
                                33.601875
                            ],
                            [
                                112.610785,
                                33.611431
                            ],
                            [
                                112.599775,
                                33.618084
                            ],
                            [
                                112.588388,
                                33.616883
                            ],
                            [
                                112.575995,
                                33.602275
                            ],
                            [
                                112.556869,
                                33.588166
                            ],
                            [
                                112.548502,
                                33.59367
                            ],
                            [
                                112.529943,
                                33.587915
                            ],
                            [
                                112.522771,
                                33.595521
                            ],
                            [
                                112.524721,
                                33.603826
                            ],
                            [
                                112.503394,
                                33.622185
                            ],
                            [
                                112.493202,
                                33.63899
                            ],
                            [
                                112.477159,
                                33.63764
                            ],
                            [
                                112.461683,
                                33.63994
                            ],
                            [
                                112.453756,
                                33.645291
                            ],
                            [
                                112.420727,
                                33.676389
                            ],
                            [
                                112.408019,
                                33.675439
                            ],
                            [
                                112.392479,
                                33.666991
                            ],
                            [
                                112.375116,
                                33.666891
                            ],
                            [
                                112.361086,
                                33.661242
                            ],
                            [
                                112.353285,
                                33.669941
                            ],
                            [
                                112.332839,
                                33.668391
                            ],
                            [
                                112.312455,
                                33.684887
                            ],
                            [
                                112.306541,
                                33.69978
                            ],
                            [
                                112.278168,
                                33.712373
                            ],
                            [
                                112.258854,
                                33.710624
                            ],
                            [
                                112.249354,
                                33.719018
                            ],
                            [
                                112.239917,
                                33.715321
                            ],
                            [
                                112.230103,
                                33.71702
                            ],
                            [
                                112.214752,
                                33.713972
                            ],
                            [
                                112.184995,
                                33.698731
                            ],
                            [
                                112.179207,
                                33.703278
                            ],
                            [
                                112.17776,
                                33.715621
                            ],
                            [
                                112.168638,
                                33.721766
                            ],
                            [
                                112.158509,
                                33.720117
                            ],
                            [
                                112.15033,
                                33.713672
                            ],
                            [
                                112.141774,
                                33.691634
                            ],
                            [
                                112.13089,
                                33.676939
                            ],
                            [
                                112.120573,
                                33.668841
                            ],
                            [
                                112.104719,
                                33.661392
                            ],
                            [
                                112.074018,
                                33.653142
                            ],
                            [
                                112.071312,
                                33.648192
                            ],
                            [
                                112.076345,
                                33.633689
                            ],
                            [
                                112.084146,
                                33.628988
                            ],
                            [
                                112.092199,
                                33.607228
                            ],
                            [
                                112.087481,
                                33.603076
                            ],
                            [
                                112.065713,
                                33.607479
                            ],
                            [
                                112.059044,
                                33.605227
                            ],
                            [
                                112.038535,
                                33.622386
                            ],
                            [
                                112.024757,
                                33.622436
                            ],
                            [
                                112.014943,
                                33.613632
                            ],
                            [
                                112.012301,
                                33.602626
                            ],
                            [
                                112.018655,
                                33.59437
                            ],
                            [
                                112.024191,
                                33.600024
                            ],
                            [
                                112.028343,
                                33.593019
                            ],
                            [
                                112.020353,
                                33.587715
                            ],
                            [
                                111.994182,
                                33.584913
                            ],
                            [
                                111.930137,
                                33.571051
                            ],
                            [
                                111.916359,
                                33.572102
                            ],
                            [
                                111.899184,
                                33.588666
                            ],
                            [
                                111.884526,
                                33.596121
                            ],
                            [
                                111.863953,
                                33.599174
                            ],
                            [
                                111.843444,
                                33.595821
                            ],
                            [
                                111.832749,
                                33.598723
                            ],
                            [
                                111.827716,
                                33.606228
                            ],
                            [
                                111.82759,
                                33.634189
                            ],
                            [
                                111.819411,
                                33.652892
                            ],
                            [
                                111.778078,
                                33.666091
                            ],
                            [
                                111.728629,
                                33.688086
                            ],
                            [
                                111.719003,
                                33.688885
                            ],
                            [
                                111.684968,
                                33.677489
                            ],
                            [
                                111.665151,
                                33.695582
                            ],
                            [
                                111.645207,
                                33.720517
                            ],
                            [
                                111.619476,
                                33.730059
                            ],
                            [
                                111.59148,
                                33.727711
                            ],
                            [
                                111.567699,
                                33.735005
                            ],
                            [
                                111.541402,
                                33.733406
                            ],
                            [
                                111.523975,
                                33.742847
                            ],
                            [
                                111.516048,
                                33.7405
                            ],
                            [
                                111.495476,
                                33.725663
                            ],
                            [
                                111.484529,
                                33.726462
                            ],
                            [
                                111.469808,
                                33.738052
                            ],
                            [
                                111.4342,
                                33.747742
                            ],
                            [
                                111.398906,
                                33.768168
                            ],
                            [
                                111.390035,
                                33.771264
                            ],
                            [
                                111.348387,
                                33.764822
                            ],
                            [
                                111.336245,
                                33.768317
                            ],
                            [
                                111.322467,
                                33.762974
                            ],
                            [
                                111.315044,
                                33.764073
                            ],
                            [
                                111.304223,
                                33.775008
                            ],
                            [
                                111.288558,
                                33.779702
                            ],
                            [
                                111.270816,
                                33.781699
                            ],
                            [
                                111.260813,
                                33.796775
                            ],
                            [
                                111.240367,
                                33.796925
                            ],
                            [
                                111.234831,
                                33.801268
                            ],
                            [
                                111.222437,
                                33.797574
                            ],
                            [
                                111.208533,
                                33.781948
                            ],
                            [
                                111.196077,
                                33.757731
                            ],
                            [
                                111.194441,
                                33.745494
                            ],
                            [
                                111.197209,
                                33.732207
                            ],
                            [
                                111.195196,
                                33.713272
                            ],
                            [
                                111.186199,
                                33.704128
                            ],
                            [
                                111.181292,
                                33.686886
                            ],
                            [
                                111.170471,
                                33.682138
                            ],
                            [
                                111.151598,
                                33.684787
                            ],
                            [
                                111.141406,
                                33.678739
                            ],
                            [
                                111.133164,
                                33.678939
                            ],
                            [
                                111.140273,
                                33.661292
                            ],
                            [
                                111.146439,
                                33.658592
                            ],
                            [
                                111.152101,
                                33.645441
                            ],
                            [
                                111.143922,
                                33.633189
                            ],
                            [
                                111.134674,
                                33.627437
                            ],
                            [
                                111.133982,
                                33.612381
                            ],
                            [
                                111.123224,
                                33.598623
                            ],
                            [
                                111.114542,
                                33.578758
                            ],
                            [
                                111.102903,
                                33.573903
                            ],
                            [
                                111.089126,
                                33.563743
                            ],
                            [
                                111.070063,
                                33.566346
                            ],
                            [
                                111.058425,
                                33.555534
                            ],
                            [
                                111.025144,
                                33.550578
                            ],
                            [
                                111.009982,
                                33.56054
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                111.033889,
                                33.178029
                            ],
                            [
                                111.037789,
                                33.184816
                            ],
                            [
                                111.032064,
                                33.188686
                            ],
                            [
                                111.015833,
                                33.174057
                            ],
                            [
                                111.033889,
                                33.178029
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                112.734093,
                                32.356751
                            ],
                            [
                                112.730885,
                                32.363144
                            ],
                            [
                                112.723021,
                                32.360962
                            ],
                            [
                                112.734093,
                                32.356751
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 411400,
                "name": "商丘市",
                "center": [
                    115.650497,
                    34.437054
                ],
                "centroid": [
                    115.702245,
                    34.28898
                ],
                "childrenNum": 9,
                "level": "city",
                "parent": {
                    "adcode": 410000
                },
                "subFeatureIndex": 13,
                "acroutes": [
                    100000,
                    410000
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                115.653601,
                                34.060084
                            ],
                            [
                                115.66914,
                                34.0567
                            ],
                            [
                                115.681848,
                                34.065508
                            ],
                            [
                                115.698205,
                                34.066403
                            ],
                            [
                                115.706007,
                                34.059835
                            ],
                            [
                                115.735827,
                                34.076852
                            ],
                            [
                                115.768856,
                                34.062174
                            ],
                            [
                                115.781438,
                                34.062223
                            ],
                            [
                                115.780243,
                                34.073121
                            ],
                            [
                                115.793455,
                                34.063666
                            ],
                            [
                                115.80912,
                                34.062472
                            ],
                            [
                                115.815537,
                                34.052867
                            ],
                            [
                                115.832209,
                                34.038533
                            ],
                            [
                                115.845231,
                                34.030867
                            ],
                            [
                                115.845483,
                                34.012048
                            ],
                            [
                                115.852718,
                                34.003832
                            ],
                            [
                                115.877065,
                                34.003135
                            ],
                            [
                                115.876751,
                                34.028826
                            ],
                            [
                                115.887257,
                                34.032759
                            ],
                            [
                                115.89531,
                                34.028727
                            ],
                            [
                                115.899336,
                                34.014737
                            ],
                            [
                                115.904369,
                                34.009957
                            ],
                            [
                                115.919783,
                                34.010803
                            ],
                            [
                                115.926703,
                                34.007865
                            ],
                            [
                                115.957593,
                                34.007716
                            ],
                            [
                                115.967596,
                                34.002089
                            ],
                            [
                                115.984016,
                                33.987846
                            ],
                            [
                                115.994963,
                                33.975095
                            ],
                            [
                                116.00031,
                                33.963238
                            ],
                            [
                                115.995529,
                                33.947593
                            ],
                            [
                                115.982695,
                                33.917192
                            ],
                            [
                                115.987036,
                                33.901189
                            ],
                            [
                                115.999178,
                                33.901937
                            ],
                            [
                                116.012515,
                                33.8974
                            ],
                            [
                                116.013459,
                                33.885732
                            ],
                            [
                                116.034535,
                                33.880047
                            ],
                            [
                                116.059196,
                                33.860945
                            ],
                            [
                                116.056743,
                                33.850919
                            ],
                            [
                                116.06511,
                                33.847477
                            ],
                            [
                                116.063474,
                                33.826222
                            ],
                            [
                                116.045922,
                                33.829016
                            ],
                            [
                                116.045418,
                                33.822978
                            ],
                            [
                                116.058064,
                                33.821381
                            ],
                            [
                                116.062342,
                                33.814494
                            ],
                            [
                                116.055421,
                                33.804812
                            ],
                            [
                                116.073351,
                                33.79403
                            ],
                            [
                                116.074421,
                                33.781549
                            ],
                            [
                                116.099083,
                                33.783097
                            ],
                            [
                                116.098894,
                                33.774859
                            ],
                            [
                                116.109274,
                                33.75818
                            ],
                            [
                                116.131671,
                                33.752237
                            ],
                            [
                                116.155389,
                                33.709924
                            ],
                            [
                                116.174074,
                                33.709025
                            ],
                            [
                                116.197289,
                                33.725363
                            ],
                            [
                                116.204964,
                                33.726812
                            ],
                            [
                                116.226669,
                                33.722466
                            ],
                            [
                                116.230192,
                                33.734855
                            ],
                            [
                                116.246046,
                                33.72871
                            ],
                            [
                                116.263598,
                                33.730059
                            ],
                            [
                                116.284674,
                                33.75009
                            ],
                            [
                                116.30814,
                                33.757581
                            ],
                            [
                                116.316822,
                                33.771313
                            ],
                            [
                                116.328712,
                                33.76637
                            ],
                            [
                                116.330663,
                                33.77386
                            ],
                            [
                                116.348718,
                                33.778753
                            ],
                            [
                                116.361049,
                                33.776307
                            ],
                            [
                                116.372499,
                                33.780251
                            ],
                            [
                                116.393701,
                                33.783097
                            ],
                            [
                                116.408234,
                                33.80551
                            ],
                            [
                                116.42176,
                                33.796076
                            ],
                            [
                                116.432581,
                                33.795328
                            ],
                            [
                                116.436984,
                                33.803065
                            ],
                            [
                                116.43365,
                                33.812099
                            ],
                            [
                                116.437362,
                                33.846529
                            ],
                            [
                                116.453027,
                                33.846928
                            ],
                            [
                                116.460199,
                                33.859948
                            ],
                            [
                                116.473977,
                                33.861294
                            ],
                            [
                                116.484861,
                                33.869774
                            ],
                            [
                                116.50191,
                                33.864686
                            ],
                            [
                                116.505307,
                                33.872317
                            ],
                            [
                                116.521224,
                                33.87107
                            ],
                            [
                                116.525187,
                                33.880496
                            ],
                            [
                                116.536889,
                                33.882291
                            ],
                            [
                                116.53928,
                                33.874212
                            ],
                            [
                                116.546641,
                                33.882541
                            ],
                            [
                                116.558405,
                                33.881493
                            ],
                            [
                                116.555071,
                                33.888275
                            ],
                            [
                                116.558342,
                                33.901688
                            ],
                            [
                                116.567024,
                                33.908219
                            ],
                            [
                                116.58162,
                                33.908318
                            ],
                            [
                                116.597096,
                                33.904131
                            ],
                            [
                                116.611818,
                                33.894658
                            ],
                            [
                                116.627294,
                                33.888624
                            ],
                            [
                                116.642708,
                                33.892464
                            ],
                            [
                                116.638492,
                                33.917192
                            ],
                            [
                                116.64579,
                                33.929902
                            ],
                            [
                                116.640002,
                                33.948889
                            ],
                            [
                                116.65032,
                                33.959103
                            ],
                            [
                                116.648055,
                                33.973351
                            ],
                            [
                                116.633522,
                                33.977087
                            ],
                            [
                                116.629936,
                                33.98406
                            ],
                            [
                                116.607225,
                                33.999898
                            ],
                            [
                                116.607414,
                                34.007119
                            ],
                            [
                                116.600431,
                                34.011749
                            ],
                            [
                                116.604079,
                                34.023201
                            ],
                            [
                                116.596593,
                                34.038583
                            ],
                            [
                                116.587408,
                                34.04575
                            ],
                            [
                                116.57061,
                                34.070981
                            ],
                            [
                                116.566898,
                                34.083768
                            ],
                            [
                                116.557965,
                                34.097796
                            ],
                            [
                                116.539657,
                                34.103466
                            ],
                            [
                                116.541482,
                                34.109932
                            ],
                            [
                                116.528018,
                                34.122862
                            ],
                            [
                                116.534624,
                                34.126591
                            ],
                            [
                                116.536008,
                                34.151002
                            ],
                            [
                                116.545886,
                                34.161043
                            ],
                            [
                                116.565514,
                                34.169542
                            ],
                            [
                                116.5596,
                                34.186488
                            ],
                            [
                                116.546263,
                                34.194686
                            ],
                            [
                                116.542677,
                                34.218879
                            ],
                            [
                                116.547144,
                                34.228167
                            ],
                            [
                                116.543621,
                                34.239539
                            ],
                            [
                                116.553938,
                                34.241923
                            ],
                            [
                                116.567653,
                                34.251258
                            ],
                            [
                                116.582312,
                                34.266499
                            ],
                            [
                                116.582438,
                                34.275236
                            ],
                            [
                                116.566458,
                                34.284369
                            ],
                            [
                                116.51185,
                                34.296478
                            ],
                            [
                                116.490145,
                                34.29092
                            ],
                            [
                                116.466302,
                                34.271166
                            ],
                            [
                                116.456865,
                                34.26913
                            ],
                            [
                                116.448623,
                                34.280348
                            ],
                            [
                                116.452775,
                                34.286552
                            ],
                            [
                                116.445792,
                                34.288141
                            ],
                            [
                                116.430693,
                                34.278065
                            ],
                            [
                                116.43321,
                                34.270123
                            ],
                            [
                                116.416223,
                                34.268237
                            ],
                            [
                                116.406094,
                                34.276527
                            ],
                            [
                                116.393952,
                                34.276129
                            ],
                            [
                                116.37596,
                                34.271315
                            ],
                            [
                                116.372248,
                                34.266102
                            ],
                            [
                                116.363251,
                                34.276229
                            ],
                            [
                                116.37338,
                                34.293947
                            ],
                            [
                                116.365013,
                                34.312406
                            ],
                            [
                                116.357652,
                                34.319798
                            ],
                            [
                                116.329656,
                                34.32972
                            ],
                            [
                                116.301597,
                                34.34212
                            ],
                            [
                                116.288826,
                                34.358932
                            ],
                            [
                                116.276747,
                                34.360419
                            ],
                            [
                                116.270833,
                                34.370733
                            ],
                            [
                                116.255608,
                                34.376484
                            ],
                            [
                                116.23988,
                                34.37455
                            ],
                            [
                                116.213583,
                                34.382235
                            ],
                            [
                                116.209934,
                                34.390216
                            ],
                            [
                                116.217043,
                                34.395569
                            ],
                            [
                                116.215911,
                                34.40335
                            ],
                            [
                                116.205278,
                                34.41569
                            ],
                            [
                                116.179233,
                                34.430505
                            ],
                            [
                                116.174955,
                                34.444674
                            ],
                            [
                                116.162058,
                                34.459385
                            ],
                            [
                                116.178855,
                                34.483551
                            ],
                            [
                                116.178604,
                                34.496028
                            ],
                            [
                                116.189487,
                                34.497067
                            ],
                            [
                                116.203957,
                                34.508651
                            ],
                            [
                                116.203831,
                                34.518748
                            ],
                            [
                                116.190997,
                                34.535673
                            ],
                            [
                                116.196345,
                                34.555661
                            ],
                            [
                                116.197037,
                                34.575942
                            ],
                            [
                                116.190117,
                                34.570501
                            ],
                            [
                                116.156647,
                                34.553732
                            ],
                            [
                                116.146896,
                                34.553188
                            ],
                            [
                                116.134565,
                                34.559718
                            ],
                            [
                                116.124814,
                                34.572331
                            ],
                            [
                                116.117893,
                                34.58974
                            ],
                            [
                                116.101284,
                                34.60581
                            ],
                            [
                                116.082662,
                                34.608331
                            ],
                            [
                                116.055107,
                                34.595426
                            ],
                            [
                                116.037554,
                                34.593053
                            ],
                            [
                                116.023902,
                                34.601953
                            ],
                            [
                                116.010187,
                                34.615845
                            ],
                            [
                                116.001568,
                                34.619009
                            ],
                            [
                                115.991377,
                                34.615351
                            ],
                            [
                                115.984771,
                                34.607243
                            ],
                            [
                                115.984016,
                                34.589295
                            ],
                            [
                                115.969987,
                                34.582619
                            ],
                            [
                                115.946206,
                                34.581629
                            ],
                            [
                                115.858317,
                                34.569957
                            ],
                            [
                                115.849698,
                                34.565604
                            ],
                            [
                                115.838122,
                                34.567781
                            ],
                            [
                                115.838814,
                                34.560559
                            ],
                            [
                                115.827427,
                                34.558283
                            ],
                            [
                                115.795971,
                                34.578464
                            ],
                            [
                                115.762061,
                                34.587712
                            ],
                            [
                                115.724503,
                                34.589196
                            ],
                            [
                                115.71148,
                                34.59869
                            ],
                            [
                                115.699086,
                                34.598838
                            ],
                            [
                                115.697325,
                                34.569017
                            ],
                            [
                                115.684428,
                                34.555612
                            ],
                            [
                                115.669455,
                                34.556948
                            ],
                            [
                                115.643598,
                                34.567731
                            ],
                            [
                                115.639508,
                                34.57154
                            ],
                            [
                                115.621893,
                                34.574755
                            ],
                            [
                                115.61038,
                                34.572084
                            ],
                            [
                                115.585215,
                                34.570996
                            ],
                            [
                                115.561183,
                                34.572232
                            ],
                            [
                                115.554765,
                                34.569067
                            ],
                            [
                                115.535137,
                                34.573321
                            ],
                            [
                                115.515634,
                                34.582619
                            ],
                            [
                                115.491602,
                                34.606996
                            ],
                            [
                                115.479019,
                                34.62588
                            ],
                            [
                                115.461404,
                                34.637248
                            ],
                            [
                                115.458132,
                                34.656175
                            ],
                            [
                                115.444732,
                                34.674504
                            ],
                            [
                                115.44706,
                                34.698608
                            ],
                            [
                                115.444921,
                                34.710311
                            ],
                            [
                                115.433848,
                                34.725074
                            ],
                            [
                                115.437308,
                                34.734306
                            ],
                            [
                                115.449324,
                                34.744277
                            ],
                            [
                                115.436553,
                                34.776797
                            ],
                            [
                                115.436113,
                                34.785037
                            ],
                            [
                                115.426802,
                                34.805409
                            ],
                            [
                                115.413842,
                                34.807826
                            ],
                            [
                                115.41617,
                                34.8133
                            ],
                            [
                                115.408557,
                                34.825924
                            ],
                            [
                                115.394025,
                                34.831792
                            ],
                            [
                                115.37924,
                                34.828784
                            ],
                            [
                                115.356969,
                                34.837314
                            ],
                            [
                                115.346022,
                                34.846188
                            ],
                            [
                                115.329602,
                                34.851463
                            ],
                            [
                                115.317146,
                                34.859201
                            ],
                            [
                                115.302361,
                                34.858807
                            ],
                            [
                                115.28959,
                                34.85161
                            ],
                            [
                                115.267445,
                                34.853533
                            ],
                            [
                                115.256058,
                                34.845301
                            ],
                            [
                                115.267256,
                                34.831249
                            ],
                            [
                                115.256561,
                                34.81187
                            ],
                            [
                                115.242658,
                                34.813497
                            ],
                            [
                                115.253919,
                                34.805014
                            ],
                            [
                                115.24832,
                                34.798109
                            ],
                            [
                                115.202897,
                                34.805656
                            ],
                            [
                                115.198367,
                                34.795297
                            ],
                            [
                                115.17899,
                                34.800279
                            ],
                            [
                                115.17553,
                                34.790463
                            ],
                            [
                                115.163891,
                                34.783063
                            ],
                            [
                                115.154455,
                                34.78178
                            ],
                            [
                                115.140048,
                                34.793324
                            ],
                            [
                                115.119601,
                                34.788638
                            ],
                            [
                                115.104125,
                                34.772357
                            ],
                            [
                                115.038885,
                                34.773985
                            ],
                            [
                                115.030329,
                                34.772455
                            ],
                            [
                                115.001012,
                                34.760662
                            ],
                            [
                                114.988366,
                                34.76456
                            ],
                            [
                                114.980502,
                                34.760909
                            ],
                            [
                                114.966913,
                                34.761106
                            ],
                            [
                                114.936841,
                                34.747041
                            ],
                            [
                                114.922874,
                                34.748423
                            ],
                            [
                                114.894375,
                                34.762833
                            ],
                            [
                                114.877578,
                                34.775219
                            ],
                            [
                                114.867386,
                                34.775515
                            ],
                            [
                                114.86682,
                                34.769199
                            ],
                            [
                                114.835615,
                                34.767472
                            ],
                            [
                                114.829009,
                                34.764314
                            ],
                            [
                                114.82838,
                                34.755332
                            ],
                            [
                                114.835678,
                                34.746893
                            ],
                            [
                                114.859333,
                                34.740328
                            ],
                            [
                                114.858767,
                                34.734256
                            ],
                            [
                                114.840648,
                                34.715101
                            ],
                            [
                                114.855558,
                                34.710904
                            ],
                            [
                                114.858012,
                                34.692286
                            ],
                            [
                                114.8677,
                                34.688038
                            ],
                            [
                                114.891418,
                                34.698213
                            ],
                            [
                                114.90765,
                                34.697916
                            ],
                            [
                                114.931682,
                                34.686804
                            ],
                            [
                                114.936652,
                                34.681914
                            ],
                            [
                                114.935771,
                                34.672182
                            ],
                            [
                                114.926649,
                                34.668625
                            ],
                            [
                                114.905825,
                                34.666896
                            ],
                            [
                                114.896451,
                                34.661363
                            ],
                            [
                                114.893494,
                                34.652469
                            ],
                            [
                                114.901673,
                                34.645303
                            ],
                            [
                                114.898339,
                                34.631762
                            ],
                            [
                                114.90117,
                                34.613769
                            ],
                            [
                                114.897018,
                                34.602596
                            ],
                            [
                                114.904882,
                                34.586179
                            ],
                            [
                                114.907398,
                                34.573865
                            ],
                            [
                                114.906517,
                                34.547647
                            ],
                            [
                                114.91501,
                                34.548686
                            ],
                            [
                                114.917841,
                                34.541957
                            ],
                            [
                                114.91111,
                                34.534782
                            ],
                            [
                                114.920673,
                                34.531417
                            ],
                            [
                                114.913752,
                                34.518154
                            ],
                            [
                                114.917653,
                                34.511571
                            ],
                            [
                                114.9096,
                                34.495137
                            ],
                            [
                                114.922371,
                                34.498206
                            ],
                            [
                                114.918596,
                                34.484938
                            ],
                            [
                                114.912305,
                                34.483601
                            ],
                            [
                                114.904001,
                                34.467606
                            ],
                            [
                                114.896451,
                                34.46102
                            ],
                            [
                                114.886322,
                                34.461317
                            ],
                            [
                                114.880786,
                                34.450519
                            ],
                            [
                                114.872356,
                                34.454085
                            ],
                            [
                                114.865624,
                                34.462902
                            ],
                            [
                                114.858893,
                                34.451906
                            ],
                            [
                                114.856502,
                                34.436599
                            ],
                            [
                                114.864806,
                                34.433726
                            ],
                            [
                                114.852413,
                                34.42887
                            ],
                            [
                                114.854615,
                                34.410933
                            ],
                            [
                                114.848575,
                                34.409942
                            ],
                            [
                                114.851658,
                                34.399534
                            ],
                            [
                                114.874432,
                                34.396411
                            ],
                            [
                                114.875061,
                                34.390612
                            ],
                            [
                                114.888461,
                                34.383771
                            ],
                            [
                                114.879025,
                                34.370683
                            ],
                            [
                                114.861724,
                                34.367014
                            ],
                            [
                                114.855558,
                                34.33473
                            ],
                            [
                                114.862353,
                                34.329174
                            ],
                            [
                                114.870783,
                                34.305608
                            ],
                            [
                                114.882674,
                                34.301192
                            ],
                            [
                                114.901988,
                                34.284567
                            ],
                            [
                                114.912179,
                                34.281837
                            ],
                            [
                                114.933695,
                                34.282135
                            ],
                            [
                                114.940804,
                                34.274243
                            ],
                            [
                                114.962258,
                                34.261883
                            ],
                            [
                                114.98088,
                                34.262975
                            ],
                            [
                                114.986605,
                                34.253393
                            ],
                            [
                                114.998558,
                                34.250116
                            ],
                            [
                                115.012965,
                                34.253393
                            ],
                            [
                                115.041087,
                                34.246342
                            ],
                            [
                                115.052474,
                                34.224641
                            ],
                            [
                                115.082609,
                                34.222555
                            ],
                            [
                                115.093556,
                                34.219277
                            ],
                            [
                                115.107207,
                                34.208845
                            ],
                            [
                                115.12627,
                                34.209441
                            ],
                            [
                                115.11872,
                                34.189966
                            ],
                            [
                                115.133127,
                                34.170835
                            ],
                            [
                                115.133442,
                                34.154234
                            ],
                            [
                                115.127906,
                                34.146777
                            ],
                            [
                                115.12671,
                                34.133652
                            ],
                            [
                                115.119538,
                                34.120475
                            ],
                            [
                                115.126144,
                                34.105207
                            ],
                            [
                                115.118217,
                                34.098642
                            ],
                            [
                                115.120608,
                                34.078196
                            ],
                            [
                                115.116707,
                                34.066353
                            ],
                            [
                                115.128661,
                                34.064164
                            ],
                            [
                                115.140048,
                                34.055854
                            ],
                            [
                                115.13967,
                                34.050628
                            ],
                            [
                                115.121363,
                                34.02569
                            ],
                            [
                                115.107962,
                                34.022703
                            ],
                            [
                                115.083364,
                                34.024893
                            ],
                            [
                                115.074241,
                                34.022802
                            ],
                            [
                                115.074871,
                                34.014438
                            ],
                            [
                                115.083238,
                                34.003185
                            ],
                            [
                                115.070089,
                                33.990635
                            ],
                            [
                                115.062351,
                                33.979329
                            ],
                            [
                                115.065748,
                                33.97355
                            ],
                            [
                                115.05801,
                                33.95721
                            ],
                            [
                                115.049957,
                                33.950035
                            ],
                            [
                                115.050398,
                                33.941962
                            ],
                            [
                                115.070026,
                                33.935583
                            ],
                            [
                                115.085251,
                                33.93354
                            ],
                            [
                                115.107207,
                                33.936331
                            ],
                            [
                                115.106453,
                                33.94844
                            ],
                            [
                                115.115009,
                                33.961096
                            ],
                            [
                                115.124257,
                                33.963089
                            ],
                            [
                                115.142375,
                                33.958306
                            ],
                            [
                                115.148541,
                                33.950184
                            ],
                            [
                                115.176474,
                                33.950732
                            ],
                            [
                                115.189497,
                                33.958106
                            ],
                            [
                                115.204722,
                                33.974447
                            ],
                            [
                                115.195473,
                                33.987398
                            ],
                            [
                                115.203778,
                                33.988942
                            ],
                            [
                                115.23039,
                                33.974148
                            ],
                            [
                                115.240959,
                                33.975144
                            ],
                            [
                                115.252283,
                                33.982467
                            ],
                            [
                                115.254548,
                                33.995117
                            ],
                            [
                                115.252975,
                                34.008861
                            ],
                            [
                                115.258449,
                                34.015334
                            ],
                            [
                                115.288395,
                                34.019516
                            ],
                            [
                                115.295441,
                                34.018172
                            ],
                            [
                                115.28959,
                                34.003981
                            ],
                            [
                                115.292484,
                                33.996163
                            ],
                            [
                                115.312742,
                                33.995715
                            ],
                            [
                                115.32092,
                                34.004828
                            ],
                            [
                                115.33539,
                                34.006969
                            ],
                            [
                                115.349042,
                                34.018222
                            ],
                            [
                                115.361813,
                                34.01628
                            ],
                            [
                                115.375403,
                                34.00677
                            ],
                            [
                                115.402581,
                                33.993374
                            ],
                            [
                                115.439573,
                                33.986053
                            ],
                            [
                                115.458824,
                                33.987099
                            ],
                            [
                                115.462599,
                                34.006023
                            ],
                            [
                                115.489274,
                                34.017575
                            ],
                            [
                                115.502989,
                                34.015434
                            ],
                            [
                                115.513369,
                                34.019367
                            ],
                            [
                                115.53023,
                                34.018819
                            ],
                            [
                                115.53564,
                                34.021757
                            ],
                            [
                                115.547782,
                                34.037737
                            ],
                            [
                                115.549921,
                                34.047542
                            ],
                            [
                                115.547593,
                                34.074414
                            ],
                            [
                                115.543693,
                                34.084564
                            ],
                            [
                                115.573702,
                                34.086404
                            ],
                            [
                                115.619754,
                                34.083171
                            ],
                            [
                                115.627555,
                                34.087499
                            ],
                            [
                                115.641962,
                                34.084166
                            ],
                            [
                                115.653601,
                                34.060084
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 411500,
                "name": "信阳市",
                "center": [
                    114.075031,
                    32.123274
                ],
                "centroid": [
                    114.889128,
                    32.080437
                ],
                "childrenNum": 10,
                "level": "city",
                "parent": {
                    "adcode": 410000
                },
                "subFeatureIndex": 14,
                "acroutes": [
                    100000,
                    410000
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                113.749057,
                                32.272684
                            ],
                            [
                                113.749812,
                                32.260291
                            ],
                            [
                                113.739369,
                                32.257598
                            ],
                            [
                                113.740438,
                                32.242815
                            ],
                            [
                                113.748365,
                                32.234788
                            ],
                            [
                                113.752643,
                                32.216189
                            ],
                            [
                                113.764659,
                                32.204195
                            ],
                            [
                                113.777934,
                                32.207956
                            ],
                            [
                                113.783344,
                                32.189657
                            ],
                            [
                                113.763716,
                                32.161694
                            ],
                            [
                                113.766169,
                                32.13835
                            ],
                            [
                                113.750315,
                                32.116324
                            ],
                            [
                                113.739872,
                                32.113067
                            ],
                            [
                                113.736978,
                                32.121564
                            ],
                            [
                                113.722445,
                                32.12426
                            ],
                            [
                                113.728359,
                                32.09938
                            ],
                            [
                                113.728485,
                                32.083197
                            ],
                            [
                                113.744905,
                                32.076784
                            ],
                            [
                                113.747421,
                                32.06976
                            ],
                            [
                                113.763779,
                                32.054743
                            ],
                            [
                                113.781331,
                                32.048786
                            ],
                            [
                                113.791271,
                                32.036006
                            ],
                            [
                                113.779255,
                                32.018895
                            ],
                            [
                                113.769881,
                                32.01701
                            ],
                            [
                                113.758934,
                                32.000915
                            ],
                            [
                                113.759438,
                                31.986447
                            ],
                            [
                                113.768623,
                                31.979466
                            ],
                            [
                                113.776109,
                                31.980434
                            ],
                            [
                                113.788189,
                                31.974014
                            ],
                            [
                                113.798506,
                                31.974116
                            ],
                            [
                                113.816247,
                                31.96688
                            ],
                            [
                                113.807314,
                                31.94889
                            ],
                            [
                                113.805112,
                                31.931508
                            ],
                            [
                                113.81631,
                                31.923249
                            ],
                            [
                                113.832479,
                                31.91866
                            ],
                            [
                                113.835876,
                                31.910961
                            ],
                            [
                                113.83531,
                                31.892858
                            ],
                            [
                                113.831221,
                                31.878985
                            ],
                            [
                                113.838204,
                                31.868681
                            ],
                            [
                                113.838644,
                                31.854702
                            ],
                            [
                                113.858902,
                                31.841078
                            ],
                            [
                                113.867206,
                                31.845058
                            ],
                            [
                                113.872931,
                                31.84067
                            ],
                            [
                                113.896398,
                                31.849344
                            ],
                            [
                                113.906589,
                                31.868528
                            ],
                            [
                                113.914957,
                                31.876995
                            ],
                            [
                                113.93144,
                                31.880974
                            ],
                            [
                                113.933516,
                                31.869395
                            ],
                            [
                                113.954906,
                                31.856334
                            ],
                            [
                                113.956416,
                                31.840262
                            ],
                            [
                                113.946979,
                                31.826483
                            ],
                            [
                                113.953019,
                                31.813518
                            ],
                            [
                                113.952578,
                                31.793864
                            ],
                            [
                                113.96535,
                                31.785644
                            ],
                            [
                                113.972333,
                                31.771653
                            ],
                            [
                                113.972459,
                                31.763124
                            ],
                            [
                                113.978939,
                                31.753778
                            ],
                            [
                                113.988753,
                                31.750202
                            ],
                            [
                                114.015805,
                                31.770274
                            ],
                            [
                                114.038328,
                                31.768844
                            ],
                            [
                                114.048079,
                                31.773389
                            ],
                            [
                                114.059089,
                                31.772266
                            ],
                            [
                                114.063744,
                                31.781917
                            ],
                            [
                                114.0723,
                                31.784878
                            ],
                            [
                                114.086644,
                                31.782223
                            ],
                            [
                                114.089853,
                                31.794834
                            ],
                            [
                                114.099164,
                                31.803411
                            ],
                            [
                                114.119233,
                                31.805759
                            ],
                            [
                                114.127915,
                                31.82633
                            ],
                            [
                                114.12716,
                                31.835363
                            ],
                            [
                                114.13408,
                                31.842813
                            ],
                            [
                                114.15006,
                                31.839241
                            ],
                            [
                                114.162768,
                                31.841078
                            ],
                            [
                                114.166983,
                                31.851028
                            ],
                            [
                                114.180258,
                                31.854039
                            ],
                            [
                                114.194979,
                                31.850161
                            ],
                            [
                                114.208883,
                                31.842762
                            ],
                            [
                                114.221277,
                                31.832403
                            ],
                            [
                                114.236439,
                                31.841895
                            ],
                            [
                                114.235432,
                                31.833372
                            ],
                            [
                                114.248518,
                                31.810507
                            ],
                            [
                                114.262044,
                                31.796315
                            ],
                            [
                                114.264372,
                                31.788503
                            ],
                            [
                                114.287523,
                                31.762052
                            ],
                            [
                                114.292808,
                                31.752296
                            ],
                            [
                                114.313946,
                                31.75199
                            ],
                            [
                                114.321496,
                                31.755106
                            ],
                            [
                                114.350373,
                                31.755412
                            ],
                            [
                                114.373839,
                                31.744277
                            ],
                            [
                                114.390007,
                                31.741007
                            ],
                            [
                                114.399822,
                                31.746933
                            ],
                            [
                                114.416305,
                                31.74208
                            ],
                            [
                                114.419136,
                                31.73314
                            ],
                            [
                                114.4309,
                                31.734928
                            ],
                            [
                                114.446566,
                                31.728031
                            ],
                            [
                                114.450844,
                                31.737636
                            ],
                            [
                                114.46135,
                                31.733242
                            ],
                            [
                                114.471982,
                                31.740956
                            ],
                            [
                                114.488843,
                                31.735694
                            ],
                            [
                                114.50866,
                                31.740701
                            ],
                            [
                                114.504319,
                                31.756433
                            ],
                            [
                                114.509667,
                                31.766852
                            ],
                            [
                                114.521305,
                                31.766903
                            ],
                            [
                                114.530679,
                                31.742897
                            ],
                            [
                                114.545275,
                                31.746167
                            ],
                            [
                                114.550308,
                                31.753165
                            ],
                            [
                                114.54949,
                                31.765422
                            ],
                            [
                                114.554963,
                                31.768538
                            ],
                            [
                                114.572768,
                                31.762562
                            ],
                            [
                                114.582519,
                                31.764758
                            ],
                            [
                                114.587615,
                                31.754033
                            ],
                            [
                                114.581575,
                                31.74254
                            ],
                            [
                                114.584092,
                                31.731863
                            ],
                            [
                                114.579751,
                                31.724659
                            ],
                            [
                                114.579122,
                                31.708154
                            ],
                            [
                                114.59139,
                                31.700335
                            ],
                            [
                                114.586168,
                                31.692567
                            ],
                            [
                                114.574215,
                                31.689142
                            ],
                            [
                                114.570817,
                                31.660106
                            ],
                            [
                                114.559179,
                                31.656067
                            ],
                            [
                                114.549679,
                                31.642465
                            ],
                            [
                                114.55295,
                                31.635203
                            ],
                            [
                                114.548295,
                                31.625127
                            ],
                            [
                                114.548924,
                                31.609782
                            ],
                            [
                                114.561066,
                                31.560966
                            ],
                            [
                                114.572453,
                                31.554056
                            ],
                            [
                                114.57497,
                                31.559533
                            ],
                            [
                                114.587363,
                                31.560607
                            ],
                            [
                                114.595605,
                                31.576319
                            ],
                            [
                                114.612025,
                                31.578469
                            ],
                            [
                                114.616743,
                                31.585326
                            ],
                            [
                                114.641719,
                                31.582153
                            ],
                            [
                                114.644425,
                                31.574682
                            ],
                            [
                                114.653044,
                                31.572686
                            ],
                            [
                                114.656944,
                                31.562859
                            ],
                            [
                                114.670093,
                                31.547043
                            ],
                            [
                                114.678523,
                                31.544023
                            ],
                            [
                                114.69985,
                                31.546121
                            ],
                            [
                                114.696579,
                                31.525847
                            ],
                            [
                                114.717214,
                                31.527947
                            ],
                            [
                                114.723317,
                                31.520625
                            ],
                            [
                                114.739485,
                                31.527179
                            ],
                            [
                                114.747223,
                                31.524004
                            ],
                            [
                                114.757038,
                                31.52723
                            ],
                            [
                                114.771004,
                                31.520522
                            ],
                            [
                                114.778868,
                                31.520727
                            ],
                            [
                                114.774024,
                                31.512431
                            ],
                            [
                                114.774653,
                                31.500909
                            ],
                            [
                                114.783083,
                                31.494814
                            ],
                            [
                                114.78302,
                                31.48462
                            ],
                            [
                                114.789438,
                                31.480522
                            ],
                            [
                                114.81303,
                                31.478832
                            ],
                            [
                                114.824165,
                                31.469969
                            ],
                            [
                                114.829827,
                                31.458902
                            ],
                            [
                                114.841529,
                                31.461976
                            ],
                            [
                                114.850651,
                                31.476168
                            ],
                            [
                                114.875313,
                                31.478268
                            ],
                            [
                                114.87676,
                                31.470584
                            ],
                            [
                                114.8867,
                                31.469457
                            ],
                            [
                                114.896388,
                                31.474375
                            ],
                            [
                                114.925265,
                                31.480471
                            ],
                            [
                                114.936464,
                                31.469764
                            ],
                            [
                                114.939924,
                                31.477141
                            ],
                            [
                                114.964019,
                                31.495377
                            ],
                            [
                                114.976098,
                                31.495889
                            ],
                            [
                                114.985346,
                                31.477705
                            ],
                            [
                                114.998306,
                                31.471608
                            ],
                            [
                                115.002018,
                                31.485286
                            ],
                            [
                                115.010826,
                                31.488206
                            ],
                            [
                                115.001704,
                                31.499987
                            ],
                            [
                                115.010008,
                                31.504903
                            ],
                            [
                                115.023094,
                                31.527588
                            ],
                            [
                                115.030329,
                                31.527691
                            ],
                            [
                                115.038444,
                                31.51704
                            ],
                            [
                                115.048951,
                                31.517552
                            ],
                            [
                                115.066314,
                                31.510537
                            ],
                            [
                                115.096198,
                                31.508437
                            ],
                            [
                                115.092801,
                                31.519088
                            ],
                            [
                                115.102112,
                                31.520573
                            ],
                            [
                                115.113373,
                                31.528971
                            ],
                            [
                                115.105949,
                                31.540029
                            ],
                            [
                                115.110479,
                                31.55078
                            ],
                            [
                                115.103055,
                                31.555745
                            ],
                            [
                                115.106767,
                                31.567466
                            ],
                            [
                                115.127276,
                                31.579083
                            ],
                            [
                                115.125389,
                                31.599089
                            ],
                            [
                                115.134826,
                                31.602415
                            ],
                            [
                                115.164395,
                                31.604564
                            ],
                            [
                                115.176851,
                                31.598834
                            ],
                            [
                                115.180374,
                                31.577752
                            ],
                            [
                                115.192831,
                                31.569564
                            ],
                            [
                                115.192957,
                                31.564037
                            ],
                            [
                                115.207238,
                                31.564241
                            ],
                            [
                                115.212586,
                                31.55554
                            ],
                            [
                                115.235611,
                                31.556206
                            ],
                            [
                                115.230578,
                                31.538238
                            ],
                            [
                                115.218248,
                                31.515299
                            ],
                            [
                                115.219506,
                                31.506901
                            ],
                            [
                                115.212334,
                                31.490101
                            ],
                            [
                                115.216926,
                                31.481598
                            ],
                            [
                                115.217052,
                                31.462898
                            ],
                            [
                                115.210509,
                                31.445476
                            ],
                            [
                                115.220512,
                                31.426718
                            ],
                            [
                                115.232969,
                                31.427077
                            ],
                            [
                                115.252598,
                                31.421695
                            ],
                            [
                                115.260273,
                                31.41216
                            ],
                            [
                                115.250459,
                                31.391755
                            ],
                            [
                                115.260399,
                                31.387396
                            ],
                            [
                                115.281349,
                                31.399856
                            ],
                            [
                                115.294057,
                                31.395036
                            ],
                            [
                                115.301103,
                                31.384063
                            ],
                            [
                                115.31356,
                                31.383448
                            ],
                            [
                                115.327212,
                                31.391139
                            ],
                            [
                                115.335957,
                                31.403394
                            ],
                            [
                                115.355271,
                                31.399958
                            ],
                            [
                                115.373641,
                                31.405752
                            ],
                            [
                                115.383392,
                                31.418671
                            ],
                            [
                                115.385657,
                                31.443324
                            ],
                            [
                                115.389809,
                                31.450293
                            ],
                            [
                                115.377667,
                                31.470532
                            ],
                            [
                                115.371565,
                                31.495838
                            ],
                            [
                                115.377164,
                                31.502957
                            ],
                            [
                                115.389621,
                                31.507566
                            ],
                            [
                                115.398366,
                                31.516067
                            ],
                            [
                                115.415918,
                                31.52595
                            ],
                            [
                                115.428563,
                                31.547196
                            ],
                            [
                                115.431583,
                                31.559021
                            ],
                            [
                                115.428249,
                                31.563371
                            ],
                            [
                                115.438881,
                                31.579953
                            ],
                            [
                                115.440013,
                                31.588703
                            ],
                            [
                                115.47537,
                                31.606712
                            ],
                            [
                                115.486569,
                                31.610089
                            ],
                            [
                                115.490658,
                                31.623593
                            ],
                            [
                                115.477132,
                                31.645431
                            ],
                            [
                                115.484241,
                                31.649061
                            ],
                            [
                                115.486128,
                                31.66118
                            ],
                            [
                                115.495376,
                                31.672938
                            ],
                            [
                                115.515068,
                                31.682855
                            ],
                            [
                                115.531865,
                                31.698547
                            ],
                            [
                                115.553507,
                                31.695276
                            ],
                            [
                                115.564894,
                                31.709023
                            ],
                            [
                                115.582636,
                                31.713929
                            ],
                            [
                                115.586977,
                                31.721696
                            ],
                            [
                                115.601446,
                                31.731659
                            ],
                            [
                                115.619125,
                                31.738351
                            ],
                            [
                                115.637243,
                                31.755616
                            ],
                            [
                                115.65964,
                                31.760213
                            ],
                            [
                                115.676564,
                                31.778393
                            ],
                            [
                                115.689775,
                                31.776555
                            ],
                            [
                                115.697136,
                                31.76864
                            ],
                            [
                                115.710851,
                                31.770887
                            ],
                            [
                                115.719407,
                                31.76578
                            ],
                            [
                                115.736456,
                                31.763277
                            ],
                            [
                                115.734254,
                                31.776044
                            ],
                            [
                                115.741992,
                                31.782121
                            ],
                            [
                                115.762691,
                                31.782325
                            ],
                            [
                                115.767912,
                                31.78784
                            ],
                            [
                                115.787226,
                                31.780436
                            ],
                            [
                                115.793769,
                                31.773593
                            ],
                            [
                                115.808428,
                                31.772572
                            ],
                            [
                                115.815348,
                                31.762358
                            ],
                            [
                                115.831013,
                                31.777576
                            ],
                            [
                                115.837493,
                                31.773593
                            ],
                            [
                                115.850264,
                                31.786767
                            ],
                            [
                                115.858317,
                                31.773695
                            ],
                            [
                                115.885244,
                                31.776096
                            ],
                            [
                                115.900783,
                                31.792026
                            ],
                            [
                                115.91022,
                                31.792333
                            ],
                            [
                                115.915001,
                                31.811885
                            ],
                            [
                                115.913114,
                                31.820103
                            ],
                            [
                                115.904054,
                                31.829392
                            ],
                            [
                                115.892982,
                                31.83327
                            ],
                            [
                                115.895687,
                                31.867507
                            ],
                            [
                                115.898329,
                                31.88026
                            ],
                            [
                                115.910597,
                                31.894949
                            ],
                            [
                                115.92016,
                                31.920445
                            ],
                            [
                                115.916134,
                                31.935994
                            ],
                            [
                                115.909025,
                                31.943232
                            ],
                            [
                                115.911352,
                                31.958013
                            ],
                            [
                                115.92318,
                                31.985479
                            ],
                            [
                                115.924564,
                                31.995617
                            ],
                            [
                                115.931107,
                                31.994496
                            ],
                            [
                                115.927835,
                                32.02358
                            ],
                            [
                                115.919531,
                                32.027858
                            ],
                            [
                                115.927709,
                                32.036311
                            ],
                            [
                                115.922236,
                                32.049652
                            ],
                            [
                                115.925382,
                                32.057543
                            ],
                            [
                                115.9396,
                                32.065841
                            ],
                            [
                                115.942557,
                                32.07765
                            ],
                            [
                                115.932491,
                                32.084266
                            ],
                            [
                                115.926577,
                                32.105283
                            ],
                            [
                                115.93916,
                                32.138961
                            ],
                            [
                                115.937901,
                                32.151777
                            ],
                            [
                                115.94155,
                                32.166423
                            ],
                            [
                                115.933686,
                                32.180456
                            ],
                            [
                                115.923369,
                                32.191691
                            ],
                            [
                                115.922865,
                                32.203636
                            ],
                            [
                                115.912736,
                                32.227623
                            ],
                            [
                                115.914687,
                                32.254855
                            ],
                            [
                                115.921481,
                                32.268519
                            ],
                            [
                                115.911038,
                                32.284161
                            ],
                            [
                                115.90827,
                                32.299243
                            ],
                            [
                                115.90028,
                                32.301426
                            ],
                            [
                                115.906948,
                                32.31158
                            ],
                            [
                                115.904558,
                                32.34102
                            ],
                            [
                                115.89921,
                                32.344978
                            ],
                            [
                                115.897889,
                                32.373596
                            ],
                            [
                                115.899084,
                                32.390792
                            ],
                            [
                                115.88927,
                                32.413462
                            ],
                            [
                                115.889396,
                                32.424263
                            ],
                            [
                                115.87933,
                                32.432324
                            ],
                            [
                                115.883356,
                                32.438814
                            ],
                            [
                                115.882727,
                                32.456099
                            ],
                            [
                                115.864231,
                                32.458937
                            ],
                            [
                                115.873479,
                                32.470594
                            ],
                            [
                                115.88128,
                                32.472469
                            ],
                            [
                                115.883545,
                                32.489241
                            ],
                            [
                                115.874486,
                                32.497804
                            ],
                            [
                                115.873165,
                                32.504694
                            ],
                            [
                                115.853033,
                                32.50444
                            ],
                            [
                                115.845735,
                                32.501806
                            ],
                            [
                                115.84737,
                                32.509557
                            ],
                            [
                                115.856996,
                                32.517965
                            ],
                            [
                                115.873039,
                                32.525816
                            ],
                            [
                                115.87587,
                                32.542477
                            ],
                            [
                                115.899399,
                                32.556198
                            ],
                            [
                                115.91022,
                                32.566982
                            ],
                            [
                                115.929282,
                                32.567235
                            ],
                            [
                                115.911856,
                                32.577561
                            ],
                            [
                                115.891535,
                                32.576245
                            ],
                            [
                                115.887571,
                                32.56764
                            ],
                            [
                                115.8614,
                                32.537413
                            ],
                            [
                                115.845986,
                                32.53164
                            ],
                            [
                                115.839947,
                                32.524803
                            ],
                            [
                                115.841457,
                                32.501198
                            ],
                            [
                                115.823841,
                                32.502262
                            ],
                            [
                                115.80415,
                                32.485441
                            ],
                            [
                                115.788736,
                                32.468922
                            ],
                            [
                                115.781313,
                                32.468466
                            ],
                            [
                                115.787415,
                                32.480121
                            ],
                            [
                                115.785654,
                                32.489393
                            ],
                            [
                                115.771498,
                                32.505301
                            ],
                            [
                                115.760237,
                                32.481996
                            ],
                            [
                                115.741992,
                                32.476371
                            ],
                            [
                                115.719344,
                                32.485644
                            ],
                            [
                                115.701225,
                                32.495321
                            ],
                            [
                                115.692103,
                                32.487519
                            ],
                            [
                                115.692229,
                                32.480628
                            ],
                            [
                                115.700785,
                                32.472874
                            ],
                            [
                                115.698772,
                                32.468212
                            ],
                            [
                                115.675872,
                                32.466438
                            ],
                            [
                                115.68166,
                                32.450473
                            ],
                            [
                                115.68059,
                                32.43998
                            ],
                            [
                                115.674425,
                                32.430854
                            ],
                            [
                                115.666938,
                                32.409405
                            ],
                            [
                                115.656306,
                                32.408746
                            ],
                            [
                                115.657816,
                                32.428826
                            ],
                            [
                                115.645611,
                                32.417519
                            ],
                            [
                                115.627115,
                                32.40545
                            ],
                            [
                                115.604529,
                                32.425936
                            ],
                            [
                                115.586096,
                                32.419243
                            ],
                            [
                                115.563888,
                                32.403015
                            ],
                            [
                                115.553633,
                                32.407478
                            ],
                            [
                                115.569109,
                                32.414629
                            ],
                            [
                                115.5676,
                                32.421626
                            ],
                            [
                                115.547279,
                                32.424719
                            ],
                            [
                                115.537465,
                                32.438966
                            ],
                            [
                                115.523183,
                                32.442007
                            ],
                            [
                                115.524127,
                                32.447837
                            ],
                            [
                                115.515571,
                                32.450625
                            ],
                            [
                                115.502863,
                                32.48306
                            ],
                            [
                                115.497515,
                                32.492535
                            ],
                            [
                                115.484996,
                                32.503934
                            ],
                            [
                                115.485059,
                                32.512292
                            ],
                            [
                                115.477635,
                                32.511836
                            ],
                            [
                                115.477761,
                                32.51989
                            ],
                            [
                                115.465745,
                                32.520143
                            ],
                            [
                                115.438944,
                                32.532551
                            ],
                            [
                                115.443725,
                                32.543287
                            ],
                            [
                                115.434666,
                                32.545211
                            ],
                            [
                                115.431646,
                                32.5523
                            ],
                            [
                                115.418057,
                                32.552958
                            ],
                            [
                                115.410004,
                                32.548097
                            ],
                            [
                                115.412772,
                                32.559793
                            ],
                            [
                                115.411577,
                                32.574777
                            ],
                            [
                                115.403273,
                                32.576701
                            ],
                            [
                                115.391948,
                                32.566324
                            ],
                            [
                                115.38767,
                                32.57088
                            ],
                            [
                                115.329602,
                                32.561211
                            ],
                            [
                                115.32048,
                                32.562628
                            ],
                            [
                                115.324003,
                                32.554831
                            ],
                            [
                                115.304186,
                                32.553768
                            ],
                            [
                                115.296511,
                                32.562729
                            ],
                            [
                                115.300348,
                                32.568399
                            ],
                            [
                                115.310855,
                                32.570576
                            ],
                            [
                                115.297769,
                                32.576347
                            ],
                            [
                                115.30557,
                                32.58318
                            ],
                            [
                                115.299404,
                                32.58814
                            ],
                            [
                                115.294812,
                                32.581054
                            ],
                            [
                                115.289213,
                                32.589861
                            ],
                            [
                                115.267193,
                                32.578068
                            ],
                            [
                                115.254737,
                                32.585002
                            ],
                            [
                                115.26128,
                                32.591683
                            ],
                            [
                                115.2548,
                                32.595225
                            ],
                            [
                                115.243538,
                                32.593505
                            ],
                            [
                                115.227118,
                                32.578624
                            ],
                            [
                                115.229509,
                                32.590569
                            ],
                            [
                                115.212145,
                                32.588494
                            ],
                            [
                                115.201136,
                                32.591834
                            ],
                            [
                                115.192013,
                                32.603018
                            ],
                            [
                                115.175341,
                                32.605346
                            ],
                            [
                                115.152127,
                                32.590012
                            ],
                            [
                                115.145647,
                                32.580143
                            ],
                            [
                                115.137028,
                                32.587026
                            ],
                            [
                                115.140362,
                                32.599223
                            ],
                            [
                                115.12476,
                                32.607573
                            ],
                            [
                                115.111548,
                                32.607421
                            ],
                            [
                                115.099532,
                                32.619868
                            ],
                            [
                                115.098022,
                                32.63378
                            ],
                            [
                                115.090599,
                                32.637017
                            ],
                            [
                                115.065182,
                                32.629075
                            ],
                            [
                                115.05002,
                                32.640153
                            ],
                            [
                                115.030077,
                                32.6486
                            ],
                            [
                                114.985472,
                                32.659322
                            ],
                            [
                                114.957791,
                                32.659979
                            ],
                            [
                                114.93357,
                                32.649308
                            ],
                            [
                                114.919351,
                                32.648903
                            ],
                            [
                                114.911047,
                                32.653405
                            ],
                            [
                                114.901296,
                                32.648954
                            ],
                            [
                                114.901799,
                                32.634741
                            ],
                            [
                                114.89167,
                                32.61749
                            ],
                            [
                                114.884875,
                                32.616225
                            ],
                            [
                                114.862856,
                                32.624117
                            ],
                            [
                                114.856565,
                                32.61926
                            ],
                            [
                                114.822404,
                                32.622853
                            ],
                            [
                                114.813785,
                                32.611165
                            ],
                            [
                                114.806172,
                                32.609495
                            ],
                            [
                                114.79403,
                                32.613695
                            ],
                            [
                                114.788997,
                                32.607168
                            ],
                            [
                                114.791325,
                                32.584141
                            ],
                            [
                                114.802649,
                                32.583433
                            ],
                            [
                                114.810136,
                                32.569007
                            ],
                            [
                                114.808877,
                                32.558882
                            ],
                            [
                                114.785789,
                                32.545616
                            ],
                            [
                                114.781133,
                                32.535539
                            ],
                            [
                                114.786858,
                                32.52384
                            ],
                            [
                                114.793527,
                                32.521764
                            ],
                            [
                                114.789689,
                                32.50824
                            ],
                            [
                                114.774024,
                                32.508696
                            ],
                            [
                                114.752319,
                                32.523942
                            ],
                            [
                                114.736088,
                                32.516901
                            ],
                            [
                                114.729545,
                                32.519333
                            ],
                            [
                                114.724512,
                                32.541464
                            ],
                            [
                                114.713062,
                                32.543743
                            ],
                            [
                                114.702115,
                                32.535134
                            ],
                            [
                                114.701927,
                                32.517357
                            ],
                            [
                                114.676699,
                                32.514977
                            ],
                            [
                                114.666067,
                                32.527183
                            ],
                            [
                                114.650338,
                                32.527842
                            ],
                            [
                                114.615737,
                                32.509911
                            ],
                            [
                                114.606866,
                                32.512697
                            ],
                            [
                                114.582393,
                                32.51371
                            ],
                            [
                                114.571258,
                                32.508088
                            ],
                            [
                                114.569559,
                                32.495119
                            ],
                            [
                                114.574781,
                                32.486353
                            ],
                            [
                                114.571509,
                                32.466793
                            ],
                            [
                                114.585665,
                                32.455136
                            ],
                            [
                                114.582142,
                                32.445657
                            ],
                            [
                                114.570125,
                                32.435721
                            ],
                            [
                                114.576542,
                                32.425733
                            ],
                            [
                                114.603595,
                                32.41833
                            ],
                            [
                                114.634673,
                                32.39982
                            ],
                            [
                                114.647759,
                                32.387597
                            ],
                            [
                                114.644551,
                                32.375879
                            ],
                            [
                                114.623727,
                                32.370602
                            ],
                            [
                                114.620141,
                                32.363398
                            ],
                            [
                                114.623349,
                                32.352539
                            ],
                            [
                                114.610767,
                                32.350002
                            ],
                            [
                                114.607998,
                                32.33701
                            ],
                            [
                                114.5929,
                                32.321326
                            ],
                            [
                                114.575976,
                                32.316402
                            ],
                            [
                                114.582519,
                                32.308432
                            ],
                            [
                                114.563645,
                                32.306401
                            ],
                            [
                                114.550685,
                                32.289036
                            ],
                            [
                                114.535083,
                                32.286091
                            ],
                            [
                                114.521934,
                                32.298684
                            ],
                            [
                                114.498342,
                                32.301527
                            ],
                            [
                                114.492177,
                                32.299953
                            ],
                            [
                                114.490856,
                                32.28665
                            ],
                            [
                                114.483621,
                                32.285177
                            ],
                            [
                                114.468333,
                                32.294165
                            ],
                            [
                                114.452479,
                                32.281368
                            ],
                            [
                                114.438324,
                                32.288478
                            ],
                            [
                                114.429328,
                                32.289341
                            ],
                            [
                                114.421589,
                                32.279134
                            ],
                            [
                                114.397054,
                                32.293353
                            ],
                            [
                                114.376607,
                                32.292032
                            ],
                            [
                                114.369813,
                                32.298735
                            ],
                            [
                                114.368177,
                                32.313407
                            ],
                            [
                                114.349303,
                                32.323002
                            ],
                            [
                                114.348422,
                                32.347566
                            ],
                            [
                                114.34276,
                                32.365021
                            ],
                            [
                                114.315142,
                                32.37324
                            ],
                            [
                                114.293877,
                                32.36492
                            ],
                            [
                                114.286894,
                                32.369892
                            ],
                            [
                                114.28098,
                                32.407428
                            ],
                            [
                                114.288467,
                                32.418939
                            ],
                            [
                                114.277961,
                                32.418888
                            ],
                            [
                                114.269027,
                                32.409253
                            ],
                            [
                                114.254117,
                                32.424516
                            ],
                            [
                                114.247511,
                                32.436583
                            ],
                            [
                                114.249084,
                                32.450625
                            ],
                            [
                                114.243485,
                                32.458583
                            ],
                            [
                                114.226876,
                                32.454122
                            ],
                            [
                                114.221214,
                                32.445961
                            ],
                            [
                                114.204479,
                                32.445252
                            ],
                            [
                                114.201522,
                                32.453514
                            ],
                            [
                                114.210078,
                                32.45838
                            ],
                            [
                                114.209135,
                                32.468719
                            ],
                            [
                                114.198314,
                                32.46877
                            ],
                            [
                                114.197433,
                                32.486353
                            ],
                            [
                                114.192274,
                                32.492585
                            ],
                            [
                                114.167675,
                                32.487012
                            ],
                            [
                                114.163397,
                                32.469986
                            ],
                            [
                                114.16497,
                                32.461877
                            ],
                            [
                                114.157421,
                                32.458279
                            ],
                            [
                                114.136723,
                                32.461978
                            ],
                            [
                                114.112564,
                                32.447786
                            ],
                            [
                                114.097654,
                                32.451639
                            ],
                            [
                                114.085512,
                                32.450777
                            ],
                            [
                                114.080731,
                                32.454832
                            ],
                            [
                                114.078529,
                                32.479614
                            ],
                            [
                                114.087336,
                                32.481236
                            ],
                            [
                                114.07639,
                                32.493548
                            ],
                            [
                                114.071357,
                                32.505909
                            ],
                            [
                                114.072992,
                                32.517205
                            ],
                            [
                                114.066638,
                                32.527031
                            ],
                            [
                                114.067204,
                                32.534881
                            ],
                            [
                                114.056258,
                                32.539033
                            ],
                            [
                                114.053867,
                                32.523233
                            ],
                            [
                                114.014861,
                                32.51599
                            ],
                            [
                                114.007375,
                                32.507784
                            ],
                            [
                                113.982147,
                                32.503579
                            ],
                            [
                                113.962204,
                                32.505403
                            ],
                            [
                                113.95434,
                                32.514268
                            ],
                            [
                                113.953837,
                                32.526575
                            ],
                            [
                                113.938046,
                                32.555996
                            ],
                            [
                                113.940373,
                                32.576195
                            ],
                            [
                                113.932824,
                                32.578219
                            ],
                            [
                                113.92238,
                                32.59396
                            ],
                            [
                                113.919738,
                                32.605295
                            ],
                            [
                                113.911811,
                                32.607775
                            ],
                            [
                                113.893315,
                                32.604891
                            ],
                            [
                                113.886646,
                                32.607016
                            ],
                            [
                                113.87268,
                                32.622751
                            ],
                            [
                                113.86513,
                                32.623814
                            ],
                            [
                                113.850409,
                                32.617338
                            ],
                            [
                                113.843614,
                                32.622245
                            ],
                            [
                                113.826691,
                                32.622397
                            ],
                            [
                                113.820337,
                                32.619109
                            ],
                            [
                                113.820211,
                                32.601804
                            ],
                            [
                                113.814423,
                                32.600842
                            ],
                            [
                                113.805301,
                                32.597705
                            ],
                            [
                                113.789698,
                                32.586368
                            ],
                            [
                                113.782023,
                                32.566172
                            ],
                            [
                                113.769126,
                                32.559287
                            ],
                            [
                                113.763212,
                                32.547895
                            ],
                            [
                                113.774285,
                                32.537362
                            ],
                            [
                                113.768245,
                                32.534425
                            ],
                            [
                                113.759375,
                                32.508797
                            ],
                            [
                                113.764219,
                                32.489951
                            ],
                            [
                                113.761828,
                                32.470645
                            ],
                            [
                                113.753398,
                                32.465425
                            ],
                            [
                                113.741319,
                                32.465374
                            ],
                            [
                                113.73767,
                                32.453362
                            ],
                            [
                                113.730498,
                                32.46061
                            ],
                            [
                                113.730875,
                                32.449307
                            ],
                            [
                                113.725339,
                                32.436025
                            ],
                            [
                                113.710555,
                                32.421221
                            ],
                            [
                                113.718608,
                                32.417215
                            ],
                            [
                                113.735279,
                                32.410876
                            ],
                            [
                                113.740753,
                                32.393125
                            ],
                            [
                                113.751699,
                                32.390031
                            ],
                            [
                                113.753209,
                                32.38435
                            ],
                            [
                                113.743835,
                                32.369435
                            ],
                            [
                                113.751448,
                                32.36081
                            ],
                            [
                                113.760381,
                                32.369182
                            ],
                            [
                                113.768874,
                                32.369486
                            ],
                            [
                                113.770699,
                                32.358628
                            ],
                            [
                                113.758494,
                                32.352235
                            ],
                            [
                                113.753838,
                                32.342085
                            ],
                            [
                                113.753838,
                                32.32823
                            ],
                            [
                                113.7651,
                                32.319448
                            ],
                            [
                                113.773907,
                                32.306147
                            ],
                            [
                                113.769063,
                                32.301324
                            ],
                            [
                                113.768182,
                                32.28406
                            ],
                            [
                                113.769944,
                                32.275985
                            ],
                            [
                                113.758305,
                                32.276747
                            ],
                            [
                                113.749057,
                                32.272684
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                113.768182,
                                32.28406
                            ],
                            [
                                113.769063,
                                32.301324
                            ],
                            [
                                113.748491,
                                32.291931
                            ],
                            [
                                113.743898,
                                32.283603
                            ],
                            [
                                113.749057,
                                32.272684
                            ],
                            [
                                113.758305,
                                32.276747
                            ],
                            [
                                113.754027,
                                32.288275
                            ],
                            [
                                113.758494,
                                32.291931
                            ],
                            [
                                113.768182,
                                32.28406
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 411600,
                "name": "周口市",
                "center": [
                    114.649653,
                    33.620357
                ],
                "centroid": [
                    114.883192,
                    33.721762
                ],
                "childrenNum": 10,
                "level": "city",
                "parent": {
                    "adcode": 410000
                },
                "subFeatureIndex": 15,
                "acroutes": [
                    100000,
                    410000
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                114.897269,
                                33.08658
                            ],
                            [
                                114.897206,
                                33.093676
                            ],
                            [
                                114.906266,
                                33.11657
                            ],
                            [
                                114.902931,
                                33.12955
                            ],
                            [
                                114.910229,
                                33.136592
                            ],
                            [
                                114.926649,
                                33.138503
                            ],
                            [
                                114.93445,
                                33.15329
                            ],
                            [
                                114.966095,
                                33.147104
                            ],
                            [
                                114.968863,
                                33.133674
                            ],
                            [
                                114.981446,
                                33.129097
                            ],
                            [
                                114.99233,
                                33.120947
                            ],
                            [
                                114.990505,
                                33.102885
                            ],
                            [
                                115.012021,
                                33.097651
                            ],
                            [
                                115.023345,
                                33.090757
                            ],
                            [
                                115.041275,
                                33.08663
                            ],
                            [
                                115.05153,
                                33.092468
                            ],
                            [
                                115.057444,
                                33.083762
                            ],
                            [
                                115.067636,
                                33.086228
                            ],
                            [
                                115.111108,
                                33.082956
                            ],
                            [
                                115.153259,
                                33.084416
                            ],
                            [
                                115.167918,
                                33.088744
                            ],
                            [
                                115.172448,
                                33.108067
                            ],
                            [
                                115.197109,
                                33.12145
                            ],
                            [
                                115.209817,
                                33.113501
                            ],
                            [
                                115.22435,
                                33.126229
                            ],
                            [
                                115.236996,
                                33.126733
                            ],
                            [
                                115.246307,
                                33.136391
                            ],
                            [
                                115.266501,
                                33.132719
                            ],
                            [
                                115.269584,
                                33.137849
                            ],
                            [
                                115.290345,
                                33.132417
                            ],
                            [
                                115.292862,
                                33.143382
                            ],
                            [
                                115.301481,
                                33.141622
                            ],
                            [
                                115.300159,
                                33.162995
                            ],
                            [
                                115.294372,
                                33.177878
                            ],
                            [
                                115.296762,
                                33.201303
                            ],
                            [
                                115.326394,
                                33.211355
                            ],
                            [
                                115.316265,
                                33.218391
                            ],
                            [
                                115.316328,
                                33.223818
                            ],
                            [
                                115.331741,
                                33.235625
                            ],
                            [
                                115.329728,
                                33.250546
                            ],
                            [
                                115.340109,
                                33.261145
                            ],
                            [
                                115.340927,
                                33.271391
                            ],
                            [
                                115.333818,
                                33.284749
                            ],
                            [
                                115.335013,
                                33.298055
                            ],
                            [
                                115.346966,
                                33.301017
                            ],
                            [
                                115.360178,
                                33.298105
                            ],
                            [
                                115.358794,
                                33.311459
                            ],
                            [
                                115.365022,
                                33.336003
                            ],
                            [
                                115.34835,
                                33.338963
                            ],
                            [
                                115.34684,
                                33.358683
                            ],
                            [
                                115.338536,
                                33.362998
                            ],
                            [
                                115.341619,
                                33.371175
                            ],
                            [
                                115.316139,
                                33.370974
                            ],
                            [
                                115.313245,
                                33.377094
                            ],
                            [
                                115.329414,
                                33.40167
                            ],
                            [
                                115.317334,
                                33.418216
                            ],
                            [
                                115.315636,
                                33.431452
                            ],
                            [
                                115.319033,
                                33.441477
                            ],
                            [
                                115.316391,
                                33.448895
                            ],
                            [
                                115.323877,
                                33.449045
                            ],
                            [
                                115.324569,
                                33.457615
                            ],
                            [
                                115.335957,
                                33.447291
                            ],
                            [
                                115.345771,
                                33.449747
                            ],
                            [
                                115.348854,
                                33.478962
                            ],
                            [
                                115.343821,
                                33.480866
                            ],
                            [
                                115.351244,
                                33.490384
                            ],
                            [
                                115.345393,
                                33.502707
                            ],
                            [
                                115.366595,
                                33.523441
                            ],
                            [
                                115.395094,
                                33.506463
                            ],
                            [
                                115.396793,
                                33.502006
                            ],
                            [
                                115.405349,
                                33.51668
                            ],
                            [
                                115.401763,
                                33.524342
                            ],
                            [
                                115.41466,
                                33.541617
                            ],
                            [
                                115.421958,
                                33.556786
                            ],
                            [
                                115.463731,
                                33.567197
                            ],
                            [
                                115.47191,
                                33.558037
                            ],
                            [
                                115.484933,
                                33.558638
                            ],
                            [
                                115.500598,
                                33.564794
                            ],
                            [
                                115.511293,
                                33.553331
                            ],
                            [
                                115.528594,
                                33.562692
                            ],
                            [
                                115.552752,
                                33.565545
                            ],
                            [
                                115.559358,
                                33.561941
                            ],
                            [
                                115.56609,
                                33.576356
                            ],
                            [
                                115.601132,
                                33.578157
                            ],
                            [
                                115.63976,
                                33.585113
                            ],
                            [
                                115.625038,
                                33.625637
                            ],
                            [
                                115.6173,
                                33.633189
                            ],
                            [
                                115.601635,
                                33.657692
                            ],
                            [
                                115.602516,
                                33.67259
                            ],
                            [
                                115.599622,
                                33.688285
                            ],
                            [
                                115.607171,
                                33.689035
                            ],
                            [
                                115.596288,
                                33.70033
                            ],
                            [
                                115.601572,
                                33.71692
                            ],
                            [
                                115.595281,
                                33.732957
                            ],
                            [
                                115.583516,
                                33.747243
                            ],
                            [
                                115.574834,
                                33.752237
                            ],
                            [
                                115.56999,
                                33.765321
                            ],
                            [
                                115.563133,
                                33.771663
                            ],
                            [
                                115.565209,
                                33.780201
                            ],
                            [
                                115.582258,
                                33.788738
                            ],
                            [
                                115.590563,
                                33.783696
                            ],
                            [
                                115.614218,
                                33.775658
                            ],
                            [
                                115.621201,
                                33.796775
                            ],
                            [
                                115.62334,
                                33.811949
                            ],
                            [
                                115.616608,
                                33.820034
                            ],
                            [
                                115.625605,
                                33.823627
                            ],
                            [
                                115.626297,
                                33.836201
                            ],
                            [
                                115.636111,
                                33.84119
                            ],
                            [
                                115.633532,
                                33.86733
                            ],
                            [
                                115.620886,
                                33.876108
                            ],
                            [
                                115.605724,
                                33.867429
                            ],
                            [
                                115.591632,
                                33.868327
                            ],
                            [
                                115.579553,
                                33.877005
                            ],
                            [
                                115.564202,
                                33.87132
                            ],
                            [
                                115.557974,
                                33.876108
                            ],
                            [
                                115.546146,
                                33.875509
                            ],
                            [
                                115.546587,
                                33.888425
                            ],
                            [
                                115.555332,
                                33.888574
                            ],
                            [
                                115.55464,
                                33.900342
                            ],
                            [
                                115.568543,
                                33.910013
                            ],
                            [
                                115.559798,
                                33.91455
                            ],
                            [
                                115.562629,
                                33.92721
                            ],
                            [
                                115.56999,
                                33.932842
                            ],
                            [
                                115.569172,
                                33.9455
                            ],
                            [
                                115.57754,
                                33.950134
                            ],
                            [
                                115.57905,
                                33.973949
                            ],
                            [
                                115.588361,
                                33.976987
                            ],
                            [
                                115.591066,
                                33.986202
                            ],
                            [
                                115.584083,
                                33.988643
                            ],
                            [
                                115.592702,
                                34.009857
                            ],
                            [
                                115.606605,
                                34.013243
                            ],
                            [
                                115.600943,
                                34.023798
                            ],
                            [
                                115.615035,
                                34.033356
                            ],
                            [
                                115.62139,
                                34.030121
                            ],
                            [
                                115.642214,
                                34.032261
                            ],
                            [
                                115.649889,
                                34.036194
                            ],
                            [
                                115.648001,
                                34.046298
                            ],
                            [
                                115.653601,
                                34.060084
                            ],
                            [
                                115.641962,
                                34.084166
                            ],
                            [
                                115.627555,
                                34.087499
                            ],
                            [
                                115.619754,
                                34.083171
                            ],
                            [
                                115.573702,
                                34.086404
                            ],
                            [
                                115.543693,
                                34.084564
                            ],
                            [
                                115.547593,
                                34.074414
                            ],
                            [
                                115.549921,
                                34.047542
                            ],
                            [
                                115.547782,
                                34.037737
                            ],
                            [
                                115.53564,
                                34.021757
                            ],
                            [
                                115.53023,
                                34.018819
                            ],
                            [
                                115.513369,
                                34.019367
                            ],
                            [
                                115.502989,
                                34.015434
                            ],
                            [
                                115.489274,
                                34.017575
                            ],
                            [
                                115.462599,
                                34.006023
                            ],
                            [
                                115.458824,
                                33.987099
                            ],
                            [
                                115.439573,
                                33.986053
                            ],
                            [
                                115.402581,
                                33.993374
                            ],
                            [
                                115.375403,
                                34.00677
                            ],
                            [
                                115.361813,
                                34.01628
                            ],
                            [
                                115.349042,
                                34.018222
                            ],
                            [
                                115.33539,
                                34.006969
                            ],
                            [
                                115.32092,
                                34.004828
                            ],
                            [
                                115.312742,
                                33.995715
                            ],
                            [
                                115.292484,
                                33.996163
                            ],
                            [
                                115.28959,
                                34.003981
                            ],
                            [
                                115.295441,
                                34.018172
                            ],
                            [
                                115.288395,
                                34.019516
                            ],
                            [
                                115.258449,
                                34.015334
                            ],
                            [
                                115.252975,
                                34.008861
                            ],
                            [
                                115.254548,
                                33.995117
                            ],
                            [
                                115.252283,
                                33.982467
                            ],
                            [
                                115.240959,
                                33.975144
                            ],
                            [
                                115.23039,
                                33.974148
                            ],
                            [
                                115.203778,
                                33.988942
                            ],
                            [
                                115.195473,
                                33.987398
                            ],
                            [
                                115.204722,
                                33.974447
                            ],
                            [
                                115.189497,
                                33.958106
                            ],
                            [
                                115.176474,
                                33.950732
                            ],
                            [
                                115.148541,
                                33.950184
                            ],
                            [
                                115.142375,
                                33.958306
                            ],
                            [
                                115.124257,
                                33.963089
                            ],
                            [
                                115.115009,
                                33.961096
                            ],
                            [
                                115.106453,
                                33.94844
                            ],
                            [
                                115.107207,
                                33.936331
                            ],
                            [
                                115.085251,
                                33.93354
                            ],
                            [
                                115.070026,
                                33.935583
                            ],
                            [
                                115.050398,
                                33.941962
                            ],
                            [
                                115.049957,
                                33.950035
                            ],
                            [
                                115.05801,
                                33.95721
                            ],
                            [
                                115.065748,
                                33.97355
                            ],
                            [
                                115.062351,
                                33.979329
                            ],
                            [
                                115.070089,
                                33.990635
                            ],
                            [
                                115.083238,
                                34.003185
                            ],
                            [
                                115.074871,
                                34.014438
                            ],
                            [
                                115.074241,
                                34.022802
                            ],
                            [
                                115.083364,
                                34.024893
                            ],
                            [
                                115.107962,
                                34.022703
                            ],
                            [
                                115.121363,
                                34.02569
                            ],
                            [
                                115.13967,
                                34.050628
                            ],
                            [
                                115.140048,
                                34.055854
                            ],
                            [
                                115.128661,
                                34.064164
                            ],
                            [
                                115.116707,
                                34.066353
                            ],
                            [
                                115.120608,
                                34.078196
                            ],
                            [
                                115.118217,
                                34.098642
                            ],
                            [
                                115.126144,
                                34.105207
                            ],
                            [
                                115.119538,
                                34.120475
                            ],
                            [
                                115.12671,
                                34.133652
                            ],
                            [
                                115.127906,
                                34.146777
                            ],
                            [
                                115.133442,
                                34.154234
                            ],
                            [
                                115.133127,
                                34.170835
                            ],
                            [
                                115.11872,
                                34.189966
                            ],
                            [
                                115.12627,
                                34.209441
                            ],
                            [
                                115.107207,
                                34.208845
                            ],
                            [
                                115.093556,
                                34.219277
                            ],
                            [
                                115.082609,
                                34.222555
                            ],
                            [
                                115.052474,
                                34.224641
                            ],
                            [
                                115.041087,
                                34.246342
                            ],
                            [
                                115.012965,
                                34.253393
                            ],
                            [
                                114.998558,
                                34.250116
                            ],
                            [
                                114.986605,
                                34.253393
                            ],
                            [
                                114.98088,
                                34.262975
                            ],
                            [
                                114.962258,
                                34.261883
                            ],
                            [
                                114.940804,
                                34.274243
                            ],
                            [
                                114.933695,
                                34.282135
                            ],
                            [
                                114.912179,
                                34.281837
                            ],
                            [
                                114.901988,
                                34.284567
                            ],
                            [
                                114.896514,
                                34.265804
                            ],
                            [
                                114.867763,
                                34.271066
                            ],
                            [
                                114.845492,
                                34.280696
                            ],
                            [
                                114.832847,
                                34.281937
                            ],
                            [
                                114.8314,
                                34.268138
                            ],
                            [
                                114.812778,
                                34.259003
                            ],
                            [
                                114.788242,
                                34.261138
                            ],
                            [
                                114.781196,
                                34.255627
                            ],
                            [
                                114.76465,
                                34.254436
                            ],
                            [
                                114.758736,
                                34.238397
                            ],
                            [
                                114.752697,
                                34.23363
                            ],
                            [
                                114.730426,
                                34.225237
                            ],
                            [
                                114.723946,
                                34.228018
                            ],
                            [
                                114.71388,
                                34.241327
                            ],
                            [
                                114.702241,
                                34.244505
                            ],
                            [
                                114.679341,
                                34.244307
                            ],
                            [
                                114.667514,
                                34.250265
                            ],
                            [
                                114.647319,
                                34.250315
                            ],
                            [
                                114.634044,
                                34.261883
                            ],
                            [
                                114.611459,
                                34.261088
                            ],
                            [
                                114.602085,
                                34.271017
                            ],
                            [
                                114.58988,
                                34.273747
                            ],
                            [
                                114.556662,
                                34.267989
                            ],
                            [
                                114.551189,
                                34.272059
                            ],
                            [
                                114.551629,
                                34.284964
                            ],
                            [
                                114.528603,
                                34.282234
                            ],
                            [
                                114.524703,
                                34.306253
                            ],
                            [
                                114.519355,
                                34.313448
                            ],
                            [
                                114.509855,
                                34.309727
                            ],
                            [
                                114.493876,
                                34.31191
                            ],
                            [
                                114.485949,
                                34.325057
                            ],
                            [
                                114.479343,
                                34.32962
                            ],
                            [
                                114.462042,
                                34.330166
                            ],
                            [
                                114.46179,
                                34.319947
                            ],
                            [
                                114.452857,
                                34.319997
                            ],
                            [
                                114.438576,
                                34.328033
                            ],
                            [
                                114.439897,
                                34.336366
                            ],
                            [
                                114.427692,
                                34.333837
                            ],
                            [
                                114.436059,
                                34.330265
                            ],
                            [
                                114.434486,
                                34.313894
                            ],
                            [
                                114.424546,
                                34.309032
                            ],
                            [
                                114.430649,
                                34.302284
                            ],
                            [
                                114.442539,
                                34.300696
                            ],
                            [
                                114.455688,
                                34.294096
                            ],
                            [
                                114.440652,
                                34.270719
                            ],
                            [
                                114.434927,
                                34.267145
                            ],
                            [
                                114.417689,
                                34.265308
                            ],
                            [
                                114.405798,
                                34.248031
                            ],
                            [
                                114.385729,
                                34.24386
                            ],
                            [
                                114.356412,
                                34.247186
                            ],
                            [
                                114.344207,
                                34.251804
                            ],
                            [
                                114.328857,
                                34.267294
                            ],
                            [
                                114.301175,
                                34.26774
                            ],
                            [
                                114.287901,
                                34.276527
                            ],
                            [
                                114.274626,
                                34.274889
                            ],
                            [
                                114.267517,
                                34.256968
                            ],
                            [
                                114.259905,
                                34.251854
                            ],
                            [
                                114.272676,
                                34.24237
                            ],
                            [
                                114.273053,
                                34.227869
                            ],
                            [
                                114.286013,
                                34.218234
                            ],
                            [
                                114.287649,
                                34.206958
                            ],
                            [
                                114.276199,
                                34.190811
                            ],
                            [
                                114.275255,
                                34.174661
                            ],
                            [
                                114.28746,
                                34.137033
                            ],
                            [
                                114.285133,
                                34.120873
                            ],
                            [
                                114.273808,
                                34.107545
                            ],
                            [
                                114.273431,
                                34.102571
                            ],
                            [
                                114.262107,
                                34.095856
                            ],
                            [
                                114.270411,
                                34.063219
                            ],
                            [
                                114.271103,
                                34.053813
                            ],
                            [
                                114.281987,
                                34.046597
                            ],
                            [
                                114.287523,
                                34.022902
                            ],
                            [
                                114.295324,
                                34.007467
                            ],
                            [
                                114.311745,
                                34.001492
                            ],
                            [
                                114.312248,
                                33.98162
                            ],
                            [
                                114.307026,
                                33.978233
                            ],
                            [
                                114.31036,
                                33.96
                            ],
                            [
                                114.299917,
                                33.953024
                            ],
                            [
                                114.305642,
                                33.889572
                            ],
                            [
                                114.3164,
                                33.880446
                            ],
                            [
                                114.311304,
                                33.87142
                            ],
                            [
                                114.315834,
                                33.865734
                            ],
                            [
                                114.312122,
                                33.853263
                            ],
                            [
                                114.301112,
                                33.852365
                            ],
                            [
                                114.301301,
                                33.842188
                            ],
                            [
                                114.310738,
                                33.842637
                            ],
                            [
                                114.316085,
                                33.833207
                            ],
                            [
                                114.323383,
                                33.832908
                            ],
                            [
                                114.325082,
                                33.818337
                            ],
                            [
                                114.313066,
                                33.80012
                            ],
                            [
                                114.309983,
                                33.781349
                            ],
                            [
                                114.290354,
                                33.771813
                            ],
                            [
                                114.249776,
                                33.779252
                            ],
                            [
                                114.242604,
                                33.790785
                            ],
                            [
                                114.217565,
                                33.793131
                            ],
                            [
                                114.211525,
                                33.798123
                            ],
                            [
                                114.19888,
                                33.797374
                            ],
                            [
                                114.190638,
                                33.801917
                            ],
                            [
                                114.179503,
                                33.799321
                            ],
                            [
                                114.178308,
                                33.806409
                            ],
                            [
                                114.161447,
                                33.79982
                            ],
                            [
                                114.15503,
                                33.809304
                            ],
                            [
                                114.145404,
                                33.810551
                            ],
                            [
                                114.134772,
                                33.806409
                            ],
                            [
                                114.133703,
                                33.791484
                            ],
                            [
                                114.139931,
                                33.783097
                            ],
                            [
                                114.142007,
                                33.765921
                            ],
                            [
                                114.133262,
                                33.768118
                            ],
                            [
                                114.098032,
                                33.765072
                            ],
                            [
                                114.10319,
                                33.756832
                            ],
                            [
                                114.106839,
                                33.739051
                            ],
                            [
                                114.095263,
                                33.728061
                            ],
                            [
                                114.091489,
                                33.71642
                            ],
                            [
                                114.097717,
                                33.683187
                            ],
                            [
                                114.115836,
                                33.684587
                            ],
                            [
                                114.118226,
                                33.67159
                            ],
                            [
                                114.116402,
                                33.651392
                            ],
                            [
                                114.125398,
                                33.652842
                            ],
                            [
                                114.149745,
                                33.650442
                            ],
                            [
                                114.152639,
                                33.662242
                            ],
                            [
                                114.162265,
                                33.669941
                            ],
                            [
                                114.169563,
                                33.664791
                            ],
                            [
                                114.186235,
                                33.67219
                            ],
                            [
                                114.186549,
                                33.682538
                            ],
                            [
                                114.196489,
                                33.690934
                            ],
                            [
                                114.214231,
                                33.691334
                            ],
                            [
                                114.249084,
                                33.704328
                            ],
                            [
                                114.250783,
                                33.693233
                            ],
                            [
                                114.259842,
                                33.680588
                            ],
                            [
                                114.260849,
                                33.661942
                            ],
                            [
                                114.264183,
                                33.654742
                            ],
                            [
                                114.264938,
                                33.635239
                            ],
                            [
                                114.277332,
                                33.621735
                            ],
                            [
                                114.279659,
                                33.604427
                            ],
                            [
                                114.265881,
                                33.597923
                            ],
                            [
                                114.265378,
                                33.593219
                            ],
                            [
                                114.278653,
                                33.57015
                            ],
                            [
                                114.282868,
                                33.558688
                            ],
                            [
                                114.295324,
                                33.553782
                            ],
                            [
                                114.289348,
                                33.522089
                            ],
                            [
                                114.281106,
                                33.513976
                            ],
                            [
                                114.283371,
                                33.500353
                            ],
                            [
                                114.279785,
                                33.489282
                            ],
                            [
                                114.284629,
                                33.472548
                            ],
                            [
                                114.307907,
                                33.481316
                            ],
                            [
                                114.347227,
                                33.462376
                            ],
                            [
                                114.349429,
                                33.452604
                            ],
                            [
                                114.362137,
                                33.454057
                            ],
                            [
                                114.368932,
                                33.44659
                            ],
                            [
                                114.382143,
                                33.454508
                            ],
                            [
                                114.402967,
                                33.457064
                            ],
                            [
                                114.407937,
                                33.460873
                            ],
                            [
                                114.446628,
                                33.464581
                            ],
                            [
                                114.459777,
                                33.454458
                            ],
                            [
                                114.464118,
                                33.437467
                            ],
                            [
                                114.480098,
                                33.443131
                            ],
                            [
                                114.490415,
                                33.43481
                            ],
                            [
                                114.488654,
                                33.417565
                            ],
                            [
                                114.52313,
                                33.418969
                            ],
                            [
                                114.537663,
                                33.426589
                            ],
                            [
                                114.554146,
                                33.42714
                            ],
                            [
                                114.563016,
                                33.42333
                            ],
                            [
                                114.57239,
                                33.406835
                            ],
                            [
                                114.572013,
                                33.396053
                            ],
                            [
                                114.577423,
                                33.390035
                            ],
                            [
                                114.575536,
                                33.376392
                            ],
                            [
                                114.585728,
                                33.374837
                            ],
                            [
                                114.589314,
                                33.362847
                            ],
                            [
                                114.605293,
                                33.35778
                            ],
                            [
                                114.615925,
                                33.344383
                            ],
                            [
                                114.623664,
                                33.341723
                            ],
                            [
                                114.645557,
                                33.34624
                            ],
                            [
                                114.654491,
                                33.341924
                            ],
                            [
                                114.662481,
                                33.322954
                            ],
                            [
                                114.669715,
                                33.31944
                            ],
                            [
                                114.665563,
                                33.313416
                            ],
                            [
                                114.684122,
                                33.314671
                            ],
                            [
                                114.685255,
                                33.298205
                            ],
                            [
                                114.705764,
                                33.302171
                            ],
                            [
                                114.722373,
                                33.301117
                            ],
                            [
                                114.728853,
                                33.289368
                            ],
                            [
                                114.73074,
                                33.261597
                            ],
                            [
                                114.717529,
                                33.221808
                            ],
                            [
                                114.69897,
                                33.208139
                            ],
                            [
                                114.697648,
                                33.197081
                            ],
                            [
                                114.681354,
                                33.170487
                            ],
                            [
                                114.704003,
                                33.160531
                            ],
                            [
                                114.705764,
                                33.14821
                            ],
                            [
                                114.717592,
                                33.144036
                            ],
                            [
                                114.720863,
                                33.125626
                            ],
                            [
                                114.731621,
                                33.120746
                            ],
                            [
                                114.742757,
                                33.106709
                            ],
                            [
                                114.761756,
                                33.10535
                            ],
                            [
                                114.765845,
                                33.090858
                            ],
                            [
                                114.77069,
                                33.087184
                            ],
                            [
                                114.77157,
                                33.069517
                            ],
                            [
                                114.7951,
                                33.068561
                            ],
                            [
                                114.800447,
                                33.05819
                            ],
                            [
                                114.817937,
                                33.060456
                            ],
                            [
                                114.833917,
                                33.059449
                            ],
                            [
                                114.850022,
                                33.052753
                            ],
                            [
                                114.854552,
                                33.055421
                            ],
                            [
                                114.857446,
                                33.075306
                            ],
                            [
                                114.897206,
                                33.080591
                            ],
                            [
                                114.897269,
                                33.08658
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 411700,
                "name": "驻马店市",
                "center": [
                    114.024736,
                    32.980169
                ],
                "centroid": [
                    114.156353,
                    32.922684
                ],
                "childrenNum": 10,
                "level": "city",
                "parent": {
                    "adcode": 410000
                },
                "subFeatureIndex": 16,
                "acroutes": [
                    100000,
                    410000
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                113.814423,
                                32.600842
                            ],
                            [
                                113.820211,
                                32.601804
                            ],
                            [
                                113.820337,
                                32.619109
                            ],
                            [
                                113.826691,
                                32.622397
                            ],
                            [
                                113.843614,
                                32.622245
                            ],
                            [
                                113.850409,
                                32.617338
                            ],
                            [
                                113.86513,
                                32.623814
                            ],
                            [
                                113.87268,
                                32.622751
                            ],
                            [
                                113.886646,
                                32.607016
                            ],
                            [
                                113.893315,
                                32.604891
                            ],
                            [
                                113.911811,
                                32.607775
                            ],
                            [
                                113.919738,
                                32.605295
                            ],
                            [
                                113.92238,
                                32.59396
                            ],
                            [
                                113.932824,
                                32.578219
                            ],
                            [
                                113.940373,
                                32.576195
                            ],
                            [
                                113.938046,
                                32.555996
                            ],
                            [
                                113.953837,
                                32.526575
                            ],
                            [
                                113.95434,
                                32.514268
                            ],
                            [
                                113.962204,
                                32.505403
                            ],
                            [
                                113.982147,
                                32.503579
                            ],
                            [
                                114.007375,
                                32.507784
                            ],
                            [
                                114.014861,
                                32.51599
                            ],
                            [
                                114.053867,
                                32.523233
                            ],
                            [
                                114.056258,
                                32.539033
                            ],
                            [
                                114.067204,
                                32.534881
                            ],
                            [
                                114.066638,
                                32.527031
                            ],
                            [
                                114.072992,
                                32.517205
                            ],
                            [
                                114.071357,
                                32.505909
                            ],
                            [
                                114.07639,
                                32.493548
                            ],
                            [
                                114.087336,
                                32.481236
                            ],
                            [
                                114.078529,
                                32.479614
                            ],
                            [
                                114.080731,
                                32.454832
                            ],
                            [
                                114.085512,
                                32.450777
                            ],
                            [
                                114.097654,
                                32.451639
                            ],
                            [
                                114.112564,
                                32.447786
                            ],
                            [
                                114.136723,
                                32.461978
                            ],
                            [
                                114.157421,
                                32.458279
                            ],
                            [
                                114.16497,
                                32.461877
                            ],
                            [
                                114.163397,
                                32.469986
                            ],
                            [
                                114.167675,
                                32.487012
                            ],
                            [
                                114.192274,
                                32.492585
                            ],
                            [
                                114.197433,
                                32.486353
                            ],
                            [
                                114.198314,
                                32.46877
                            ],
                            [
                                114.209135,
                                32.468719
                            ],
                            [
                                114.210078,
                                32.45838
                            ],
                            [
                                114.201522,
                                32.453514
                            ],
                            [
                                114.204479,
                                32.445252
                            ],
                            [
                                114.221214,
                                32.445961
                            ],
                            [
                                114.226876,
                                32.454122
                            ],
                            [
                                114.243485,
                                32.458583
                            ],
                            [
                                114.249084,
                                32.450625
                            ],
                            [
                                114.247511,
                                32.436583
                            ],
                            [
                                114.254117,
                                32.424516
                            ],
                            [
                                114.269027,
                                32.409253
                            ],
                            [
                                114.277961,
                                32.418888
                            ],
                            [
                                114.288467,
                                32.418939
                            ],
                            [
                                114.28098,
                                32.407428
                            ],
                            [
                                114.286894,
                                32.369892
                            ],
                            [
                                114.293877,
                                32.36492
                            ],
                            [
                                114.315142,
                                32.37324
                            ],
                            [
                                114.34276,
                                32.365021
                            ],
                            [
                                114.348422,
                                32.347566
                            ],
                            [
                                114.349303,
                                32.323002
                            ],
                            [
                                114.368177,
                                32.313407
                            ],
                            [
                                114.369813,
                                32.298735
                            ],
                            [
                                114.376607,
                                32.292032
                            ],
                            [
                                114.397054,
                                32.293353
                            ],
                            [
                                114.421589,
                                32.279134
                            ],
                            [
                                114.429328,
                                32.289341
                            ],
                            [
                                114.438324,
                                32.288478
                            ],
                            [
                                114.452479,
                                32.281368
                            ],
                            [
                                114.468333,
                                32.294165
                            ],
                            [
                                114.483621,
                                32.285177
                            ],
                            [
                                114.490856,
                                32.28665
                            ],
                            [
                                114.492177,
                                32.299953
                            ],
                            [
                                114.498342,
                                32.301527
                            ],
                            [
                                114.521934,
                                32.298684
                            ],
                            [
                                114.535083,
                                32.286091
                            ],
                            [
                                114.550685,
                                32.289036
                            ],
                            [
                                114.563645,
                                32.306401
                            ],
                            [
                                114.582519,
                                32.308432
                            ],
                            [
                                114.575976,
                                32.316402
                            ],
                            [
                                114.5929,
                                32.321326
                            ],
                            [
                                114.607998,
                                32.33701
                            ],
                            [
                                114.610767,
                                32.350002
                            ],
                            [
                                114.623349,
                                32.352539
                            ],
                            [
                                114.620141,
                                32.363398
                            ],
                            [
                                114.623727,
                                32.370602
                            ],
                            [
                                114.644551,
                                32.375879
                            ],
                            [
                                114.647759,
                                32.387597
                            ],
                            [
                                114.634673,
                                32.39982
                            ],
                            [
                                114.603595,
                                32.41833
                            ],
                            [
                                114.576542,
                                32.425733
                            ],
                            [
                                114.570125,
                                32.435721
                            ],
                            [
                                114.582142,
                                32.445657
                            ],
                            [
                                114.585665,
                                32.455136
                            ],
                            [
                                114.571509,
                                32.466793
                            ],
                            [
                                114.574781,
                                32.486353
                            ],
                            [
                                114.569559,
                                32.495119
                            ],
                            [
                                114.571258,
                                32.508088
                            ],
                            [
                                114.582393,
                                32.51371
                            ],
                            [
                                114.606866,
                                32.512697
                            ],
                            [
                                114.615737,
                                32.509911
                            ],
                            [
                                114.650338,
                                32.527842
                            ],
                            [
                                114.666067,
                                32.527183
                            ],
                            [
                                114.676699,
                                32.514977
                            ],
                            [
                                114.701927,
                                32.517357
                            ],
                            [
                                114.702115,
                                32.535134
                            ],
                            [
                                114.713062,
                                32.543743
                            ],
                            [
                                114.724512,
                                32.541464
                            ],
                            [
                                114.729545,
                                32.519333
                            ],
                            [
                                114.736088,
                                32.516901
                            ],
                            [
                                114.752319,
                                32.523942
                            ],
                            [
                                114.774024,
                                32.508696
                            ],
                            [
                                114.789689,
                                32.50824
                            ],
                            [
                                114.793527,
                                32.521764
                            ],
                            [
                                114.786858,
                                32.52384
                            ],
                            [
                                114.781133,
                                32.535539
                            ],
                            [
                                114.785789,
                                32.545616
                            ],
                            [
                                114.808877,
                                32.558882
                            ],
                            [
                                114.810136,
                                32.569007
                            ],
                            [
                                114.802649,
                                32.583433
                            ],
                            [
                                114.791325,
                                32.584141
                            ],
                            [
                                114.788997,
                                32.607168
                            ],
                            [
                                114.79403,
                                32.613695
                            ],
                            [
                                114.806172,
                                32.609495
                            ],
                            [
                                114.813785,
                                32.611165
                            ],
                            [
                                114.822404,
                                32.622853
                            ],
                            [
                                114.856565,
                                32.61926
                            ],
                            [
                                114.862856,
                                32.624117
                            ],
                            [
                                114.884875,
                                32.616225
                            ],
                            [
                                114.89167,
                                32.61749
                            ],
                            [
                                114.901799,
                                32.634741
                            ],
                            [
                                114.901296,
                                32.648954
                            ],
                            [
                                114.911047,
                                32.653405
                            ],
                            [
                                114.919351,
                                32.648903
                            ],
                            [
                                114.93357,
                                32.649308
                            ],
                            [
                                114.957791,
                                32.659979
                            ],
                            [
                                114.985472,
                                32.659322
                            ],
                            [
                                115.030077,
                                32.6486
                            ],
                            [
                                115.05002,
                                32.640153
                            ],
                            [
                                115.065182,
                                32.629075
                            ],
                            [
                                115.090599,
                                32.637017
                            ],
                            [
                                115.098022,
                                32.63378
                            ],
                            [
                                115.099532,
                                32.619868
                            ],
                            [
                                115.111548,
                                32.607421
                            ],
                            [
                                115.12476,
                                32.607573
                            ],
                            [
                                115.140362,
                                32.599223
                            ],
                            [
                                115.137028,
                                32.587026
                            ],
                            [
                                115.145647,
                                32.580143
                            ],
                            [
                                115.152127,
                                32.590012
                            ],
                            [
                                115.175341,
                                32.605346
                            ],
                            [
                                115.192013,
                                32.603018
                            ],
                            [
                                115.204029,
                                32.606662
                            ],
                            [
                                115.209125,
                                32.612936
                            ],
                            [
                                115.199437,
                                32.619665
                            ],
                            [
                                115.202079,
                                32.632464
                            ],
                            [
                                115.19453,
                                32.63125
                            ],
                            [
                                115.194907,
                                32.642379
                            ],
                            [
                                115.202708,
                                32.645515
                            ],
                            [
                                115.209503,
                                32.636714
                            ],
                            [
                                115.208874,
                                32.649864
                            ],
                            [
                                115.219443,
                                32.659221
                            ],
                            [
                                115.203967,
                                32.65391
                            ],
                            [
                                115.205162,
                                32.672924
                            ],
                            [
                                115.193649,
                                32.682885
                            ],
                            [
                                115.189434,
                                32.678789
                            ],
                            [
                                115.19692,
                                32.672722
                            ],
                            [
                                115.182954,
                                32.666755
                            ],
                            [
                                115.18459,
                                32.678284
                            ],
                            [
                                115.178487,
                                32.682885
                            ],
                            [
                                115.182702,
                                32.694512
                            ],
                            [
                                115.179116,
                                32.701943
                            ],
                            [
                                115.184338,
                                32.720391
                            ],
                            [
                                115.179368,
                                32.726354
                            ],
                            [
                                115.189623,
                                32.770913
                            ],
                            [
                                115.183583,
                                32.776923
                            ],
                            [
                                115.182073,
                                32.787326
                            ],
                            [
                                115.19107,
                                32.790053
                            ],
                            [
                                115.206923,
                                32.785306
                            ],
                            [
                                115.212334,
                                32.787175
                            ],
                            [
                                115.206357,
                                32.797678
                            ],
                            [
                                115.19692,
                                32.802121
                            ],
                            [
                                115.189937,
                                32.812522
                            ],
                            [
                                115.195599,
                                32.828877
                            ],
                            [
                                115.188868,
                                32.840435
                            ],
                            [
                                115.202645,
                                32.843514
                            ],
                            [
                                115.198619,
                                32.854363
                            ],
                            [
                                115.191132,
                                32.857492
                            ],
                            [
                                115.176222,
                                32.856281
                            ],
                            [
                                115.159802,
                                32.862285
                            ],
                            [
                                115.154958,
                                32.877269
                            ],
                            [
                                115.142501,
                                32.884332
                            ],
                            [
                                115.140551,
                                32.897496
                            ],
                            [
                                115.116141,
                                32.90022
                            ],
                            [
                                115.102426,
                                32.894268
                            ],
                            [
                                115.086258,
                                32.903246
                            ],
                            [
                                115.067321,
                                32.903246
                            ],
                            [
                                115.029762,
                                32.906827
                            ],
                            [
                                115.027435,
                                32.91434
                            ],
                            [
                                115.036746,
                                32.916307
                            ],
                            [
                                115.035425,
                                32.932341
                            ],
                            [
                                115.023975,
                                32.933702
                            ],
                            [
                                115.009253,
                                32.940155
                            ],
                            [
                                114.978803,
                                32.941314
                            ],
                            [
                                114.959993,
                                32.9395
                            ],
                            [
                                114.943573,
                                32.935013
                            ],
                            [
                                114.936023,
                                32.952152
                            ],
                            [
                                114.924133,
                                32.958956
                            ],
                            [
                                114.91608,
                                32.971304
                            ],
                            [
                                114.893809,
                                32.972664
                            ],
                            [
                                114.886071,
                                32.978611
                            ],
                            [
                                114.882799,
                                32.990351
                            ],
                            [
                                114.901547,
                                33.000326
                            ],
                            [
                                114.891922,
                                33.020525
                            ],
                            [
                                114.915388,
                                33.016093
                            ],
                            [
                                114.924321,
                                33.016697
                            ],
                            [
                                114.936967,
                                33.025511
                            ],
                            [
                                114.923,
                                33.036087
                            ],
                            [
                                114.922497,
                                33.048322
                            ],
                            [
                                114.91501,
                                33.059801
                            ],
                            [
                                114.91954,
                                33.068812
                            ],
                            [
                                114.914004,
                                33.082805
                            ],
                            [
                                114.897269,
                                33.08658
                            ],
                            [
                                114.897206,
                                33.080591
                            ],
                            [
                                114.857446,
                                33.075306
                            ],
                            [
                                114.854552,
                                33.055421
                            ],
                            [
                                114.850022,
                                33.052753
                            ],
                            [
                                114.833917,
                                33.059449
                            ],
                            [
                                114.817937,
                                33.060456
                            ],
                            [
                                114.800447,
                                33.05819
                            ],
                            [
                                114.7951,
                                33.068561
                            ],
                            [
                                114.77157,
                                33.069517
                            ],
                            [
                                114.77069,
                                33.087184
                            ],
                            [
                                114.765845,
                                33.090858
                            ],
                            [
                                114.761756,
                                33.10535
                            ],
                            [
                                114.742757,
                                33.106709
                            ],
                            [
                                114.731621,
                                33.120746
                            ],
                            [
                                114.720863,
                                33.125626
                            ],
                            [
                                114.717592,
                                33.144036
                            ],
                            [
                                114.705764,
                                33.14821
                            ],
                            [
                                114.704003,
                                33.160531
                            ],
                            [
                                114.681354,
                                33.170487
                            ],
                            [
                                114.697648,
                                33.197081
                            ],
                            [
                                114.69897,
                                33.208139
                            ],
                            [
                                114.717529,
                                33.221808
                            ],
                            [
                                114.73074,
                                33.261597
                            ],
                            [
                                114.728853,
                                33.289368
                            ],
                            [
                                114.722373,
                                33.301117
                            ],
                            [
                                114.705764,
                                33.302171
                            ],
                            [
                                114.685255,
                                33.298205
                            ],
                            [
                                114.684122,
                                33.314671
                            ],
                            [
                                114.665563,
                                33.313416
                            ],
                            [
                                114.669715,
                                33.31944
                            ],
                            [
                                114.662481,
                                33.322954
                            ],
                            [
                                114.654491,
                                33.341924
                            ],
                            [
                                114.645557,
                                33.34624
                            ],
                            [
                                114.623664,
                                33.341723
                            ],
                            [
                                114.615925,
                                33.344383
                            ],
                            [
                                114.605293,
                                33.35778
                            ],
                            [
                                114.589314,
                                33.362847
                            ],
                            [
                                114.585728,
                                33.374837
                            ],
                            [
                                114.575536,
                                33.376392
                            ],
                            [
                                114.577423,
                                33.390035
                            ],
                            [
                                114.572013,
                                33.396053
                            ],
                            [
                                114.57239,
                                33.406835
                            ],
                            [
                                114.563016,
                                33.42333
                            ],
                            [
                                114.554146,
                                33.42714
                            ],
                            [
                                114.537663,
                                33.426589
                            ],
                            [
                                114.52313,
                                33.418969
                            ],
                            [
                                114.488654,
                                33.417565
                            ],
                            [
                                114.490415,
                                33.43481
                            ],
                            [
                                114.480098,
                                33.443131
                            ],
                            [
                                114.464118,
                                33.437467
                            ],
                            [
                                114.459777,
                                33.454458
                            ],
                            [
                                114.446628,
                                33.464581
                            ],
                            [
                                114.407937,
                                33.460873
                            ],
                            [
                                114.402967,
                                33.457064
                            ],
                            [
                                114.382143,
                                33.454508
                            ],
                            [
                                114.368932,
                                33.44659
                            ],
                            [
                                114.362137,
                                33.454057
                            ],
                            [
                                114.349429,
                                33.452604
                            ],
                            [
                                114.347227,
                                33.462376
                            ],
                            [
                                114.307907,
                                33.481316
                            ],
                            [
                                114.284629,
                                33.472548
                            ],
                            [
                                114.266636,
                                33.461625
                            ],
                            [
                                114.247574,
                                33.45967
                            ],
                            [
                                114.230714,
                                33.451551
                            ],
                            [
                                114.211399,
                                33.453757
                            ],
                            [
                                114.195294,
                                33.447692
                            ],
                            [
                                114.190575,
                                33.426489
                            ],
                            [
                                114.171324,
                                33.440926
                            ],
                            [
                                114.180384,
                                33.453656
                            ],
                            [
                                114.171639,
                                33.459019
                            ],
                            [
                                114.159937,
                                33.456713
                            ],
                            [
                                114.150312,
                                33.460372
                            ],
                            [
                                114.151507,
                                33.468139
                            ],
                            [
                                114.131501,
                                33.472298
                            ],
                            [
                                114.130683,
                                33.495093
                            ],
                            [
                                114.115836,
                                33.488631
                            ],
                            [
                                114.103505,
                                33.491586
                            ],
                            [
                                114.104071,
                                33.499351
                            ],
                            [
                                114.118101,
                                33.502406
                            ],
                            [
                                114.116276,
                                33.51027
                            ],
                            [
                                114.099101,
                                33.503108
                            ],
                            [
                                114.075572,
                                33.517782
                            ],
                            [
                                114.055692,
                                33.523942
                            ],
                            [
                                114.052168,
                                33.528999
                            ],
                            [
                                114.038579,
                                33.5296
                            ],
                            [
                                114.033735,
                                33.523892
                            ],
                            [
                                114.014924,
                                33.522039
                            ],
                            [
                                114.01354,
                                33.511071
                            ],
                            [
                                114.001084,
                                33.510671
                            ],
                            [
                                113.998693,
                                33.500904
                            ],
                            [
                                113.981329,
                                33.482268
                            ],
                            [
                                113.9712,
                                33.482619
                            ],
                            [
                                113.967929,
                                33.477408
                            ],
                            [
                                113.95434,
                                33.473901
                            ],
                            [
                                113.94528,
                                33.465633
                            ],
                            [
                                113.933768,
                                33.465884
                            ],
                            [
                                113.914139,
                                33.478511
                            ],
                            [
                                113.865508,
                                33.479362
                            ],
                            [
                                113.856134,
                                33.47796
                            ],
                            [
                                113.847515,
                                33.466836
                            ],
                            [
                                113.825999,
                                33.460723
                            ],
                            [
                                113.805804,
                                33.446189
                            ],
                            [
                                113.799513,
                                33.43481
                            ],
                            [
                                113.771139,
                                33.435713
                            ],
                            [
                                113.766861,
                                33.432154
                            ],
                            [
                                113.721187,
                                33.432705
                            ],
                            [
                                113.713197,
                                33.430249
                            ],
                            [
                                113.710429,
                                33.417013
                            ],
                            [
                                113.693065,
                                33.418216
                            ],
                            [
                                113.688347,
                                33.407737
                            ],
                            [
                                113.676897,
                                33.378298
                            ],
                            [
                                113.655003,
                                33.371175
                            ],
                            [
                                113.639149,
                                33.355221
                            ],
                            [
                                113.642106,
                                33.34905
                            ],
                            [
                                113.640282,
                                33.325162
                            ],
                            [
                                113.627448,
                                33.312212
                            ],
                            [
                                113.618766,
                                33.291477
                            ],
                            [
                                113.613167,
                                33.261798
                            ],
                            [
                                113.606875,
                                33.237786
                            ],
                            [
                                113.613796,
                                33.211506
                            ],
                            [
                                113.627511,
                                33.186475
                            ],
                            [
                                113.644623,
                                33.186575
                            ],
                            [
                                113.64846,
                                33.182402
                            ],
                            [
                                113.63506,
                                33.160833
                            ],
                            [
                                113.626001,
                                33.150423
                            ],
                            [
                                113.617004,
                                33.147255
                            ],
                            [
                                113.600144,
                                33.163146
                            ],
                            [
                                113.593601,
                                33.157715
                            ],
                            [
                                113.573846,
                                33.15691
                            ],
                            [
                                113.561201,
                                33.161134
                            ],
                            [
                                113.550254,
                                33.140113
                            ],
                            [
                                113.541321,
                                33.14308
                            ],
                            [
                                113.532324,
                                33.152736
                            ],
                            [
                                113.521378,
                                33.154698
                            ],
                            [
                                113.514772,
                                33.162492
                            ],
                            [
                                113.499987,
                                33.156206
                            ],
                            [
                                113.46029,
                                33.156458
                            ],
                            [
                                113.449217,
                                33.160581
                            ],
                            [
                                113.432545,
                                33.15681
                            ],
                            [
                                113.413105,
                                33.156659
                            ],
                            [
                                113.397881,
                                33.14997
                            ],
                            [
                                113.388821,
                                33.128393
                            ],
                            [
                                113.386619,
                                33.113451
                            ],
                            [
                                113.357239,
                                33.091613
                            ],
                            [
                                113.333836,
                                33.085976
                            ],
                            [
                                113.325469,
                                33.079181
                            ],
                            [
                                113.313138,
                                33.075608
                            ],
                            [
                                113.301436,
                                33.080138
                            ],
                            [
                                113.271427,
                                33.08049
                            ],
                            [
                                113.257335,
                                33.083409
                            ],
                            [
                                113.250477,
                                33.077822
                            ],
                            [
                                113.237077,
                                33.077017
                            ],
                            [
                                113.219273,
                                33.064584
                            ],
                            [
                                113.206124,
                                33.070826
                            ],
                            [
                                113.190019,
                                33.067202
                            ],
                            [
                                113.18574,
                                33.056932
                            ],
                            [
                                113.165546,
                                33.048977
                            ],
                            [
                                113.161456,
                                33.038906
                            ],
                            [
                                113.142016,
                                33.016647
                            ],
                            [
                                113.127358,
                                33.010552
                            ],
                            [
                                113.120312,
                                33.001182
                            ],
                            [
                                113.116097,
                                32.986421
                            ],
                            [
                                113.108799,
                                32.97332
                            ],
                            [
                                113.097789,
                                32.946406
                            ],
                            [
                                113.109805,
                                32.94202
                            ],
                            [
                                113.11553,
                                32.932996
                            ],
                            [
                                113.140129,
                                32.930627
                            ],
                            [
                                113.145854,
                                32.940306
                            ],
                            [
                                113.15592,
                                32.936122
                            ],
                            [
                                113.161897,
                                32.92745
                            ],
                            [
                                113.181714,
                                32.920644
                            ],
                            [
                                113.199015,
                                32.920291
                            ],
                            [
                                113.208137,
                                32.916408
                            ],
                            [
                                113.201154,
                                32.888821
                            ],
                            [
                                113.205558,
                                32.884937
                            ],
                            [
                                113.195681,
                                32.871871
                            ],
                            [
                                113.187062,
                                32.866422
                            ],
                            [
                                113.177059,
                                32.852446
                            ],
                            [
                                113.167999,
                                32.847046
                            ],
                            [
                                113.165797,
                                32.838063
                            ],
                            [
                                113.175737,
                                32.83241
                            ],
                            [
                                113.187062,
                                32.819943
                            ],
                            [
                                113.17838,
                                32.806665
                            ],
                            [
                                113.184294,
                                32.801364
                            ],
                            [
                                113.185237,
                                32.788286
                            ],
                            [
                                113.177247,
                                32.775307
                            ],
                            [
                                113.199959,
                                32.750253
                            ],
                            [
                                113.201343,
                                32.738835
                            ],
                            [
                                113.193982,
                                32.733378
                            ],
                            [
                                113.191528,
                                32.717712
                            ],
                            [
                                113.207697,
                                32.717257
                            ],
                            [
                                113.213736,
                                32.703055
                            ],
                            [
                                113.231226,
                                32.701488
                            ],
                            [
                                113.241103,
                                32.691429
                            ],
                            [
                                113.236259,
                                32.682581
                            ],
                            [
                                113.259914,
                                32.677778
                            ],
                            [
                                113.269351,
                                32.662053
                            ],
                            [
                                113.258467,
                                32.653961
                            ],
                            [
                                113.252679,
                                32.666907
                            ],
                            [
                                113.243305,
                                32.66984
                            ],
                            [
                                113.236196,
                                32.679143
                            ],
                            [
                                113.220594,
                                32.684452
                            ],
                            [
                                113.210276,
                                32.678941
                            ],
                            [
                                113.20172,
                                32.660333
                            ],
                            [
                                113.18788,
                                32.652241
                            ],
                            [
                                113.186181,
                                32.646476
                            ],
                            [
                                113.19222,
                                32.635398
                            ],
                            [
                                113.20279,
                                32.632262
                            ],
                            [
                                113.201783,
                                32.614504
                            ],
                            [
                                113.196121,
                                32.606156
                            ],
                            [
                                113.200651,
                                32.585103
                            ],
                            [
                                113.198575,
                                32.579536
                            ],
                            [
                                113.205432,
                                32.569969
                            ],
                            [
                                113.221286,
                                32.570424
                            ],
                            [
                                113.243871,
                                32.578827
                            ],
                            [
                                113.249785,
                                32.593555
                            ],
                            [
                                113.280486,
                                32.595984
                            ],
                            [
                                113.282311,
                                32.591986
                            ],
                            [
                                113.303135,
                                32.586723
                            ],
                            [
                                113.31037,
                                32.579536
                            ],
                            [
                                113.315717,
                                32.587988
                            ],
                            [
                                113.321631,
                                32.58733
                            ],
                            [
                                113.326349,
                                32.577561
                            ],
                            [
                                113.342832,
                                32.567893
                            ],
                            [
                                113.351577,
                                32.573664
                            ],
                            [
                                113.364537,
                                32.569462
                            ],
                            [
                                113.372024,
                                32.576245
                            ],
                            [
                                113.382216,
                                32.593353
                            ],
                            [
                                113.400712,
                                32.61324
                            ],
                            [
                                113.422354,
                                32.605245
                            ],
                            [
                                113.437893,
                                32.589203
                            ],
                            [
                                113.447393,
                                32.584698
                            ],
                            [
                                113.458528,
                                32.585508
                            ],
                            [
                                113.458843,
                                32.575689
                            ],
                            [
                                113.472621,
                                32.578574
                            ],
                            [
                                113.492752,
                                32.567741
                            ],
                            [
                                113.512759,
                                32.571538
                            ],
                            [
                                113.513513,
                                32.579384
                            ],
                            [
                                113.524397,
                                32.593505
                            ],
                            [
                                113.542264,
                                32.589152
                            ],
                            [
                                113.565416,
                                32.602715
                            ],
                            [
                                113.571582,
                                32.624775
                            ],
                            [
                                113.583535,
                                32.633577
                            ],
                            [
                                113.588882,
                                32.650421
                            ],
                            [
                                113.596243,
                                32.649763
                            ],
                            [
                                113.594041,
                                32.661092
                            ],
                            [
                                113.619332,
                                32.667362
                            ],
                            [
                                113.616941,
                                32.69158
                            ],
                            [
                                113.609832,
                                32.696484
                            ],
                            [
                                113.614676,
                                32.711344
                            ],
                            [
                                113.623358,
                                32.706138
                            ],
                            [
                                113.642987,
                                32.703106
                            ],
                            [
                                113.649089,
                                32.708261
                            ],
                            [
                                113.668404,
                                32.692389
                            ],
                            [
                                113.696274,
                                32.695624
                            ],
                            [
                                113.717727,
                                32.683694
                            ],
                            [
                                113.729114,
                                32.669688
                            ],
                            [
                                113.761199,
                                32.652697
                            ],
                            [
                                113.771894,
                                32.655276
                            ],
                            [
                                113.781079,
                                32.652595
                            ],
                            [
                                113.791963,
                                32.642075
                            ],
                            [
                                113.785169,
                                32.631402
                            ],
                            [
                                113.799072,
                                32.620879
                            ],
                            [
                                113.809264,
                                32.603828
                            ],
                            [
                                113.814423,
                                32.600842
                            ]
                        ]
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "adcode": 419001,
                "name": "济源市",
                "center": [
                    112.590047,
                    35.090378
                ],
                "centroid": [
                    112.398673,
                    35.099131
                ],
                "childrenNum": 0,
                "level": "city",
                "parent": {
                    "adcode": 410000
                },
                "subFeatureIndex": 17,
                "acroutes": [
                    100000,
                    410000
                ]
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [
                    [
                        [
                            [
                                112.758,
                                35.204436
                            ],
                            [
                                112.744662,
                                35.205123
                            ],
                            [
                                112.735351,
                                35.210424
                            ],
                            [
                                112.720315,
                                35.206448
                            ],
                            [
                                112.71264,
                                35.18701
                            ],
                            [
                                112.703077,
                                35.20154
                            ],
                            [
                                112.707418,
                                35.216951
                            ],
                            [
                                112.695339,
                                35.218718
                            ],
                            [
                                112.684267,
                                35.227256
                            ],
                            [
                                112.682694,
                                35.233733
                            ],
                            [
                                112.67288,
                                35.234272
                            ],
                            [
                                112.655012,
                                35.244232
                            ],
                            [
                                112.651426,
                                35.259242
                            ],
                            [
                                112.645009,
                                35.260566
                            ],
                            [
                                112.639159,
                                35.247862
                            ],
                            [
                                112.633056,
                                35.265569
                            ],
                            [
                                112.618335,
                                35.254043
                            ],
                            [
                                112.617643,
                                35.244575
                            ],
                            [
                                112.634188,
                                35.239326
                            ],
                            [
                                112.637208,
                                35.225686
                            ],
                            [
                                112.619027,
                                35.220043
                            ],
                            [
                                112.602544,
                                35.22284
                            ],
                            [
                                112.574988,
                                35.221122
                            ],
                            [
                                112.567879,
                                35.211749
                            ],
                            [
                                112.559071,
                                35.21278
                            ],
                            [
                                112.536234,
                                35.223429
                            ],
                            [
                                112.513523,
                                35.21857
                            ],
                            [
                                112.489805,
                                35.229955
                            ],
                            [
                                112.482444,
                                35.224655
                            ],
                            [
                                112.472378,
                                35.230298
                            ],
                            [
                                112.45772,
                                35.226373
                            ],
                            [
                                112.423999,
                                35.23805
                            ],
                            [
                                112.401413,
                                35.241877
                            ],
                            [
                                112.390718,
                                35.238786
                            ],
                            [
                                112.376751,
                                35.224115
                            ],
                            [
                                112.367315,
                                35.22019
                            ],
                            [
                                112.320697,
                                35.21911
                            ],
                            [
                                112.306667,
                                35.220975
                            ],
                            [
                                112.288548,
                                35.21754
                            ],
                            [
                                112.304465,
                                35.251884
                            ],
                            [
                                112.294462,
                                35.252816
                            ],
                            [
                                112.282823,
                                35.242024
                            ],
                            [
                                112.261307,
                                35.24119
                            ],
                            [
                                112.242748,
                                35.234812
                            ],
                            [
                                112.21664,
                                35.240209
                            ],
                            [
                                112.220792,
                                35.247028
                            ],
                            [
                                112.217269,
                                35.253258
                            ],
                            [
                                112.191097,
                                35.256348
                            ],
                            [
                                112.173545,
                                35.263803
                            ],
                            [
                                112.134287,
                                35.271258
                            ],
                            [
                                112.120006,
                                35.265275
                            ],
                            [
                                112.110947,
                                35.27013
                            ],
                            [
                                112.115665,
                                35.273072
                            ],
                            [
                                112.093961,
                                35.279202
                            ],
                            [
                                112.075842,
                                35.277143
                            ],
                            [
                                112.058793,
                                35.279889
                            ],
                            [
                                112.055018,
                                35.271454
                            ],
                            [
                                112.067978,
                                35.265275
                            ],
                            [
                                112.079617,
                                35.242367
                            ],
                            [
                                112.08119,
                                35.221613
                            ],
                            [
                                112.058919,
                                35.206301
                            ],
                            [
                                112.042058,
                                35.200264
                            ],
                            [
                                112.041492,
                                35.189808
                            ],
                            [
                                112.051935,
                                35.177044
                            ],
                            [
                                112.066279,
                                35.153522
                            ],
                            [
                                112.060177,
                                35.140752
                            ],
                            [
                                112.067223,
                                35.136233
                            ],
                            [
                                112.056276,
                                35.098449
                            ],
                            [
                                112.056591,
                                35.089061
                            ],
                            [
                                112.062756,
                                35.078591
                            ],
                            [
                                112.062127,
                                35.055779
                            ],
                            [
                                112.053571,
                                35.044223
                            ],
                            [
                                112.038912,
                                35.045501
                            ],
                            [
                                112.035075,
                                35.033845
                            ],
                            [
                                112.042436,
                                35.027845
                            ],
                            [
                                112.09352,
                                35.029911
                            ],
                            [
                                112.108242,
                                35.029222
                            ],
                            [
                                112.125857,
                                35.021204
                            ],
                            [
                                112.1514,
                                35.015399
                            ],
                            [
                                112.169896,
                                35.00241
                            ],
                            [
                                112.1877,
                                34.972981
                            ],
                            [
                                112.212047,
                                34.965007
                            ],
                            [
                                112.226831,
                                34.956589
                            ],
                            [
                                112.247844,
                                34.940735
                            ],
                            [
                                112.258099,
                                34.942212
                            ],
                            [
                                112.267284,
                                34.953537
                            ],
                            [
                                112.28188,
                                34.960232
                            ],
                            [
                                112.301068,
                                34.945462
                            ],
                            [
                                112.3212,
                                34.941375
                            ],
                            [
                                112.334537,
                                34.941425
                            ],
                            [
                                112.360268,
                                34.931428
                            ],
                            [
                                112.384993,
                                34.924533
                            ],
                            [
                                112.39097,
                                34.918574
                            ],
                            [
                                112.433247,
                                34.920987
                            ],
                            [
                                112.462501,
                                34.915668
                            ],
                            [
                                112.489616,
                                34.90286
                            ],
                            [
                                112.496536,
                                34.895717
                            ],
                            [
                                112.505659,
                                34.898821
                            ],
                            [
                                112.521072,
                                34.892761
                            ],
                            [
                                112.534221,
                                34.893746
                            ],
                            [
                                112.537304,
                                34.916013
                            ],
                            [
                                112.527426,
                                34.929163
                            ],
                            [
                                112.515976,
                                34.929212
                            ],
                            [
                                112.511447,
                                34.92084
                            ],
                            [
                                112.496914,
                                34.921726
                            ],
                            [
                                112.505155,
                                34.942459
                            ],
                            [
                                112.519436,
                                34.940341
                            ],
                            [
                                112.527867,
                                34.932019
                            ],
                            [
                                112.551207,
                                34.938569
                            ],
                            [
                                112.563853,
                                34.949696
                            ],
                            [
                                112.5692,
                                34.958608
                            ],
                            [
                                112.579392,
                                34.971751
                            ],
                            [
                                112.596001,
                                34.971013
                            ],
                            [
                                112.614182,
                                34.98002
                            ],
                            [
                                112.624752,
                                34.977903
                            ],
                            [
                                112.644695,
                                34.978888
                            ],
                            [
                                112.653062,
                                34.988681
                            ],
                            [
                                112.666462,
                                34.9875
                            ],
                            [
                                112.675962,
                                34.993504
                            ],
                            [
                                112.684581,
                                35.012497
                            ],
                            [
                                112.698988,
                                35.023221
                            ],
                            [
                                112.72711,
                                35.035026
                            ],
                            [
                                112.735289,
                                35.043338
                            ],
                            [
                                112.736043,
                                35.060008
                            ],
                            [
                                112.743341,
                                35.06458
                            ],
                            [
                                112.753219,
                                35.08508
                            ],
                            [
                                112.754288,
                                35.098891
                            ],
                            [
                                112.766304,
                                35.107196
                            ],
                            [
                                112.761963,
                                35.158041
                            ],
                            [
                                112.76687,
                                35.182985
                            ],
                            [
                                112.758,
                                35.204436
                            ]
                        ]
                    ]
                ]
            }
        }
    ]
}